[
  {
    "id": "living_01_default_theme_1_wallpaper_b_tier_2",
    "item_id": "living_01_default_theme_1_wallpaper_b",
    "tier": 2,
    "can_fuse": false,
    "can_sell": false,
    "image": "01_living_room/01_default_theme/02_color_B/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_01_default_theme_1_wallpaper_c_tier_2",
    "item_id": "living_01_default_theme_1_wallpaper_c",
    "tier": 2,
    "can_fuse": false,
    "can_sell": false,
    "image": "01_living_room/01_default_theme/03_color_C/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_01_default_theme_2_floor_b_tier_2",
    "item_id": "living_01_default_theme_2_floor_b",
    "tier": 2,
    "can_fuse": false,
    "can_sell": false,
    "image": "01_living_room/01_default_theme/02_color_B/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_01_default_theme_2_floor_c_tier_2",
    "item_id": "living_01_default_theme_2_floor_c",
    "tier": 2,
    "can_fuse": false,
    "can_sell": false,
    "image": "01_living_room/01_default_theme/03_color_C/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_01_default_theme_3_above_fireplace_b_tier_2",
    "item_id": "living_01_default_theme_3_above_fireplace_b",
    "tier": 2,
    "can_fuse": false,
    "can_sell": false,
    "image": "01_living_room/01_default_theme/02_color_B/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_01_default_theme_3_above_fireplace_c_tier_2",
    "item_id": "living_01_default_theme_3_above_fireplace_c",
    "tier": 2,
    "can_fuse": false,
    "can_sell": false,
    "image": "01_living_room/01_default_theme/03_color_C/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_01_default_theme_3_empty_na_tier_2",
    "item_id": "living_01_default_theme_3_empty_na",
    "tier": 2,
    "can_fuse": false,
    "can_sell": false,
    "animated": false
  },
  {
    "id": "living_01_default_theme_4_empty_na_tier_2",
    "item_id": "living_01_default_theme_4_empty_na",
    "tier": 2,
    "can_fuse": false,
    "can_sell": false,
    "animated": false
  },
  {
    "id": "living_01_default_theme_4_painting_b_tier_2",
    "item_id": "living_01_default_theme_4_painting_b",
    "tier": 2,
    "can_fuse": false,
    "can_sell": false,
    "image": "01_living_room/01_default_theme/02_color_B/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_01_default_theme_4_painting_c_tier_2",
    "item_id": "living_01_default_theme_4_painting_c",
    "tier": 2,
    "can_fuse": false,
    "can_sell": false,
    "image": "01_living_room/01_default_theme/03_color_C/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_01_default_theme_5_fireplace_b_tier_2",
    "item_id": "living_01_default_theme_5_fireplace_b",
    "tier": 2,
    "can_fuse": false,
    "can_sell": false,
    "image": "01_living_room/01_default_theme/02_color_B/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_01_default_theme_5_fireplace_c_tier_2",
    "item_id": "living_01_default_theme_5_fireplace_c",
    "tier": 2,
    "can_fuse": false,
    "can_sell": false,
    "image": "01_living_room/01_default_theme/03_color_C/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_01_default_theme_6_empty_na_tier_2",
    "item_id": "living_01_default_theme_6_empty_na",
    "tier": 2,
    "can_fuse": false,
    "can_sell": false,
    "animated": false
  },
  {
    "id": "living_01_default_theme_6_tree_b_tier_2",
    "item_id": "living_01_default_theme_6_tree_b",
    "tier": 2,
    "can_fuse": false,
    "can_sell": false,
    "image": "01_living_room/01_default_theme/02_color_B/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_01_default_theme_6_tree_c_tier_2",
    "item_id": "living_01_default_theme_6_tree_c",
    "tier": 2,
    "can_fuse": false,
    "can_sell": false,
    "image": "01_living_room/01_default_theme/03_color_C/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_01_default_theme_7_couch_b_tier_2",
    "item_id": "living_01_default_theme_7_couch_b",
    "tier": 2,
    "can_fuse": false,
    "can_sell": false,
    "image": "01_living_room/01_default_theme/02_color_B/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_01_default_theme_7_couch_c_tier_2",
    "item_id": "living_01_default_theme_7_couch_c",
    "tier": 2,
    "can_fuse": false,
    "can_sell": false,
    "image": "01_living_room/01_default_theme/03_color_C/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_01_default_theme_7_empty_na_tier_2",
    "item_id": "living_01_default_theme_7_empty_na",
    "tier": 2,
    "can_fuse": false,
    "can_sell": false,
    "animated": false
  },
  {
    "id": "living_01_default_theme_8_empty_na_tier_2",
    "item_id": "living_01_default_theme_8_empty_na",
    "tier": 2,
    "can_fuse": false,
    "can_sell": false,
    "animated": false
  },
  {
    "id": "living_01_default_theme_8_sidetable_b_tier_2",
    "item_id": "living_01_default_theme_8_sidetable_b",
    "tier": 2,
    "can_fuse": false,
    "can_sell": false,
    "image": "01_living_room/01_default_theme/02_color_B/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_01_default_theme_8_sidetable_c_tier_2",
    "item_id": "living_01_default_theme_8_sidetable_c",
    "tier": 2,
    "can_fuse": false,
    "can_sell": false,
    "image": "01_living_room/01_default_theme/03_color_C/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_1_wallpaper_a_tier_1",
    "item_id": "living_02_surprise_birthday_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/02_surprise_birthday/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_1_wallpaper_a_tier_2",
    "item_id": "living_02_surprise_birthday_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/02_surprise_birthday/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_1_wallpaper_a_tier_3",
    "item_id": "living_02_surprise_birthday_1_wallpaper_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/02_surprise_birthday/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_1_wallpaper_b_tier_1",
    "item_id": "living_02_surprise_birthday_1_wallpaper_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_1_wallpaper_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/02_surprise_birthday/02_color_B/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_1_wallpaper_b_tier_2",
    "item_id": "living_02_surprise_birthday_1_wallpaper_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_1_wallpaper_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/02_surprise_birthday/02_color_B/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_1_wallpaper_b_tier_3",
    "item_id": "living_02_surprise_birthday_1_wallpaper_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/02_surprise_birthday/02_color_B/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_1_wallpaper_c_tier_1",
    "item_id": "living_02_surprise_birthday_1_wallpaper_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_1_wallpaper_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/02_surprise_birthday/03_color_C/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_1_wallpaper_c_tier_2",
    "item_id": "living_02_surprise_birthday_1_wallpaper_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_1_wallpaper_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/02_surprise_birthday/03_color_C/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_1_wallpaper_c_tier_3",
    "item_id": "living_02_surprise_birthday_1_wallpaper_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/02_surprise_birthday/03_color_C/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_2_floor_a_tier_1",
    "item_id": "living_02_surprise_birthday_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/02_surprise_birthday/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_2_floor_a_tier_2",
    "item_id": "living_02_surprise_birthday_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/02_surprise_birthday/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_2_floor_a_tier_3",
    "item_id": "living_02_surprise_birthday_2_floor_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/02_surprise_birthday/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_2_floor_b_tier_1",
    "item_id": "living_02_surprise_birthday_2_floor_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_2_floor_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/02_surprise_birthday/02_color_B/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_2_floor_b_tier_2",
    "item_id": "living_02_surprise_birthday_2_floor_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_2_floor_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/02_surprise_birthday/02_color_B/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_2_floor_b_tier_3",
    "item_id": "living_02_surprise_birthday_2_floor_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/02_surprise_birthday/02_color_B/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_2_floor_c_tier_1",
    "item_id": "living_02_surprise_birthday_2_floor_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_2_floor_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/02_surprise_birthday/03_color_C/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_2_floor_c_tier_2",
    "item_id": "living_02_surprise_birthday_2_floor_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_2_floor_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/02_surprise_birthday/03_color_C/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_2_floor_c_tier_3",
    "item_id": "living_02_surprise_birthday_2_floor_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/02_surprise_birthday/03_color_C/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_3_above_fireplace_a_tier_1",
    "item_id": "living_02_surprise_birthday_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/02_surprise_birthday/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_3_above_fireplace_a_tier_2",
    "item_id": "living_02_surprise_birthday_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/02_surprise_birthday/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_3_above_fireplace_a_tier_3",
    "item_id": "living_02_surprise_birthday_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/02_surprise_birthday/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_3_above_fireplace_b_tier_1",
    "item_id": "living_02_surprise_birthday_3_above_fireplace_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_3_above_fireplace_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/02_surprise_birthday/02_color_B/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_3_above_fireplace_b_tier_2",
    "item_id": "living_02_surprise_birthday_3_above_fireplace_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_3_above_fireplace_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/02_surprise_birthday/02_color_B/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_3_above_fireplace_b_tier_3",
    "item_id": "living_02_surprise_birthday_3_above_fireplace_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/02_surprise_birthday/02_color_B/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_3_above_fireplace_c_tier_1",
    "item_id": "living_02_surprise_birthday_3_above_fireplace_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_3_above_fireplace_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/02_surprise_birthday/03_color_C/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_3_above_fireplace_c_tier_2",
    "item_id": "living_02_surprise_birthday_3_above_fireplace_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_3_above_fireplace_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/02_surprise_birthday/03_color_C/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_3_above_fireplace_c_tier_3",
    "item_id": "living_02_surprise_birthday_3_above_fireplace_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/02_surprise_birthday/03_color_C/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_4_painting_a_tier_1",
    "item_id": "living_02_surprise_birthday_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/02_surprise_birthday/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_4_painting_a_tier_2",
    "item_id": "living_02_surprise_birthday_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/02_surprise_birthday/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_4_painting_a_tier_3",
    "item_id": "living_02_surprise_birthday_4_painting_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/02_surprise_birthday/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_4_painting_b_tier_1",
    "item_id": "living_02_surprise_birthday_4_painting_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_4_painting_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/02_surprise_birthday/02_color_B/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_4_painting_b_tier_2",
    "item_id": "living_02_surprise_birthday_4_painting_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_4_painting_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/02_surprise_birthday/02_color_B/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_4_painting_b_tier_3",
    "item_id": "living_02_surprise_birthday_4_painting_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/02_surprise_birthday/02_color_B/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_4_painting_c_tier_1",
    "item_id": "living_02_surprise_birthday_4_painting_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_4_painting_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/02_surprise_birthday/03_color_C/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_4_painting_c_tier_2",
    "item_id": "living_02_surprise_birthday_4_painting_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_4_painting_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/02_surprise_birthday/03_color_C/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_4_painting_c_tier_3",
    "item_id": "living_02_surprise_birthday_4_painting_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/02_surprise_birthday/03_color_C/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_5_fireplace_a_tier_1",
    "item_id": "living_02_surprise_birthday_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/02_surprise_birthday/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_5_fireplace_a_tier_2",
    "item_id": "living_02_surprise_birthday_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/02_surprise_birthday/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_5_fireplace_a_tier_3",
    "item_id": "living_02_surprise_birthday_5_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/02_surprise_birthday/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_5_fireplace_b_tier_1",
    "item_id": "living_02_surprise_birthday_5_fireplace_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_5_fireplace_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/02_surprise_birthday/02_color_B/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_5_fireplace_b_tier_2",
    "item_id": "living_02_surprise_birthday_5_fireplace_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_5_fireplace_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/02_surprise_birthday/02_color_B/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_5_fireplace_b_tier_3",
    "item_id": "living_02_surprise_birthday_5_fireplace_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/02_surprise_birthday/02_color_B/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_5_fireplace_c_tier_1",
    "item_id": "living_02_surprise_birthday_5_fireplace_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_5_fireplace_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/02_surprise_birthday/03_color_C/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_5_fireplace_c_tier_2",
    "item_id": "living_02_surprise_birthday_5_fireplace_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_5_fireplace_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/02_surprise_birthday/03_color_C/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_5_fireplace_c_tier_3",
    "item_id": "living_02_surprise_birthday_5_fireplace_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/02_surprise_birthday/03_color_C/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_6_tree_a_tier_1",
    "item_id": "living_02_surprise_birthday_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/02_surprise_birthday/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_6_tree_a_tier_2",
    "item_id": "living_02_surprise_birthday_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/02_surprise_birthday/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_6_tree_a_tier_3",
    "item_id": "living_02_surprise_birthday_6_tree_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/02_surprise_birthday/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_6_tree_b_tier_1",
    "item_id": "living_02_surprise_birthday_6_tree_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_6_tree_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/02_surprise_birthday/02_color_B/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_6_tree_b_tier_2",
    "item_id": "living_02_surprise_birthday_6_tree_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_6_tree_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/02_surprise_birthday/02_color_B/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_6_tree_b_tier_3",
    "item_id": "living_02_surprise_birthday_6_tree_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/02_surprise_birthday/02_color_B/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_6_tree_c_tier_1",
    "item_id": "living_02_surprise_birthday_6_tree_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_6_tree_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/02_surprise_birthday/03_color_C/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_6_tree_c_tier_2",
    "item_id": "living_02_surprise_birthday_6_tree_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_6_tree_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/02_surprise_birthday/03_color_C/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_6_tree_c_tier_3",
    "item_id": "living_02_surprise_birthday_6_tree_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/02_surprise_birthday/03_color_C/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_7_couch_a_tier_1",
    "item_id": "living_02_surprise_birthday_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/02_surprise_birthday/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_7_couch_a_tier_2",
    "item_id": "living_02_surprise_birthday_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/02_surprise_birthday/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_7_couch_a_tier_3",
    "item_id": "living_02_surprise_birthday_7_couch_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/02_surprise_birthday/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_7_couch_b_tier_1",
    "item_id": "living_02_surprise_birthday_7_couch_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_7_couch_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/02_surprise_birthday/02_color_B/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_7_couch_b_tier_2",
    "item_id": "living_02_surprise_birthday_7_couch_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_7_couch_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/02_surprise_birthday/02_color_B/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_7_couch_b_tier_3",
    "item_id": "living_02_surprise_birthday_7_couch_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/02_surprise_birthday/02_color_B/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_7_couch_c_tier_1",
    "item_id": "living_02_surprise_birthday_7_couch_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_7_couch_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/02_surprise_birthday/03_color_C/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_7_couch_c_tier_2",
    "item_id": "living_02_surprise_birthday_7_couch_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_7_couch_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/02_surprise_birthday/03_color_C/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_7_couch_c_tier_3",
    "item_id": "living_02_surprise_birthday_7_couch_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/02_surprise_birthday/03_color_C/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_8_sidetable_a_tier_1",
    "item_id": "living_02_surprise_birthday_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/02_surprise_birthday/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_8_sidetable_a_tier_2",
    "item_id": "living_02_surprise_birthday_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/02_surprise_birthday/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_8_sidetable_a_tier_3",
    "item_id": "living_02_surprise_birthday_8_sidetable_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/02_surprise_birthday/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_8_sidetable_b_tier_1",
    "item_id": "living_02_surprise_birthday_8_sidetable_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_8_sidetable_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/02_surprise_birthday/02_color_B/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_8_sidetable_b_tier_2",
    "item_id": "living_02_surprise_birthday_8_sidetable_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_8_sidetable_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/02_surprise_birthday/02_color_B/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_8_sidetable_b_tier_3",
    "item_id": "living_02_surprise_birthday_8_sidetable_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/02_surprise_birthday/02_color_B/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_8_sidetable_c_tier_1",
    "item_id": "living_02_surprise_birthday_8_sidetable_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_8_sidetable_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/02_surprise_birthday/03_color_C/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_8_sidetable_c_tier_2",
    "item_id": "living_02_surprise_birthday_8_sidetable_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_02_surprise_birthday_8_sidetable_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/02_surprise_birthday/03_color_C/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_02_surprise_birthday_8_sidetable_c_tier_3",
    "item_id": "living_02_surprise_birthday_8_sidetable_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/02_surprise_birthday/03_color_C/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_1_wallpaper_a_tier_1",
    "item_id": "living_03_starry_night_camp_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/03_starry_night_camp/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_1_wallpaper_a_tier_2",
    "item_id": "living_03_starry_night_camp_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/03_starry_night_camp/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_1_wallpaper_a_tier_3",
    "item_id": "living_03_starry_night_camp_1_wallpaper_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/03_starry_night_camp/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_1_wallpaper_b_tier_1",
    "item_id": "living_03_starry_night_camp_1_wallpaper_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_1_wallpaper_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/03_starry_night_camp/02_color_B/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_1_wallpaper_b_tier_2",
    "item_id": "living_03_starry_night_camp_1_wallpaper_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_1_wallpaper_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/03_starry_night_camp/02_color_B/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_1_wallpaper_b_tier_3",
    "item_id": "living_03_starry_night_camp_1_wallpaper_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/03_starry_night_camp/02_color_B/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_1_wallpaper_c_tier_1",
    "item_id": "living_03_starry_night_camp_1_wallpaper_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_1_wallpaper_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/03_starry_night_camp/03_color_C/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_1_wallpaper_c_tier_2",
    "item_id": "living_03_starry_night_camp_1_wallpaper_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_1_wallpaper_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/03_starry_night_camp/03_color_C/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_1_wallpaper_c_tier_3",
    "item_id": "living_03_starry_night_camp_1_wallpaper_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/03_starry_night_camp/03_color_C/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_2_floor_a_tier_1",
    "item_id": "living_03_starry_night_camp_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/03_starry_night_camp/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_2_floor_a_tier_2",
    "item_id": "living_03_starry_night_camp_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/03_starry_night_camp/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_2_floor_a_tier_3",
    "item_id": "living_03_starry_night_camp_2_floor_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/03_starry_night_camp/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_2_floor_b_tier_1",
    "item_id": "living_03_starry_night_camp_2_floor_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_2_floor_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/03_starry_night_camp/02_color_B/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_2_floor_b_tier_2",
    "item_id": "living_03_starry_night_camp_2_floor_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_2_floor_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/03_starry_night_camp/02_color_B/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_2_floor_b_tier_3",
    "item_id": "living_03_starry_night_camp_2_floor_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/03_starry_night_camp/02_color_B/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_2_floor_c_tier_1",
    "item_id": "living_03_starry_night_camp_2_floor_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_2_floor_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/03_starry_night_camp/03_color_C/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_2_floor_c_tier_2",
    "item_id": "living_03_starry_night_camp_2_floor_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_2_floor_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/03_starry_night_camp/03_color_C/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_2_floor_c_tier_3",
    "item_id": "living_03_starry_night_camp_2_floor_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/03_starry_night_camp/03_color_C/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_3_above_fireplace_a_tier_1",
    "item_id": "living_03_starry_night_camp_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/03_starry_night_camp/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_3_above_fireplace_a_tier_2",
    "item_id": "living_03_starry_night_camp_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/03_starry_night_camp/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_3_above_fireplace_a_tier_3",
    "item_id": "living_03_starry_night_camp_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/03_starry_night_camp/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_3_above_fireplace_b_tier_1",
    "item_id": "living_03_starry_night_camp_3_above_fireplace_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_3_above_fireplace_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/03_starry_night_camp/02_color_B/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_3_above_fireplace_b_tier_2",
    "item_id": "living_03_starry_night_camp_3_above_fireplace_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_3_above_fireplace_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/03_starry_night_camp/02_color_B/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_3_above_fireplace_b_tier_3",
    "item_id": "living_03_starry_night_camp_3_above_fireplace_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/03_starry_night_camp/02_color_B/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_3_above_fireplace_c_tier_1",
    "item_id": "living_03_starry_night_camp_3_above_fireplace_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_3_above_fireplace_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/03_starry_night_camp/03_color_C/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_3_above_fireplace_c_tier_2",
    "item_id": "living_03_starry_night_camp_3_above_fireplace_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_3_above_fireplace_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/03_starry_night_camp/03_color_C/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_3_above_fireplace_c_tier_3",
    "item_id": "living_03_starry_night_camp_3_above_fireplace_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/03_starry_night_camp/03_color_C/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_4_painting_a_tier_1",
    "item_id": "living_03_starry_night_camp_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/03_starry_night_camp/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_4_painting_a_tier_2",
    "item_id": "living_03_starry_night_camp_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/03_starry_night_camp/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_4_painting_a_tier_3",
    "item_id": "living_03_starry_night_camp_4_painting_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/03_starry_night_camp/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_4_painting_b_tier_1",
    "item_id": "living_03_starry_night_camp_4_painting_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_4_painting_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/03_starry_night_camp/02_color_B/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_4_painting_b_tier_2",
    "item_id": "living_03_starry_night_camp_4_painting_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_4_painting_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/03_starry_night_camp/02_color_B/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_4_painting_b_tier_3",
    "item_id": "living_03_starry_night_camp_4_painting_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/03_starry_night_camp/02_color_B/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_4_painting_c_tier_1",
    "item_id": "living_03_starry_night_camp_4_painting_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_4_painting_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/03_starry_night_camp/03_color_C/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_4_painting_c_tier_2",
    "item_id": "living_03_starry_night_camp_4_painting_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_4_painting_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/03_starry_night_camp/03_color_C/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_4_painting_c_tier_3",
    "item_id": "living_03_starry_night_camp_4_painting_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/03_starry_night_camp/03_color_C/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_5_fireplace_a_tier_1",
    "item_id": "living_03_starry_night_camp_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/03_starry_night_camp/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_5_fireplace_a_tier_2",
    "item_id": "living_03_starry_night_camp_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/03_starry_night_camp/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_5_fireplace_a_tier_3",
    "item_id": "living_03_starry_night_camp_5_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/03_starry_night_camp/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_5_fireplace_b_tier_1",
    "item_id": "living_03_starry_night_camp_5_fireplace_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_5_fireplace_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/03_starry_night_camp/02_color_B/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_5_fireplace_b_tier_2",
    "item_id": "living_03_starry_night_camp_5_fireplace_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_5_fireplace_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/03_starry_night_camp/02_color_B/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_5_fireplace_b_tier_3",
    "item_id": "living_03_starry_night_camp_5_fireplace_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/03_starry_night_camp/02_color_B/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_5_fireplace_c_tier_1",
    "item_id": "living_03_starry_night_camp_5_fireplace_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_5_fireplace_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/03_starry_night_camp/03_color_C/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_5_fireplace_c_tier_2",
    "item_id": "living_03_starry_night_camp_5_fireplace_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_5_fireplace_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/03_starry_night_camp/03_color_C/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_5_fireplace_c_tier_3",
    "item_id": "living_03_starry_night_camp_5_fireplace_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/03_starry_night_camp/03_color_C/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_6_tree_a_tier_1",
    "item_id": "living_03_starry_night_camp_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/03_starry_night_camp/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_6_tree_a_tier_2",
    "item_id": "living_03_starry_night_camp_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/03_starry_night_camp/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_6_tree_a_tier_3",
    "item_id": "living_03_starry_night_camp_6_tree_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/03_starry_night_camp/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_6_tree_b_tier_1",
    "item_id": "living_03_starry_night_camp_6_tree_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_6_tree_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/03_starry_night_camp/02_color_B/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_6_tree_b_tier_2",
    "item_id": "living_03_starry_night_camp_6_tree_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_6_tree_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/03_starry_night_camp/02_color_B/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_6_tree_b_tier_3",
    "item_id": "living_03_starry_night_camp_6_tree_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/03_starry_night_camp/02_color_B/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_6_tree_c_tier_1",
    "item_id": "living_03_starry_night_camp_6_tree_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_6_tree_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/03_starry_night_camp/03_color_C/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_6_tree_c_tier_2",
    "item_id": "living_03_starry_night_camp_6_tree_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_6_tree_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/03_starry_night_camp/03_color_C/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_6_tree_c_tier_3",
    "item_id": "living_03_starry_night_camp_6_tree_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/03_starry_night_camp/03_color_C/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_7_couch_a_tier_1",
    "item_id": "living_03_starry_night_camp_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/03_starry_night_camp/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_7_couch_a_tier_2",
    "item_id": "living_03_starry_night_camp_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/03_starry_night_camp/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_7_couch_a_tier_3",
    "item_id": "living_03_starry_night_camp_7_couch_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/03_starry_night_camp/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_7_couch_b_tier_1",
    "item_id": "living_03_starry_night_camp_7_couch_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_7_couch_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/03_starry_night_camp/02_color_B/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_7_couch_b_tier_2",
    "item_id": "living_03_starry_night_camp_7_couch_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_7_couch_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/03_starry_night_camp/02_color_B/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_7_couch_b_tier_3",
    "item_id": "living_03_starry_night_camp_7_couch_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/03_starry_night_camp/02_color_B/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_7_couch_c_tier_1",
    "item_id": "living_03_starry_night_camp_7_couch_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_7_couch_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/03_starry_night_camp/03_color_C/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_7_couch_c_tier_2",
    "item_id": "living_03_starry_night_camp_7_couch_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_7_couch_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/03_starry_night_camp/03_color_C/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_7_couch_c_tier_3",
    "item_id": "living_03_starry_night_camp_7_couch_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/03_starry_night_camp/03_color_C/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_8_sidetable_a_tier_1",
    "item_id": "living_03_starry_night_camp_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/03_starry_night_camp/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_8_sidetable_a_tier_2",
    "item_id": "living_03_starry_night_camp_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/03_starry_night_camp/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_8_sidetable_a_tier_3",
    "item_id": "living_03_starry_night_camp_8_sidetable_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/03_starry_night_camp/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_8_sidetable_b_tier_1",
    "item_id": "living_03_starry_night_camp_8_sidetable_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_8_sidetable_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/03_starry_night_camp/02_color_B/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_8_sidetable_b_tier_2",
    "item_id": "living_03_starry_night_camp_8_sidetable_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_8_sidetable_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/03_starry_night_camp/02_color_B/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_8_sidetable_b_tier_3",
    "item_id": "living_03_starry_night_camp_8_sidetable_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/03_starry_night_camp/02_color_B/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_8_sidetable_c_tier_1",
    "item_id": "living_03_starry_night_camp_8_sidetable_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_8_sidetable_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/03_starry_night_camp/03_color_C/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_8_sidetable_c_tier_2",
    "item_id": "living_03_starry_night_camp_8_sidetable_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_03_starry_night_camp_8_sidetable_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/03_starry_night_camp/03_color_C/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_03_starry_night_camp_8_sidetable_c_tier_3",
    "item_id": "living_03_starry_night_camp_8_sidetable_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/03_starry_night_camp/03_color_C/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_1_wallpaper_a_tier_1",
    "item_id": "living_04_spring_flower_humming_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/04_spring_flower_humming/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_1_wallpaper_a_tier_2",
    "item_id": "living_04_spring_flower_humming_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/04_spring_flower_humming/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_1_wallpaper_a_tier_3",
    "item_id": "living_04_spring_flower_humming_1_wallpaper_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/04_spring_flower_humming/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_1_wallpaper_b_tier_1",
    "item_id": "living_04_spring_flower_humming_1_wallpaper_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_1_wallpaper_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/04_spring_flower_humming/02_color_B/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_1_wallpaper_b_tier_2",
    "item_id": "living_04_spring_flower_humming_1_wallpaper_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_1_wallpaper_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/04_spring_flower_humming/02_color_B/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_1_wallpaper_b_tier_3",
    "item_id": "living_04_spring_flower_humming_1_wallpaper_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/04_spring_flower_humming/02_color_B/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_1_wallpaper_c_tier_1",
    "item_id": "living_04_spring_flower_humming_1_wallpaper_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_1_wallpaper_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/04_spring_flower_humming/03_color_C/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_1_wallpaper_c_tier_2",
    "item_id": "living_04_spring_flower_humming_1_wallpaper_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_1_wallpaper_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/04_spring_flower_humming/03_color_C/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_1_wallpaper_c_tier_3",
    "item_id": "living_04_spring_flower_humming_1_wallpaper_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/04_spring_flower_humming/03_color_C/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_2_floor_a_tier_1",
    "item_id": "living_04_spring_flower_humming_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/04_spring_flower_humming/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_2_floor_a_tier_2",
    "item_id": "living_04_spring_flower_humming_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/04_spring_flower_humming/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_2_floor_a_tier_3",
    "item_id": "living_04_spring_flower_humming_2_floor_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/04_spring_flower_humming/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_2_floor_b_tier_1",
    "item_id": "living_04_spring_flower_humming_2_floor_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_2_floor_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/04_spring_flower_humming/02_color_B/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_2_floor_b_tier_2",
    "item_id": "living_04_spring_flower_humming_2_floor_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_2_floor_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/04_spring_flower_humming/02_color_B/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_2_floor_b_tier_3",
    "item_id": "living_04_spring_flower_humming_2_floor_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/04_spring_flower_humming/02_color_B/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_2_floor_c_tier_1",
    "item_id": "living_04_spring_flower_humming_2_floor_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_2_floor_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/04_spring_flower_humming/03_color_C/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_2_floor_c_tier_2",
    "item_id": "living_04_spring_flower_humming_2_floor_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_2_floor_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/04_spring_flower_humming/03_color_C/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_2_floor_c_tier_3",
    "item_id": "living_04_spring_flower_humming_2_floor_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/04_spring_flower_humming/03_color_C/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_3_above_fireplace_a_tier_1",
    "item_id": "living_04_spring_flower_humming_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/04_spring_flower_humming/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_3_above_fireplace_a_tier_2",
    "item_id": "living_04_spring_flower_humming_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/04_spring_flower_humming/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_3_above_fireplace_a_tier_3",
    "item_id": "living_04_spring_flower_humming_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/04_spring_flower_humming/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_3_above_fireplace_b_tier_1",
    "item_id": "living_04_spring_flower_humming_3_above_fireplace_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_3_above_fireplace_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/04_spring_flower_humming/02_color_B/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_3_above_fireplace_b_tier_2",
    "item_id": "living_04_spring_flower_humming_3_above_fireplace_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_3_above_fireplace_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/04_spring_flower_humming/02_color_B/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_3_above_fireplace_b_tier_3",
    "item_id": "living_04_spring_flower_humming_3_above_fireplace_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/04_spring_flower_humming/02_color_B/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_3_above_fireplace_c_tier_1",
    "item_id": "living_04_spring_flower_humming_3_above_fireplace_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_3_above_fireplace_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/04_spring_flower_humming/03_color_C/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_3_above_fireplace_c_tier_2",
    "item_id": "living_04_spring_flower_humming_3_above_fireplace_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_3_above_fireplace_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/04_spring_flower_humming/03_color_C/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_3_above_fireplace_c_tier_3",
    "item_id": "living_04_spring_flower_humming_3_above_fireplace_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/04_spring_flower_humming/03_color_C/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_4_painting_a_tier_1",
    "item_id": "living_04_spring_flower_humming_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/04_spring_flower_humming/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_4_painting_a_tier_2",
    "item_id": "living_04_spring_flower_humming_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/04_spring_flower_humming/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_4_painting_a_tier_3",
    "item_id": "living_04_spring_flower_humming_4_painting_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/04_spring_flower_humming/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_4_painting_b_tier_1",
    "item_id": "living_04_spring_flower_humming_4_painting_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_4_painting_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/04_spring_flower_humming/02_color_B/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_4_painting_b_tier_2",
    "item_id": "living_04_spring_flower_humming_4_painting_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_4_painting_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/04_spring_flower_humming/02_color_B/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_4_painting_b_tier_3",
    "item_id": "living_04_spring_flower_humming_4_painting_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/04_spring_flower_humming/02_color_B/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_4_painting_c_tier_1",
    "item_id": "living_04_spring_flower_humming_4_painting_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_4_painting_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/04_spring_flower_humming/03_color_C/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_4_painting_c_tier_2",
    "item_id": "living_04_spring_flower_humming_4_painting_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_4_painting_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/04_spring_flower_humming/03_color_C/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_4_painting_c_tier_3",
    "item_id": "living_04_spring_flower_humming_4_painting_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/04_spring_flower_humming/03_color_C/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_5_fireplace_a_tier_1",
    "item_id": "living_04_spring_flower_humming_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/04_spring_flower_humming/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_5_fireplace_a_tier_2",
    "item_id": "living_04_spring_flower_humming_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/04_spring_flower_humming/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_5_fireplace_a_tier_3",
    "item_id": "living_04_spring_flower_humming_5_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/04_spring_flower_humming/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_5_fireplace_b_tier_1",
    "item_id": "living_04_spring_flower_humming_5_fireplace_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_5_fireplace_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/04_spring_flower_humming/02_color_B/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_5_fireplace_b_tier_2",
    "item_id": "living_04_spring_flower_humming_5_fireplace_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_5_fireplace_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/04_spring_flower_humming/02_color_B/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_5_fireplace_b_tier_3",
    "item_id": "living_04_spring_flower_humming_5_fireplace_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/04_spring_flower_humming/02_color_B/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_5_fireplace_c_tier_1",
    "item_id": "living_04_spring_flower_humming_5_fireplace_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_5_fireplace_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/04_spring_flower_humming/03_color_C/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_5_fireplace_c_tier_2",
    "item_id": "living_04_spring_flower_humming_5_fireplace_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_5_fireplace_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/04_spring_flower_humming/03_color_C/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_5_fireplace_c_tier_3",
    "item_id": "living_04_spring_flower_humming_5_fireplace_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/04_spring_flower_humming/03_color_C/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_6_tree_a_tier_1",
    "item_id": "living_04_spring_flower_humming_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/04_spring_flower_humming/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_6_tree_a_tier_2",
    "item_id": "living_04_spring_flower_humming_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/04_spring_flower_humming/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_6_tree_a_tier_3",
    "item_id": "living_04_spring_flower_humming_6_tree_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/04_spring_flower_humming/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_6_tree_b_tier_1",
    "item_id": "living_04_spring_flower_humming_6_tree_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_6_tree_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/04_spring_flower_humming/02_color_B/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_6_tree_b_tier_2",
    "item_id": "living_04_spring_flower_humming_6_tree_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_6_tree_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/04_spring_flower_humming/02_color_B/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_6_tree_b_tier_3",
    "item_id": "living_04_spring_flower_humming_6_tree_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/04_spring_flower_humming/02_color_B/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_6_tree_c_tier_1",
    "item_id": "living_04_spring_flower_humming_6_tree_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_6_tree_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/04_spring_flower_humming/03_color_C/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_6_tree_c_tier_2",
    "item_id": "living_04_spring_flower_humming_6_tree_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_6_tree_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/04_spring_flower_humming/03_color_C/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_6_tree_c_tier_3",
    "item_id": "living_04_spring_flower_humming_6_tree_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/04_spring_flower_humming/03_color_C/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_7_couch_a_tier_1",
    "item_id": "living_04_spring_flower_humming_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/04_spring_flower_humming/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_7_couch_a_tier_2",
    "item_id": "living_04_spring_flower_humming_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/04_spring_flower_humming/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_7_couch_a_tier_3",
    "item_id": "living_04_spring_flower_humming_7_couch_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/04_spring_flower_humming/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_7_couch_b_tier_1",
    "item_id": "living_04_spring_flower_humming_7_couch_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_7_couch_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/04_spring_flower_humming/02_color_B/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_7_couch_b_tier_2",
    "item_id": "living_04_spring_flower_humming_7_couch_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_7_couch_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/04_spring_flower_humming/02_color_B/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_7_couch_b_tier_3",
    "item_id": "living_04_spring_flower_humming_7_couch_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/04_spring_flower_humming/02_color_B/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_7_couch_c_tier_1",
    "item_id": "living_04_spring_flower_humming_7_couch_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_7_couch_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/04_spring_flower_humming/03_color_C/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_7_couch_c_tier_2",
    "item_id": "living_04_spring_flower_humming_7_couch_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_7_couch_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/04_spring_flower_humming/03_color_C/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_7_couch_c_tier_3",
    "item_id": "living_04_spring_flower_humming_7_couch_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/04_spring_flower_humming/03_color_C/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_8_sidetable_a_tier_1",
    "item_id": "living_04_spring_flower_humming_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/04_spring_flower_humming/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_8_sidetable_a_tier_2",
    "item_id": "living_04_spring_flower_humming_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/04_spring_flower_humming/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_8_sidetable_a_tier_3",
    "item_id": "living_04_spring_flower_humming_8_sidetable_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/04_spring_flower_humming/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_8_sidetable_b_tier_1",
    "item_id": "living_04_spring_flower_humming_8_sidetable_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_8_sidetable_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/04_spring_flower_humming/02_color_B/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_8_sidetable_b_tier_2",
    "item_id": "living_04_spring_flower_humming_8_sidetable_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_8_sidetable_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/04_spring_flower_humming/02_color_B/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_8_sidetable_b_tier_3",
    "item_id": "living_04_spring_flower_humming_8_sidetable_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/04_spring_flower_humming/02_color_B/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_8_sidetable_c_tier_1",
    "item_id": "living_04_spring_flower_humming_8_sidetable_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_8_sidetable_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/04_spring_flower_humming/03_color_C/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_8_sidetable_c_tier_2",
    "item_id": "living_04_spring_flower_humming_8_sidetable_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_04_spring_flower_humming_8_sidetable_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/04_spring_flower_humming/03_color_C/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_04_spring_flower_humming_8_sidetable_c_tier_3",
    "item_id": "living_04_spring_flower_humming_8_sidetable_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/04_spring_flower_humming/03_color_C/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_1_wallpaper_a_tier_1",
    "item_id": "living_05_forrest_friends_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/05_forrest_friends/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_1_wallpaper_a_tier_2",
    "item_id": "living_05_forrest_friends_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/05_forrest_friends/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_1_wallpaper_a_tier_3",
    "item_id": "living_05_forrest_friends_1_wallpaper_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/05_forrest_friends/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_1_wallpaper_b_tier_1",
    "item_id": "living_05_forrest_friends_1_wallpaper_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_1_wallpaper_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/05_forrest_friends/02_color_B/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_1_wallpaper_b_tier_2",
    "item_id": "living_05_forrest_friends_1_wallpaper_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_1_wallpaper_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/05_forrest_friends/02_color_B/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_1_wallpaper_b_tier_3",
    "item_id": "living_05_forrest_friends_1_wallpaper_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/05_forrest_friends/02_color_B/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_1_wallpaper_c_tier_1",
    "item_id": "living_05_forrest_friends_1_wallpaper_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_1_wallpaper_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/05_forrest_friends/03_color_C/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_1_wallpaper_c_tier_2",
    "item_id": "living_05_forrest_friends_1_wallpaper_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_1_wallpaper_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/05_forrest_friends/03_color_C/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_1_wallpaper_c_tier_3",
    "item_id": "living_05_forrest_friends_1_wallpaper_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/05_forrest_friends/03_color_C/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_2_floor_a_tier_1",
    "item_id": "living_05_forrest_friends_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/05_forrest_friends/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_2_floor_a_tier_2",
    "item_id": "living_05_forrest_friends_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/05_forrest_friends/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_2_floor_a_tier_3",
    "item_id": "living_05_forrest_friends_2_floor_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/05_forrest_friends/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_2_floor_b_tier_1",
    "item_id": "living_05_forrest_friends_2_floor_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_2_floor_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/05_forrest_friends/02_color_B/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_2_floor_b_tier_2",
    "item_id": "living_05_forrest_friends_2_floor_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_2_floor_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/05_forrest_friends/02_color_B/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_2_floor_b_tier_3",
    "item_id": "living_05_forrest_friends_2_floor_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/05_forrest_friends/02_color_B/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_2_floor_c_tier_1",
    "item_id": "living_05_forrest_friends_2_floor_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_2_floor_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/05_forrest_friends/03_color_C/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_2_floor_c_tier_2",
    "item_id": "living_05_forrest_friends_2_floor_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_2_floor_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/05_forrest_friends/03_color_C/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_2_floor_c_tier_3",
    "item_id": "living_05_forrest_friends_2_floor_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/05_forrest_friends/03_color_C/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_3_above_fireplace_a_tier_1",
    "item_id": "living_05_forrest_friends_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/05_forrest_friends/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_3_above_fireplace_a_tier_2",
    "item_id": "living_05_forrest_friends_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/05_forrest_friends/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_3_above_fireplace_a_tier_3",
    "item_id": "living_05_forrest_friends_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/05_forrest_friends/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_3_above_fireplace_b_tier_1",
    "item_id": "living_05_forrest_friends_3_above_fireplace_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_3_above_fireplace_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/05_forrest_friends/02_color_B/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_3_above_fireplace_b_tier_2",
    "item_id": "living_05_forrest_friends_3_above_fireplace_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_3_above_fireplace_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/05_forrest_friends/02_color_B/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_3_above_fireplace_b_tier_3",
    "item_id": "living_05_forrest_friends_3_above_fireplace_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/05_forrest_friends/02_color_B/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_3_above_fireplace_c_tier_1",
    "item_id": "living_05_forrest_friends_3_above_fireplace_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_3_above_fireplace_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/05_forrest_friends/03_color_C/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_3_above_fireplace_c_tier_2",
    "item_id": "living_05_forrest_friends_3_above_fireplace_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_3_above_fireplace_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/05_forrest_friends/03_color_C/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_3_above_fireplace_c_tier_3",
    "item_id": "living_05_forrest_friends_3_above_fireplace_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/05_forrest_friends/03_color_C/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_4_painting_a_tier_1",
    "item_id": "living_05_forrest_friends_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/05_forrest_friends/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_4_painting_a_tier_2",
    "item_id": "living_05_forrest_friends_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/05_forrest_friends/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_4_painting_a_tier_3",
    "item_id": "living_05_forrest_friends_4_painting_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/05_forrest_friends/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_4_painting_b_tier_1",
    "item_id": "living_05_forrest_friends_4_painting_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_4_painting_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/05_forrest_friends/02_color_B/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_4_painting_b_tier_2",
    "item_id": "living_05_forrest_friends_4_painting_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_4_painting_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/05_forrest_friends/02_color_B/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_4_painting_b_tier_3",
    "item_id": "living_05_forrest_friends_4_painting_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/05_forrest_friends/02_color_B/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_4_painting_c_tier_1",
    "item_id": "living_05_forrest_friends_4_painting_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_4_painting_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/05_forrest_friends/03_color_C/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_4_painting_c_tier_2",
    "item_id": "living_05_forrest_friends_4_painting_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_4_painting_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/05_forrest_friends/03_color_C/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_4_painting_c_tier_3",
    "item_id": "living_05_forrest_friends_4_painting_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/05_forrest_friends/03_color_C/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_5_fireplace_a_tier_1",
    "item_id": "living_05_forrest_friends_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/05_forrest_friends/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_5_fireplace_a_tier_2",
    "item_id": "living_05_forrest_friends_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/05_forrest_friends/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_5_fireplace_a_tier_3",
    "item_id": "living_05_forrest_friends_5_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/05_forrest_friends/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_5_fireplace_b_tier_1",
    "item_id": "living_05_forrest_friends_5_fireplace_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_5_fireplace_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/05_forrest_friends/02_color_B/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_5_fireplace_b_tier_2",
    "item_id": "living_05_forrest_friends_5_fireplace_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_5_fireplace_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/05_forrest_friends/02_color_B/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_5_fireplace_b_tier_3",
    "item_id": "living_05_forrest_friends_5_fireplace_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/05_forrest_friends/02_color_B/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_5_fireplace_c_tier_1",
    "item_id": "living_05_forrest_friends_5_fireplace_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_5_fireplace_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/05_forrest_friends/03_color_C/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_5_fireplace_c_tier_2",
    "item_id": "living_05_forrest_friends_5_fireplace_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_5_fireplace_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/05_forrest_friends/03_color_C/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_5_fireplace_c_tier_3",
    "item_id": "living_05_forrest_friends_5_fireplace_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/05_forrest_friends/03_color_C/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_6_tree_a_tier_1",
    "item_id": "living_05_forrest_friends_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/05_forrest_friends/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_6_tree_a_tier_2",
    "item_id": "living_05_forrest_friends_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/05_forrest_friends/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_6_tree_a_tier_3",
    "item_id": "living_05_forrest_friends_6_tree_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/05_forrest_friends/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_6_tree_b_tier_1",
    "item_id": "living_05_forrest_friends_6_tree_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_6_tree_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/05_forrest_friends/02_color_B/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_6_tree_b_tier_2",
    "item_id": "living_05_forrest_friends_6_tree_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_6_tree_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/05_forrest_friends/02_color_B/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_6_tree_b_tier_3",
    "item_id": "living_05_forrest_friends_6_tree_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/05_forrest_friends/02_color_B/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_6_tree_c_tier_1",
    "item_id": "living_05_forrest_friends_6_tree_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_6_tree_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/05_forrest_friends/03_color_C/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_6_tree_c_tier_2",
    "item_id": "living_05_forrest_friends_6_tree_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_6_tree_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/05_forrest_friends/03_color_C/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_6_tree_c_tier_3",
    "item_id": "living_05_forrest_friends_6_tree_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/05_forrest_friends/03_color_C/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_7_couch_a_tier_1",
    "item_id": "living_05_forrest_friends_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/05_forrest_friends/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_7_couch_a_tier_2",
    "item_id": "living_05_forrest_friends_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/05_forrest_friends/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_7_couch_a_tier_3",
    "item_id": "living_05_forrest_friends_7_couch_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/05_forrest_friends/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_7_couch_b_tier_1",
    "item_id": "living_05_forrest_friends_7_couch_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_7_couch_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/05_forrest_friends/02_color_B/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_7_couch_b_tier_2",
    "item_id": "living_05_forrest_friends_7_couch_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_7_couch_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/05_forrest_friends/02_color_B/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_7_couch_b_tier_3",
    "item_id": "living_05_forrest_friends_7_couch_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/05_forrest_friends/02_color_B/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_7_couch_c_tier_1",
    "item_id": "living_05_forrest_friends_7_couch_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_7_couch_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/05_forrest_friends/03_color_C/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_7_couch_c_tier_2",
    "item_id": "living_05_forrest_friends_7_couch_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_7_couch_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/05_forrest_friends/03_color_C/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_7_couch_c_tier_3",
    "item_id": "living_05_forrest_friends_7_couch_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/05_forrest_friends/03_color_C/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_8_sidetable_a_tier_1",
    "item_id": "living_05_forrest_friends_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/05_forrest_friends/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_8_sidetable_a_tier_2",
    "item_id": "living_05_forrest_friends_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/05_forrest_friends/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_8_sidetable_a_tier_3",
    "item_id": "living_05_forrest_friends_8_sidetable_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/05_forrest_friends/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_8_sidetable_b_tier_1",
    "item_id": "living_05_forrest_friends_8_sidetable_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_8_sidetable_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/05_forrest_friends/02_color_B/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_8_sidetable_b_tier_2",
    "item_id": "living_05_forrest_friends_8_sidetable_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_8_sidetable_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/05_forrest_friends/02_color_B/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_8_sidetable_b_tier_3",
    "item_id": "living_05_forrest_friends_8_sidetable_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/05_forrest_friends/02_color_B/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_8_sidetable_c_tier_1",
    "item_id": "living_05_forrest_friends_8_sidetable_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_8_sidetable_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/05_forrest_friends/03_color_C/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_8_sidetable_c_tier_2",
    "item_id": "living_05_forrest_friends_8_sidetable_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_05_forrest_friends_8_sidetable_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/05_forrest_friends/03_color_C/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_05_forrest_friends_8_sidetable_c_tier_3",
    "item_id": "living_05_forrest_friends_8_sidetable_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/05_forrest_friends/03_color_C/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_1_wallpaper_a_tier_1",
    "item_id": "living_06_happy_xmas_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/06_happy_xmas/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_1_wallpaper_a_tier_2",
    "item_id": "living_06_happy_xmas_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/06_happy_xmas/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_1_wallpaper_a_tier_3",
    "item_id": "living_06_happy_xmas_1_wallpaper_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/06_happy_xmas/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_1_wallpaper_b_tier_1",
    "item_id": "living_06_happy_xmas_1_wallpaper_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_1_wallpaper_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/06_happy_xmas/02_color_B/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_1_wallpaper_b_tier_2",
    "item_id": "living_06_happy_xmas_1_wallpaper_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_1_wallpaper_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/06_happy_xmas/02_color_B/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_1_wallpaper_b_tier_3",
    "item_id": "living_06_happy_xmas_1_wallpaper_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/06_happy_xmas/02_color_B/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_1_wallpaper_c_tier_1",
    "item_id": "living_06_happy_xmas_1_wallpaper_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_1_wallpaper_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/06_happy_xmas/03_color_C/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_1_wallpaper_c_tier_2",
    "item_id": "living_06_happy_xmas_1_wallpaper_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_1_wallpaper_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/06_happy_xmas/03_color_C/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_1_wallpaper_c_tier_3",
    "item_id": "living_06_happy_xmas_1_wallpaper_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/06_happy_xmas/03_color_C/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_2_floor_a_tier_1",
    "item_id": "living_06_happy_xmas_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/06_happy_xmas/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_2_floor_a_tier_2",
    "item_id": "living_06_happy_xmas_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/06_happy_xmas/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_2_floor_a_tier_3",
    "item_id": "living_06_happy_xmas_2_floor_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/06_happy_xmas/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_2_floor_b_tier_1",
    "item_id": "living_06_happy_xmas_2_floor_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_2_floor_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/06_happy_xmas/02_color_B/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_2_floor_b_tier_2",
    "item_id": "living_06_happy_xmas_2_floor_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_2_floor_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/06_happy_xmas/02_color_B/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_2_floor_b_tier_3",
    "item_id": "living_06_happy_xmas_2_floor_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/06_happy_xmas/02_color_B/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_2_floor_c_tier_1",
    "item_id": "living_06_happy_xmas_2_floor_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_2_floor_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/06_happy_xmas/03_color_C/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_2_floor_c_tier_2",
    "item_id": "living_06_happy_xmas_2_floor_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_2_floor_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/06_happy_xmas/03_color_C/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_2_floor_c_tier_3",
    "item_id": "living_06_happy_xmas_2_floor_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/06_happy_xmas/03_color_C/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_3_above_fireplace_a_tier_1",
    "item_id": "living_06_happy_xmas_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/06_happy_xmas/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_3_above_fireplace_a_tier_2",
    "item_id": "living_06_happy_xmas_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/06_happy_xmas/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_3_above_fireplace_a_tier_3",
    "item_id": "living_06_happy_xmas_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/06_happy_xmas/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_3_above_fireplace_b_tier_1",
    "item_id": "living_06_happy_xmas_3_above_fireplace_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_3_above_fireplace_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/06_happy_xmas/02_color_B/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_3_above_fireplace_b_tier_2",
    "item_id": "living_06_happy_xmas_3_above_fireplace_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_3_above_fireplace_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/06_happy_xmas/02_color_B/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_3_above_fireplace_b_tier_3",
    "item_id": "living_06_happy_xmas_3_above_fireplace_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/06_happy_xmas/02_color_B/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_3_above_fireplace_c_tier_1",
    "item_id": "living_06_happy_xmas_3_above_fireplace_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_3_above_fireplace_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/06_happy_xmas/03_color_C/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_3_above_fireplace_c_tier_2",
    "item_id": "living_06_happy_xmas_3_above_fireplace_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_3_above_fireplace_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/06_happy_xmas/03_color_C/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_3_above_fireplace_c_tier_3",
    "item_id": "living_06_happy_xmas_3_above_fireplace_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/06_happy_xmas/03_color_C/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_4_painting_a_tier_1",
    "item_id": "living_06_happy_xmas_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/06_happy_xmas/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_4_painting_a_tier_2",
    "item_id": "living_06_happy_xmas_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/06_happy_xmas/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_4_painting_a_tier_3",
    "item_id": "living_06_happy_xmas_4_painting_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/06_happy_xmas/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_4_painting_b_tier_1",
    "item_id": "living_06_happy_xmas_4_painting_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_4_painting_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/06_happy_xmas/02_color_B/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_4_painting_b_tier_2",
    "item_id": "living_06_happy_xmas_4_painting_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_4_painting_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/06_happy_xmas/02_color_B/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_4_painting_b_tier_3",
    "item_id": "living_06_happy_xmas_4_painting_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/06_happy_xmas/02_color_B/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_4_painting_c_tier_1",
    "item_id": "living_06_happy_xmas_4_painting_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_4_painting_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/06_happy_xmas/03_color_C/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_4_painting_c_tier_2",
    "item_id": "living_06_happy_xmas_4_painting_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_4_painting_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/06_happy_xmas/03_color_C/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_4_painting_c_tier_3",
    "item_id": "living_06_happy_xmas_4_painting_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/06_happy_xmas/03_color_C/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_5_fireplace_a_tier_1",
    "item_id": "living_06_happy_xmas_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/06_happy_xmas/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_5_fireplace_a_tier_2",
    "item_id": "living_06_happy_xmas_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/06_happy_xmas/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_5_fireplace_a_tier_3",
    "item_id": "living_06_happy_xmas_5_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/06_happy_xmas/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_5_fireplace_b_tier_1",
    "item_id": "living_06_happy_xmas_5_fireplace_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_5_fireplace_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/06_happy_xmas/02_color_B/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_5_fireplace_b_tier_2",
    "item_id": "living_06_happy_xmas_5_fireplace_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_5_fireplace_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/06_happy_xmas/02_color_B/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_5_fireplace_b_tier_3",
    "item_id": "living_06_happy_xmas_5_fireplace_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/06_happy_xmas/02_color_B/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_5_fireplace_c_tier_1",
    "item_id": "living_06_happy_xmas_5_fireplace_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_5_fireplace_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/06_happy_xmas/03_color_C/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_5_fireplace_c_tier_2",
    "item_id": "living_06_happy_xmas_5_fireplace_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_5_fireplace_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/06_happy_xmas/03_color_C/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_5_fireplace_c_tier_3",
    "item_id": "living_06_happy_xmas_5_fireplace_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/06_happy_xmas/03_color_C/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_6_tree_a_tier_1",
    "item_id": "living_06_happy_xmas_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/06_happy_xmas/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_6_tree_a_tier_2",
    "item_id": "living_06_happy_xmas_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/06_happy_xmas/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_6_tree_a_tier_3",
    "item_id": "living_06_happy_xmas_6_tree_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/06_happy_xmas/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_6_tree_b_tier_1",
    "item_id": "living_06_happy_xmas_6_tree_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_6_tree_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/06_happy_xmas/02_color_B/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_6_tree_b_tier_2",
    "item_id": "living_06_happy_xmas_6_tree_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_6_tree_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/06_happy_xmas/02_color_B/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_6_tree_b_tier_3",
    "item_id": "living_06_happy_xmas_6_tree_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/06_happy_xmas/02_color_B/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_6_tree_c_tier_1",
    "item_id": "living_06_happy_xmas_6_tree_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_6_tree_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/06_happy_xmas/03_color_C/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_6_tree_c_tier_2",
    "item_id": "living_06_happy_xmas_6_tree_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_6_tree_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/06_happy_xmas/03_color_C/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_6_tree_c_tier_3",
    "item_id": "living_06_happy_xmas_6_tree_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/06_happy_xmas/03_color_C/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_7_couch_a_tier_1",
    "item_id": "living_06_happy_xmas_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/06_happy_xmas/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_7_couch_a_tier_2",
    "item_id": "living_06_happy_xmas_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/06_happy_xmas/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_7_couch_a_tier_3",
    "item_id": "living_06_happy_xmas_7_couch_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/06_happy_xmas/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_7_couch_b_tier_1",
    "item_id": "living_06_happy_xmas_7_couch_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_7_couch_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/06_happy_xmas/02_color_B/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_7_couch_b_tier_2",
    "item_id": "living_06_happy_xmas_7_couch_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_7_couch_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/06_happy_xmas/02_color_B/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_7_couch_b_tier_3",
    "item_id": "living_06_happy_xmas_7_couch_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/06_happy_xmas/02_color_B/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_7_couch_c_tier_1",
    "item_id": "living_06_happy_xmas_7_couch_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_7_couch_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/06_happy_xmas/03_color_C/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_7_couch_c_tier_2",
    "item_id": "living_06_happy_xmas_7_couch_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_7_couch_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/06_happy_xmas/03_color_C/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_7_couch_c_tier_3",
    "item_id": "living_06_happy_xmas_7_couch_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/06_happy_xmas/03_color_C/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_8_sidetable_a_tier_1",
    "item_id": "living_06_happy_xmas_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/06_happy_xmas/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_8_sidetable_a_tier_2",
    "item_id": "living_06_happy_xmas_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/06_happy_xmas/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_8_sidetable_a_tier_3",
    "item_id": "living_06_happy_xmas_8_sidetable_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/06_happy_xmas/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_8_sidetable_b_tier_1",
    "item_id": "living_06_happy_xmas_8_sidetable_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_8_sidetable_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/06_happy_xmas/02_color_B/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_8_sidetable_b_tier_2",
    "item_id": "living_06_happy_xmas_8_sidetable_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_8_sidetable_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/06_happy_xmas/02_color_B/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_8_sidetable_b_tier_3",
    "item_id": "living_06_happy_xmas_8_sidetable_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/06_happy_xmas/02_color_B/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_8_sidetable_c_tier_1",
    "item_id": "living_06_happy_xmas_8_sidetable_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_8_sidetable_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/06_happy_xmas/03_color_C/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_8_sidetable_c_tier_2",
    "item_id": "living_06_happy_xmas_8_sidetable_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_06_happy_xmas_8_sidetable_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/06_happy_xmas/03_color_C/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_06_happy_xmas_8_sidetable_c_tier_3",
    "item_id": "living_06_happy_xmas_8_sidetable_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/06_happy_xmas/03_color_C/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_1_wallpaper_a_tier_1",
    "item_id": "living_07_trad_japanese_winter_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/07_trad_japanese_winter/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_1_wallpaper_a_tier_2",
    "item_id": "living_07_trad_japanese_winter_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/07_trad_japanese_winter/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_1_wallpaper_a_tier_3",
    "item_id": "living_07_trad_japanese_winter_1_wallpaper_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/07_trad_japanese_winter/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_1_wallpaper_b_tier_1",
    "item_id": "living_07_trad_japanese_winter_1_wallpaper_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_1_wallpaper_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/07_trad_japanese_winter/02_color_B/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_1_wallpaper_b_tier_2",
    "item_id": "living_07_trad_japanese_winter_1_wallpaper_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_1_wallpaper_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/07_trad_japanese_winter/02_color_B/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_1_wallpaper_b_tier_3",
    "item_id": "living_07_trad_japanese_winter_1_wallpaper_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/07_trad_japanese_winter/02_color_B/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_1_wallpaper_c_tier_1",
    "item_id": "living_07_trad_japanese_winter_1_wallpaper_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_1_wallpaper_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/07_trad_japanese_winter/03_color_C/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_1_wallpaper_c_tier_2",
    "item_id": "living_07_trad_japanese_winter_1_wallpaper_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_1_wallpaper_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/07_trad_japanese_winter/03_color_C/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_1_wallpaper_c_tier_3",
    "item_id": "living_07_trad_japanese_winter_1_wallpaper_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/07_trad_japanese_winter/03_color_C/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_2_floor_a_tier_1",
    "item_id": "living_07_trad_japanese_winter_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/07_trad_japanese_winter/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_2_floor_a_tier_2",
    "item_id": "living_07_trad_japanese_winter_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/07_trad_japanese_winter/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_2_floor_a_tier_3",
    "item_id": "living_07_trad_japanese_winter_2_floor_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/07_trad_japanese_winter/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_2_floor_b_tier_1",
    "item_id": "living_07_trad_japanese_winter_2_floor_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_2_floor_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/07_trad_japanese_winter/02_color_B/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_2_floor_b_tier_2",
    "item_id": "living_07_trad_japanese_winter_2_floor_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_2_floor_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/07_trad_japanese_winter/02_color_B/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_2_floor_b_tier_3",
    "item_id": "living_07_trad_japanese_winter_2_floor_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/07_trad_japanese_winter/02_color_B/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_2_floor_c_tier_1",
    "item_id": "living_07_trad_japanese_winter_2_floor_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_2_floor_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/07_trad_japanese_winter/03_color_C/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_2_floor_c_tier_2",
    "item_id": "living_07_trad_japanese_winter_2_floor_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_2_floor_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/07_trad_japanese_winter/03_color_C/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_2_floor_c_tier_3",
    "item_id": "living_07_trad_japanese_winter_2_floor_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/07_trad_japanese_winter/03_color_C/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_3_above_fireplace_a_tier_1",
    "item_id": "living_07_trad_japanese_winter_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/07_trad_japanese_winter/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_3_above_fireplace_a_tier_2",
    "item_id": "living_07_trad_japanese_winter_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/07_trad_japanese_winter/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_3_above_fireplace_a_tier_3",
    "item_id": "living_07_trad_japanese_winter_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/07_trad_japanese_winter/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_3_above_fireplace_b_tier_1",
    "item_id": "living_07_trad_japanese_winter_3_above_fireplace_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_3_above_fireplace_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/07_trad_japanese_winter/02_color_B/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_3_above_fireplace_b_tier_2",
    "item_id": "living_07_trad_japanese_winter_3_above_fireplace_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_3_above_fireplace_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/07_trad_japanese_winter/02_color_B/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_3_above_fireplace_b_tier_3",
    "item_id": "living_07_trad_japanese_winter_3_above_fireplace_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/07_trad_japanese_winter/02_color_B/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_3_above_fireplace_c_tier_1",
    "item_id": "living_07_trad_japanese_winter_3_above_fireplace_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_3_above_fireplace_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/07_trad_japanese_winter/03_color_C/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_3_above_fireplace_c_tier_2",
    "item_id": "living_07_trad_japanese_winter_3_above_fireplace_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_3_above_fireplace_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/07_trad_japanese_winter/03_color_C/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_3_above_fireplace_c_tier_3",
    "item_id": "living_07_trad_japanese_winter_3_above_fireplace_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/07_trad_japanese_winter/03_color_C/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_4_painting_a_tier_1",
    "item_id": "living_07_trad_japanese_winter_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/07_trad_japanese_winter/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_4_painting_a_tier_2",
    "item_id": "living_07_trad_japanese_winter_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/07_trad_japanese_winter/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_4_painting_a_tier_3",
    "item_id": "living_07_trad_japanese_winter_4_painting_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/07_trad_japanese_winter/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_4_painting_b_tier_1",
    "item_id": "living_07_trad_japanese_winter_4_painting_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_4_painting_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/07_trad_japanese_winter/02_color_B/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_4_painting_b_tier_2",
    "item_id": "living_07_trad_japanese_winter_4_painting_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_4_painting_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/07_trad_japanese_winter/02_color_B/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_4_painting_b_tier_3",
    "item_id": "living_07_trad_japanese_winter_4_painting_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/07_trad_japanese_winter/02_color_B/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_4_painting_c_tier_1",
    "item_id": "living_07_trad_japanese_winter_4_painting_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_4_painting_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/07_trad_japanese_winter/03_color_C/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_4_painting_c_tier_2",
    "item_id": "living_07_trad_japanese_winter_4_painting_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_4_painting_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/07_trad_japanese_winter/03_color_C/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_4_painting_c_tier_3",
    "item_id": "living_07_trad_japanese_winter_4_painting_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/07_trad_japanese_winter/03_color_C/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_5_fireplace_a_tier_1",
    "item_id": "living_07_trad_japanese_winter_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/07_trad_japanese_winter/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_5_fireplace_a_tier_2",
    "item_id": "living_07_trad_japanese_winter_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/07_trad_japanese_winter/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_5_fireplace_a_tier_3",
    "item_id": "living_07_trad_japanese_winter_5_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/07_trad_japanese_winter/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_5_fireplace_b_tier_1",
    "item_id": "living_07_trad_japanese_winter_5_fireplace_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_5_fireplace_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/07_trad_japanese_winter/02_color_B/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_5_fireplace_b_tier_2",
    "item_id": "living_07_trad_japanese_winter_5_fireplace_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_5_fireplace_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/07_trad_japanese_winter/02_color_B/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_5_fireplace_b_tier_3",
    "item_id": "living_07_trad_japanese_winter_5_fireplace_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/07_trad_japanese_winter/02_color_B/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_5_fireplace_c_tier_1",
    "item_id": "living_07_trad_japanese_winter_5_fireplace_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_5_fireplace_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/07_trad_japanese_winter/03_color_C/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_5_fireplace_c_tier_2",
    "item_id": "living_07_trad_japanese_winter_5_fireplace_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_5_fireplace_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/07_trad_japanese_winter/03_color_C/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_5_fireplace_c_tier_3",
    "item_id": "living_07_trad_japanese_winter_5_fireplace_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/07_trad_japanese_winter/03_color_C/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_6_tree_a_tier_1",
    "item_id": "living_07_trad_japanese_winter_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/07_trad_japanese_winter/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_6_tree_a_tier_2",
    "item_id": "living_07_trad_japanese_winter_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/07_trad_japanese_winter/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_6_tree_a_tier_3",
    "item_id": "living_07_trad_japanese_winter_6_tree_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/07_trad_japanese_winter/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_6_tree_b_tier_1",
    "item_id": "living_07_trad_japanese_winter_6_tree_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_6_tree_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/07_trad_japanese_winter/02_color_B/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_6_tree_b_tier_2",
    "item_id": "living_07_trad_japanese_winter_6_tree_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_6_tree_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/07_trad_japanese_winter/02_color_B/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_6_tree_b_tier_3",
    "item_id": "living_07_trad_japanese_winter_6_tree_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/07_trad_japanese_winter/02_color_B/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_6_tree_c_tier_1",
    "item_id": "living_07_trad_japanese_winter_6_tree_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_6_tree_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/07_trad_japanese_winter/03_color_C/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_6_tree_c_tier_2",
    "item_id": "living_07_trad_japanese_winter_6_tree_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_6_tree_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/07_trad_japanese_winter/03_color_C/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_6_tree_c_tier_3",
    "item_id": "living_07_trad_japanese_winter_6_tree_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/07_trad_japanese_winter/03_color_C/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_7_couch_a_tier_1",
    "item_id": "living_07_trad_japanese_winter_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/07_trad_japanese_winter/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_7_couch_a_tier_2",
    "item_id": "living_07_trad_japanese_winter_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/07_trad_japanese_winter/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_7_couch_a_tier_3",
    "item_id": "living_07_trad_japanese_winter_7_couch_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/07_trad_japanese_winter/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_7_couch_b_tier_1",
    "item_id": "living_07_trad_japanese_winter_7_couch_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_7_couch_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/07_trad_japanese_winter/02_color_B/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_7_couch_b_tier_2",
    "item_id": "living_07_trad_japanese_winter_7_couch_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_7_couch_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/07_trad_japanese_winter/02_color_B/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_7_couch_b_tier_3",
    "item_id": "living_07_trad_japanese_winter_7_couch_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/07_trad_japanese_winter/02_color_B/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_7_couch_c_tier_1",
    "item_id": "living_07_trad_japanese_winter_7_couch_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_7_couch_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/07_trad_japanese_winter/03_color_C/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_7_couch_c_tier_2",
    "item_id": "living_07_trad_japanese_winter_7_couch_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_7_couch_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/07_trad_japanese_winter/03_color_C/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_7_couch_c_tier_3",
    "item_id": "living_07_trad_japanese_winter_7_couch_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/07_trad_japanese_winter/03_color_C/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_8_sidetable_a_tier_1",
    "item_id": "living_07_trad_japanese_winter_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/07_trad_japanese_winter/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_8_sidetable_a_tier_2",
    "item_id": "living_07_trad_japanese_winter_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/07_trad_japanese_winter/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_8_sidetable_a_tier_3",
    "item_id": "living_07_trad_japanese_winter_8_sidetable_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/07_trad_japanese_winter/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_8_sidetable_b_tier_1",
    "item_id": "living_07_trad_japanese_winter_8_sidetable_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_8_sidetable_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/07_trad_japanese_winter/02_color_B/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_8_sidetable_b_tier_2",
    "item_id": "living_07_trad_japanese_winter_8_sidetable_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_8_sidetable_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/07_trad_japanese_winter/02_color_B/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_8_sidetable_b_tier_3",
    "item_id": "living_07_trad_japanese_winter_8_sidetable_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/07_trad_japanese_winter/02_color_B/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_8_sidetable_c_tier_1",
    "item_id": "living_07_trad_japanese_winter_8_sidetable_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_8_sidetable_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/07_trad_japanese_winter/03_color_C/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_8_sidetable_c_tier_2",
    "item_id": "living_07_trad_japanese_winter_8_sidetable_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_07_trad_japanese_winter_8_sidetable_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/07_trad_japanese_winter/03_color_C/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_07_trad_japanese_winter_8_sidetable_c_tier_3",
    "item_id": "living_07_trad_japanese_winter_8_sidetable_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/07_trad_japanese_winter/03_color_C/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_1_wallpaper_a_tier_1",
    "item_id": "living_08_neon_party_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/08_neon_party/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_1_wallpaper_a_tier_2",
    "item_id": "living_08_neon_party_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/08_neon_party/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_1_wallpaper_a_tier_3",
    "item_id": "living_08_neon_party_1_wallpaper_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/08_neon_party/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_1_wallpaper_b_tier_1",
    "item_id": "living_08_neon_party_1_wallpaper_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_1_wallpaper_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/08_neon_party/02_color_B/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_1_wallpaper_b_tier_2",
    "item_id": "living_08_neon_party_1_wallpaper_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_1_wallpaper_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/08_neon_party/02_color_B/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_1_wallpaper_b_tier_3",
    "item_id": "living_08_neon_party_1_wallpaper_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/08_neon_party/02_color_B/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_1_wallpaper_c_tier_1",
    "item_id": "living_08_neon_party_1_wallpaper_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_1_wallpaper_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/08_neon_party/03_color_C/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_1_wallpaper_c_tier_2",
    "item_id": "living_08_neon_party_1_wallpaper_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_1_wallpaper_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/08_neon_party/03_color_C/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_1_wallpaper_c_tier_3",
    "item_id": "living_08_neon_party_1_wallpaper_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/08_neon_party/03_color_C/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_2_floor_a_tier_1",
    "item_id": "living_08_neon_party_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/08_neon_party/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_2_floor_a_tier_2",
    "item_id": "living_08_neon_party_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/08_neon_party/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_2_floor_a_tier_3",
    "item_id": "living_08_neon_party_2_floor_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/08_neon_party/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_2_floor_b_tier_1",
    "item_id": "living_08_neon_party_2_floor_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_2_floor_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/08_neon_party/02_color_B/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_2_floor_b_tier_2",
    "item_id": "living_08_neon_party_2_floor_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_2_floor_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/08_neon_party/02_color_B/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_2_floor_b_tier_3",
    "item_id": "living_08_neon_party_2_floor_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/08_neon_party/02_color_B/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_2_floor_c_tier_1",
    "item_id": "living_08_neon_party_2_floor_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_2_floor_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/08_neon_party/03_color_C/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_2_floor_c_tier_2",
    "item_id": "living_08_neon_party_2_floor_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_2_floor_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/08_neon_party/03_color_C/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_2_floor_c_tier_3",
    "item_id": "living_08_neon_party_2_floor_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/08_neon_party/03_color_C/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_3_above_fireplace_a_tier_1",
    "item_id": "living_08_neon_party_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/08_neon_party/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_3_above_fireplace_a_tier_2",
    "item_id": "living_08_neon_party_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/08_neon_party/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_3_above_fireplace_a_tier_3",
    "item_id": "living_08_neon_party_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/08_neon_party/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_3_above_fireplace_b_tier_1",
    "item_id": "living_08_neon_party_3_above_fireplace_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_3_above_fireplace_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/08_neon_party/02_color_B/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_3_above_fireplace_b_tier_2",
    "item_id": "living_08_neon_party_3_above_fireplace_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_3_above_fireplace_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/08_neon_party/02_color_B/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_3_above_fireplace_b_tier_3",
    "item_id": "living_08_neon_party_3_above_fireplace_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/08_neon_party/02_color_B/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_3_above_fireplace_c_tier_1",
    "item_id": "living_08_neon_party_3_above_fireplace_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_3_above_fireplace_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/08_neon_party/03_color_C/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_3_above_fireplace_c_tier_2",
    "item_id": "living_08_neon_party_3_above_fireplace_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_3_above_fireplace_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/08_neon_party/03_color_C/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_3_above_fireplace_c_tier_3",
    "item_id": "living_08_neon_party_3_above_fireplace_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/08_neon_party/03_color_C/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_4_painting_a_tier_1",
    "item_id": "living_08_neon_party_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/08_neon_party/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_4_painting_a_tier_2",
    "item_id": "living_08_neon_party_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/08_neon_party/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_4_painting_a_tier_3",
    "item_id": "living_08_neon_party_4_painting_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/08_neon_party/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_4_painting_b_tier_1",
    "item_id": "living_08_neon_party_4_painting_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_4_painting_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/08_neon_party/02_color_B/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_4_painting_b_tier_2",
    "item_id": "living_08_neon_party_4_painting_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_4_painting_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/08_neon_party/02_color_B/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_4_painting_b_tier_3",
    "item_id": "living_08_neon_party_4_painting_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/08_neon_party/02_color_B/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_4_painting_c_tier_1",
    "item_id": "living_08_neon_party_4_painting_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_4_painting_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/08_neon_party/03_color_C/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_4_painting_c_tier_2",
    "item_id": "living_08_neon_party_4_painting_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_4_painting_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/08_neon_party/03_color_C/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_4_painting_c_tier_3",
    "item_id": "living_08_neon_party_4_painting_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/08_neon_party/03_color_C/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_5_fireplace_a_tier_1",
    "item_id": "living_08_neon_party_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/08_neon_party/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_5_fireplace_a_tier_2",
    "item_id": "living_08_neon_party_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/08_neon_party/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_5_fireplace_a_tier_3",
    "item_id": "living_08_neon_party_5_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/08_neon_party/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_5_fireplace_b_tier_1",
    "item_id": "living_08_neon_party_5_fireplace_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_5_fireplace_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/08_neon_party/02_color_B/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_5_fireplace_b_tier_2",
    "item_id": "living_08_neon_party_5_fireplace_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_5_fireplace_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/08_neon_party/02_color_B/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_5_fireplace_b_tier_3",
    "item_id": "living_08_neon_party_5_fireplace_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/08_neon_party/02_color_B/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_5_fireplace_c_tier_1",
    "item_id": "living_08_neon_party_5_fireplace_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_5_fireplace_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/08_neon_party/03_color_C/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_5_fireplace_c_tier_2",
    "item_id": "living_08_neon_party_5_fireplace_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_5_fireplace_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/08_neon_party/03_color_C/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_5_fireplace_c_tier_3",
    "item_id": "living_08_neon_party_5_fireplace_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/08_neon_party/03_color_C/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_6_tree_a_tier_1",
    "item_id": "living_08_neon_party_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/08_neon_party/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_6_tree_a_tier_2",
    "item_id": "living_08_neon_party_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/08_neon_party/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_6_tree_a_tier_3",
    "item_id": "living_08_neon_party_6_tree_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/08_neon_party/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_6_tree_b_tier_1",
    "item_id": "living_08_neon_party_6_tree_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_6_tree_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/08_neon_party/02_color_B/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_6_tree_b_tier_2",
    "item_id": "living_08_neon_party_6_tree_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_6_tree_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/08_neon_party/02_color_B/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_6_tree_b_tier_3",
    "item_id": "living_08_neon_party_6_tree_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/08_neon_party/02_color_B/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_6_tree_c_tier_1",
    "item_id": "living_08_neon_party_6_tree_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_6_tree_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/08_neon_party/03_color_C/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_6_tree_c_tier_2",
    "item_id": "living_08_neon_party_6_tree_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_6_tree_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/08_neon_party/03_color_C/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_6_tree_c_tier_3",
    "item_id": "living_08_neon_party_6_tree_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/08_neon_party/03_color_C/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_7_couch_a_tier_1",
    "item_id": "living_08_neon_party_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/08_neon_party/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_7_couch_a_tier_2",
    "item_id": "living_08_neon_party_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/08_neon_party/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_7_couch_a_tier_3",
    "item_id": "living_08_neon_party_7_couch_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/08_neon_party/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_7_couch_b_tier_1",
    "item_id": "living_08_neon_party_7_couch_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_7_couch_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/08_neon_party/02_color_B/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_7_couch_b_tier_2",
    "item_id": "living_08_neon_party_7_couch_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_7_couch_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/08_neon_party/02_color_B/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_7_couch_b_tier_3",
    "item_id": "living_08_neon_party_7_couch_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/08_neon_party/02_color_B/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_7_couch_c_tier_1",
    "item_id": "living_08_neon_party_7_couch_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_7_couch_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/08_neon_party/03_color_C/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_7_couch_c_tier_2",
    "item_id": "living_08_neon_party_7_couch_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_7_couch_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/08_neon_party/03_color_C/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_7_couch_c_tier_3",
    "item_id": "living_08_neon_party_7_couch_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/08_neon_party/03_color_C/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_8_sidetable_a_tier_1",
    "item_id": "living_08_neon_party_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/08_neon_party/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_8_sidetable_a_tier_2",
    "item_id": "living_08_neon_party_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/08_neon_party/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_8_sidetable_a_tier_3",
    "item_id": "living_08_neon_party_8_sidetable_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/08_neon_party/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_8_sidetable_b_tier_1",
    "item_id": "living_08_neon_party_8_sidetable_b",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_8_sidetable_b_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/08_neon_party/02_color_B/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_8_sidetable_b_tier_2",
    "item_id": "living_08_neon_party_8_sidetable_b",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_8_sidetable_b_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/08_neon_party/02_color_B/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_8_sidetable_b_tier_3",
    "item_id": "living_08_neon_party_8_sidetable_b",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/08_neon_party/02_color_B/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_8_sidetable_c_tier_1",
    "item_id": "living_08_neon_party_8_sidetable_c",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_8_sidetable_c_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/08_neon_party/03_color_C/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_8_sidetable_c_tier_2",
    "item_id": "living_08_neon_party_8_sidetable_c",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_08_neon_party_8_sidetable_c_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/08_neon_party/03_color_C/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_08_neon_party_8_sidetable_c_tier_3",
    "item_id": "living_08_neon_party_8_sidetable_c",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/08_neon_party/03_color_C/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_09_valentine_day_1_wallpaper_a_tier_1",
    "item_id": "living_09_valentine_day_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_09_valentine_day_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/09_valentine_day/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_09_valentine_day_1_wallpaper_a_tier_2",
    "item_id": "living_09_valentine_day_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_09_valentine_day_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/09_valentine_day/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_09_valentine_day_1_wallpaper_a_tier_3",
    "item_id": "living_09_valentine_day_1_wallpaper_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_09_valentine_day_1_wallpaper_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/09_valentine_day/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_09_valentine_day_1_wallpaper_a_tier_4",
    "item_id": "living_09_valentine_day_1_wallpaper_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/09_valentine_day/01_color_A/04_tier_4/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_09_valentine_day_2_floor_a_tier_1",
    "item_id": "living_09_valentine_day_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_09_valentine_day_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/09_valentine_day/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_09_valentine_day_2_floor_a_tier_2",
    "item_id": "living_09_valentine_day_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_09_valentine_day_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/09_valentine_day/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_09_valentine_day_2_floor_a_tier_3",
    "item_id": "living_09_valentine_day_2_floor_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_09_valentine_day_2_floor_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/09_valentine_day/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_09_valentine_day_2_floor_a_tier_4",
    "item_id": "living_09_valentine_day_2_floor_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/09_valentine_day/01_color_A/04_tier_4/02_floor.png",
    "animated": false
  },
  {
    "id": "living_09_valentine_day_3_above_fireplace_a_tier_1",
    "item_id": "living_09_valentine_day_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_09_valentine_day_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/09_valentine_day/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_09_valentine_day_3_above_fireplace_a_tier_2",
    "item_id": "living_09_valentine_day_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_09_valentine_day_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/09_valentine_day/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_09_valentine_day_3_above_fireplace_a_tier_3",
    "item_id": "living_09_valentine_day_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_09_valentine_day_3_above_fireplace_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/09_valentine_day/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_09_valentine_day_3_above_fireplace_a_tier_4",
    "item_id": "living_09_valentine_day_3_above_fireplace_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/09_valentine_day/01_color_A/04_tier_4/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_09_valentine_day_4_painting_a_tier_1",
    "item_id": "living_09_valentine_day_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_09_valentine_day_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/09_valentine_day/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_09_valentine_day_4_painting_a_tier_2",
    "item_id": "living_09_valentine_day_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_09_valentine_day_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/09_valentine_day/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_09_valentine_day_4_painting_a_tier_3",
    "item_id": "living_09_valentine_day_4_painting_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_09_valentine_day_4_painting_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/09_valentine_day/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_09_valentine_day_4_painting_a_tier_4",
    "item_id": "living_09_valentine_day_4_painting_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/09_valentine_day/01_color_A/04_tier_4/04_painting.png",
    "animated": false
  },
  {
    "id": "living_09_valentine_day_5_fireplace_a_tier_1",
    "item_id": "living_09_valentine_day_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_09_valentine_day_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/09_valentine_day/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_09_valentine_day_5_fireplace_a_tier_2",
    "item_id": "living_09_valentine_day_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_09_valentine_day_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/09_valentine_day/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_09_valentine_day_5_fireplace_a_tier_3",
    "item_id": "living_09_valentine_day_5_fireplace_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_09_valentine_day_5_fireplace_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/09_valentine_day/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_09_valentine_day_5_fireplace_a_tier_4",
    "item_id": "living_09_valentine_day_5_fireplace_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/09_valentine_day/01_color_A/04_tier_4/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_09_valentine_day_6_tree_a_tier_1",
    "item_id": "living_09_valentine_day_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_09_valentine_day_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/09_valentine_day/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_09_valentine_day_6_tree_a_tier_2",
    "item_id": "living_09_valentine_day_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_09_valentine_day_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/09_valentine_day/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_09_valentine_day_6_tree_a_tier_3",
    "item_id": "living_09_valentine_day_6_tree_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_09_valentine_day_6_tree_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/09_valentine_day/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_09_valentine_day_6_tree_a_tier_4",
    "item_id": "living_09_valentine_day_6_tree_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/09_valentine_day/01_color_A/04_tier_4/06_tree.png",
    "animated": false
  },
  {
    "id": "living_09_valentine_day_7_couch_a_tier_1",
    "item_id": "living_09_valentine_day_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_09_valentine_day_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/09_valentine_day/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_09_valentine_day_7_couch_a_tier_2",
    "item_id": "living_09_valentine_day_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_09_valentine_day_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/09_valentine_day/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_09_valentine_day_7_couch_a_tier_3",
    "item_id": "living_09_valentine_day_7_couch_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_09_valentine_day_7_couch_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/09_valentine_day/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_09_valentine_day_7_couch_a_tier_4",
    "item_id": "living_09_valentine_day_7_couch_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/09_valentine_day/01_color_A/04_tier_4/07_couch.png",
    "animated": false
  },
  {
    "id": "living_09_valentine_day_8_sidetable_a_tier_1",
    "item_id": "living_09_valentine_day_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_09_valentine_day_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/09_valentine_day/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_09_valentine_day_8_sidetable_a_tier_2",
    "item_id": "living_09_valentine_day_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_09_valentine_day_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/09_valentine_day/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_09_valentine_day_8_sidetable_a_tier_3",
    "item_id": "living_09_valentine_day_8_sidetable_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_09_valentine_day_8_sidetable_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/09_valentine_day/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_09_valentine_day_8_sidetable_a_tier_4",
    "item_id": "living_09_valentine_day_8_sidetable_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/09_valentine_day/01_color_A/04_tier_4/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_10_angel_1_wallpaper_a_tier_1",
    "item_id": "living_10_angel_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_10_angel_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/10_angel/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_10_angel_1_wallpaper_a_tier_2",
    "item_id": "living_10_angel_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_10_angel_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/10_angel/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_10_angel_1_wallpaper_a_tier_3",
    "item_id": "living_10_angel_1_wallpaper_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_10_angel_1_wallpaper_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/10_angel/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_10_angel_1_wallpaper_a_tier_4",
    "item_id": "living_10_angel_1_wallpaper_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/10_angel/01_color_A/04_tier_4/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_10_angel_2_floor_a_tier_1",
    "item_id": "living_10_angel_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_10_angel_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/10_angel/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_10_angel_2_floor_a_tier_2",
    "item_id": "living_10_angel_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_10_angel_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/10_angel/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_10_angel_2_floor_a_tier_3",
    "item_id": "living_10_angel_2_floor_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_10_angel_2_floor_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/10_angel/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_10_angel_2_floor_a_tier_4",
    "item_id": "living_10_angel_2_floor_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/10_angel/01_color_A/04_tier_4/02_floor.png",
    "animated": false
  },
  {
    "id": "living_10_angel_3_above_fireplace_a_tier_1",
    "item_id": "living_10_angel_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_10_angel_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/10_angel/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_10_angel_3_above_fireplace_a_tier_2",
    "item_id": "living_10_angel_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_10_angel_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/10_angel/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_10_angel_3_above_fireplace_a_tier_3",
    "item_id": "living_10_angel_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_10_angel_3_above_fireplace_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/10_angel/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_10_angel_3_above_fireplace_a_tier_4",
    "item_id": "living_10_angel_3_above_fireplace_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/10_angel/01_color_A/04_tier_4/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_10_angel_4_painting_a_tier_1",
    "item_id": "living_10_angel_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_10_angel_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/10_angel/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_10_angel_4_painting_a_tier_2",
    "item_id": "living_10_angel_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_10_angel_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/10_angel/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_10_angel_4_painting_a_tier_3",
    "item_id": "living_10_angel_4_painting_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_10_angel_4_painting_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/10_angel/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_10_angel_4_painting_a_tier_4",
    "item_id": "living_10_angel_4_painting_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/10_angel/01_color_A/04_tier_4/04_painting.png",
    "animated": false
  },
  {
    "id": "living_10_angel_5_fireplace_a_tier_1",
    "item_id": "living_10_angel_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_10_angel_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/10_angel/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_10_angel_5_fireplace_a_tier_2",
    "item_id": "living_10_angel_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_10_angel_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/10_angel/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_10_angel_5_fireplace_a_tier_3",
    "item_id": "living_10_angel_5_fireplace_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_10_angel_5_fireplace_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/10_angel/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_10_angel_5_fireplace_a_tier_4",
    "item_id": "living_10_angel_5_fireplace_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/10_angel/01_color_A/04_tier_4/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_10_angel_6_tree_a_tier_1",
    "item_id": "living_10_angel_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_10_angel_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/10_angel/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_10_angel_6_tree_a_tier_2",
    "item_id": "living_10_angel_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_10_angel_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/10_angel/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_10_angel_6_tree_a_tier_3",
    "item_id": "living_10_angel_6_tree_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_10_angel_6_tree_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/10_angel/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_10_angel_6_tree_a_tier_4",
    "item_id": "living_10_angel_6_tree_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/10_angel/01_color_A/04_tier_4/06_tree.png",
    "animated": false
  },
  {
    "id": "living_10_angel_7_couch_a_tier_1",
    "item_id": "living_10_angel_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_10_angel_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/10_angel/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_10_angel_7_couch_a_tier_2",
    "item_id": "living_10_angel_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_10_angel_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/10_angel/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_10_angel_7_couch_a_tier_3",
    "item_id": "living_10_angel_7_couch_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_10_angel_7_couch_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/10_angel/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_10_angel_7_couch_a_tier_4",
    "item_id": "living_10_angel_7_couch_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/10_angel/01_color_A/04_tier_4/07_couch.png",
    "animated": false
  },
  {
    "id": "living_10_angel_8_sidetable_a_tier_1",
    "item_id": "living_10_angel_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_10_angel_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/10_angel/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_10_angel_8_sidetable_a_tier_2",
    "item_id": "living_10_angel_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_10_angel_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/10_angel/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_10_angel_8_sidetable_a_tier_3",
    "item_id": "living_10_angel_8_sidetable_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_10_angel_8_sidetable_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/10_angel/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_10_angel_8_sidetable_a_tier_4",
    "item_id": "living_10_angel_8_sidetable_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/10_angel/01_color_A/04_tier_4/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_11_devil_1_wallpaper_a_tier_1",
    "item_id": "living_11_devil_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_11_devil_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/11_devil/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_11_devil_1_wallpaper_a_tier_2",
    "item_id": "living_11_devil_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_11_devil_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/11_devil/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_11_devil_1_wallpaper_a_tier_3",
    "item_id": "living_11_devil_1_wallpaper_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_11_devil_1_wallpaper_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/11_devil/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_11_devil_1_wallpaper_a_tier_4",
    "item_id": "living_11_devil_1_wallpaper_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/11_devil/01_color_A/04_tier_4/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_11_devil_2_floor_a_tier_1",
    "item_id": "living_11_devil_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_11_devil_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/11_devil/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_11_devil_2_floor_a_tier_2",
    "item_id": "living_11_devil_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_11_devil_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/11_devil/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_11_devil_2_floor_a_tier_3",
    "item_id": "living_11_devil_2_floor_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_11_devil_2_floor_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/11_devil/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_11_devil_2_floor_a_tier_4",
    "item_id": "living_11_devil_2_floor_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/11_devil/01_color_A/04_tier_4/02_floor.png",
    "animated": false
  },
  {
    "id": "living_11_devil_3_above_fireplace_a_tier_1",
    "item_id": "living_11_devil_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_11_devil_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/11_devil/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_11_devil_3_above_fireplace_a_tier_2",
    "item_id": "living_11_devil_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_11_devil_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/11_devil/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_11_devil_3_above_fireplace_a_tier_3",
    "item_id": "living_11_devil_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_11_devil_3_above_fireplace_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/11_devil/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_11_devil_3_above_fireplace_a_tier_4",
    "item_id": "living_11_devil_3_above_fireplace_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/11_devil/01_color_A/04_tier_4/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_11_devil_4_painting_a_tier_1",
    "item_id": "living_11_devil_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_11_devil_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/11_devil/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_11_devil_4_painting_a_tier_2",
    "item_id": "living_11_devil_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_11_devil_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/11_devil/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_11_devil_4_painting_a_tier_3",
    "item_id": "living_11_devil_4_painting_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_11_devil_4_painting_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/11_devil/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_11_devil_4_painting_a_tier_4",
    "item_id": "living_11_devil_4_painting_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/11_devil/01_color_A/04_tier_4/04_painting.png",
    "animated": false
  },
  {
    "id": "living_11_devil_5_fireplace_a_tier_1",
    "item_id": "living_11_devil_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_11_devil_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/11_devil/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_11_devil_5_fireplace_a_tier_2",
    "item_id": "living_11_devil_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_11_devil_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/11_devil/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_11_devil_5_fireplace_a_tier_3",
    "item_id": "living_11_devil_5_fireplace_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_11_devil_5_fireplace_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/11_devil/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_11_devil_5_fireplace_a_tier_4",
    "item_id": "living_11_devil_5_fireplace_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/11_devil/01_color_A/04_tier_4/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_11_devil_6_tree_a_tier_1",
    "item_id": "living_11_devil_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_11_devil_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/11_devil/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_11_devil_6_tree_a_tier_2",
    "item_id": "living_11_devil_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_11_devil_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/11_devil/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_11_devil_6_tree_a_tier_3",
    "item_id": "living_11_devil_6_tree_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_11_devil_6_tree_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/11_devil/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_11_devil_6_tree_a_tier_4",
    "item_id": "living_11_devil_6_tree_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/11_devil/01_color_A/04_tier_4/06_tree.png",
    "animated": false
  },
  {
    "id": "living_11_devil_7_couch_a_tier_1",
    "item_id": "living_11_devil_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_11_devil_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/11_devil/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_11_devil_7_couch_a_tier_2",
    "item_id": "living_11_devil_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_11_devil_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/11_devil/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_11_devil_7_couch_a_tier_3",
    "item_id": "living_11_devil_7_couch_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_11_devil_7_couch_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/11_devil/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_11_devil_7_couch_a_tier_4",
    "item_id": "living_11_devil_7_couch_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/11_devil/01_color_A/04_tier_4/07_couch.png",
    "animated": false
  },
  {
    "id": "living_11_devil_8_sidetable_a_tier_1",
    "item_id": "living_11_devil_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_11_devil_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/11_devil/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_11_devil_8_sidetable_a_tier_2",
    "item_id": "living_11_devil_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_11_devil_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/11_devil/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_11_devil_8_sidetable_a_tier_3",
    "item_id": "living_11_devil_8_sidetable_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_11_devil_8_sidetable_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/11_devil/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_11_devil_8_sidetable_a_tier_4",
    "item_id": "living_11_devil_8_sidetable_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/11_devil/01_color_A/04_tier_4/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_12_hinamatsuri_a1_1_wallpaper_a_tier_1",
    "item_id": "living_12_hinamatsuri_a1_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_12_hinamatsuri_a1_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/12_hinamatsuri_a1/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_12_hinamatsuri_a1_1_wallpaper_a_tier_2",
    "item_id": "living_12_hinamatsuri_a1_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_12_hinamatsuri_a1_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/12_hinamatsuri_a1/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_12_hinamatsuri_a1_1_wallpaper_a_tier_3",
    "item_id": "living_12_hinamatsuri_a1_1_wallpaper_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_12_hinamatsuri_a1_1_wallpaper_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/12_hinamatsuri_a1/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_12_hinamatsuri_a1_1_wallpaper_a_tier_4",
    "item_id": "living_12_hinamatsuri_a1_1_wallpaper_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/12_hinamatsuri_a1/01_color_A/04_tier_4/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_12_hinamatsuri_a1_2_floor_a_tier_1",
    "item_id": "living_12_hinamatsuri_a1_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_12_hinamatsuri_a1_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/12_hinamatsuri_a1/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_12_hinamatsuri_a1_2_floor_a_tier_2",
    "item_id": "living_12_hinamatsuri_a1_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_12_hinamatsuri_a1_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/12_hinamatsuri_a1/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_12_hinamatsuri_a1_2_floor_a_tier_3",
    "item_id": "living_12_hinamatsuri_a1_2_floor_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_12_hinamatsuri_a1_2_floor_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/12_hinamatsuri_a1/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_12_hinamatsuri_a1_2_floor_a_tier_4",
    "item_id": "living_12_hinamatsuri_a1_2_floor_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/12_hinamatsuri_a1/01_color_A/04_tier_4/02_floor.png",
    "animated": false
  },
  {
    "id": "living_12_hinamatsuri_a1_3_above_fireplace_a_tier_1",
    "item_id": "living_12_hinamatsuri_a1_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_12_hinamatsuri_a1_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/12_hinamatsuri_a1/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_12_hinamatsuri_a1_3_above_fireplace_a_tier_2",
    "item_id": "living_12_hinamatsuri_a1_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_12_hinamatsuri_a1_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/12_hinamatsuri_a1/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_12_hinamatsuri_a1_3_above_fireplace_a_tier_3",
    "item_id": "living_12_hinamatsuri_a1_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_12_hinamatsuri_a1_3_above_fireplace_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/12_hinamatsuri_a1/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_12_hinamatsuri_a1_3_above_fireplace_a_tier_4",
    "item_id": "living_12_hinamatsuri_a1_3_above_fireplace_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/12_hinamatsuri_a1/01_color_A/04_tier_4/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_12_hinamatsuri_a1_4_painting_a_tier_1",
    "item_id": "living_12_hinamatsuri_a1_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_12_hinamatsuri_a1_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/12_hinamatsuri_a1/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_12_hinamatsuri_a1_4_painting_a_tier_2",
    "item_id": "living_12_hinamatsuri_a1_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_12_hinamatsuri_a1_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/12_hinamatsuri_a1/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_12_hinamatsuri_a1_4_painting_a_tier_3",
    "item_id": "living_12_hinamatsuri_a1_4_painting_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_12_hinamatsuri_a1_4_painting_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/12_hinamatsuri_a1/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_12_hinamatsuri_a1_4_painting_a_tier_4",
    "item_id": "living_12_hinamatsuri_a1_4_painting_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/12_hinamatsuri_a1/01_color_A/04_tier_4/04_painting.png",
    "animated": false
  },
  {
    "id": "living_12_hinamatsuri_a1_5_fireplace_a_tier_1",
    "item_id": "living_12_hinamatsuri_a1_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_12_hinamatsuri_a1_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/12_hinamatsuri_a1/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_12_hinamatsuri_a1_5_fireplace_a_tier_2",
    "item_id": "living_12_hinamatsuri_a1_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_12_hinamatsuri_a1_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/12_hinamatsuri_a1/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_12_hinamatsuri_a1_5_fireplace_a_tier_3",
    "item_id": "living_12_hinamatsuri_a1_5_fireplace_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_12_hinamatsuri_a1_5_fireplace_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/12_hinamatsuri_a1/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_12_hinamatsuri_a1_5_fireplace_a_tier_4",
    "item_id": "living_12_hinamatsuri_a1_5_fireplace_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/12_hinamatsuri_a1/01_color_A/04_tier_4/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_12_hinamatsuri_a1_6_tree_a_tier_1",
    "item_id": "living_12_hinamatsuri_a1_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_12_hinamatsuri_a1_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/12_hinamatsuri_a1/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_12_hinamatsuri_a1_6_tree_a_tier_2",
    "item_id": "living_12_hinamatsuri_a1_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_12_hinamatsuri_a1_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/12_hinamatsuri_a1/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_12_hinamatsuri_a1_6_tree_a_tier_3",
    "item_id": "living_12_hinamatsuri_a1_6_tree_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_12_hinamatsuri_a1_6_tree_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/12_hinamatsuri_a1/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_12_hinamatsuri_a1_6_tree_a_tier_4",
    "item_id": "living_12_hinamatsuri_a1_6_tree_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/12_hinamatsuri_a1/01_color_A/04_tier_4/06_tree.png",
    "animated": false
  },
  {
    "id": "living_12_hinamatsuri_a1_7_couch_a_tier_1",
    "item_id": "living_12_hinamatsuri_a1_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_12_hinamatsuri_a1_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/12_hinamatsuri_a1/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_12_hinamatsuri_a1_7_couch_a_tier_2",
    "item_id": "living_12_hinamatsuri_a1_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_12_hinamatsuri_a1_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/12_hinamatsuri_a1/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_12_hinamatsuri_a1_7_couch_a_tier_3",
    "item_id": "living_12_hinamatsuri_a1_7_couch_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_12_hinamatsuri_a1_7_couch_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/12_hinamatsuri_a1/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_12_hinamatsuri_a1_7_couch_a_tier_4",
    "item_id": "living_12_hinamatsuri_a1_7_couch_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/12_hinamatsuri_a1/01_color_A/04_tier_4/07_couch.png",
    "animated": false
  },
  {
    "id": "living_12_hinamatsuri_a1_8_sidetable_a_tier_1",
    "item_id": "living_12_hinamatsuri_a1_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_12_hinamatsuri_a1_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/12_hinamatsuri_a1/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_12_hinamatsuri_a1_8_sidetable_a_tier_2",
    "item_id": "living_12_hinamatsuri_a1_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_12_hinamatsuri_a1_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/12_hinamatsuri_a1/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_12_hinamatsuri_a1_8_sidetable_a_tier_3",
    "item_id": "living_12_hinamatsuri_a1_8_sidetable_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_12_hinamatsuri_a1_8_sidetable_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/12_hinamatsuri_a1/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_12_hinamatsuri_a1_8_sidetable_a_tier_4",
    "item_id": "living_12_hinamatsuri_a1_8_sidetable_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/12_hinamatsuri_a1/01_color_A/04_tier_4/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_13_hinamatsuri_a2_1_wallpaper_a_tier_1",
    "item_id": "living_13_hinamatsuri_a2_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_13_hinamatsuri_a2_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/13_hinamatsuri_a2/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_13_hinamatsuri_a2_1_wallpaper_a_tier_2",
    "item_id": "living_13_hinamatsuri_a2_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_13_hinamatsuri_a2_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/13_hinamatsuri_a2/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_13_hinamatsuri_a2_1_wallpaper_a_tier_3",
    "item_id": "living_13_hinamatsuri_a2_1_wallpaper_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_13_hinamatsuri_a2_1_wallpaper_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/13_hinamatsuri_a2/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_13_hinamatsuri_a2_1_wallpaper_a_tier_4",
    "item_id": "living_13_hinamatsuri_a2_1_wallpaper_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/13_hinamatsuri_a2/01_color_A/04_tier_4/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_13_hinamatsuri_a2_2_floor_a_tier_1",
    "item_id": "living_13_hinamatsuri_a2_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_13_hinamatsuri_a2_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/13_hinamatsuri_a2/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_13_hinamatsuri_a2_2_floor_a_tier_2",
    "item_id": "living_13_hinamatsuri_a2_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_13_hinamatsuri_a2_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/13_hinamatsuri_a2/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_13_hinamatsuri_a2_2_floor_a_tier_3",
    "item_id": "living_13_hinamatsuri_a2_2_floor_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_13_hinamatsuri_a2_2_floor_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/13_hinamatsuri_a2/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_13_hinamatsuri_a2_2_floor_a_tier_4",
    "item_id": "living_13_hinamatsuri_a2_2_floor_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/13_hinamatsuri_a2/01_color_A/04_tier_4/02_floor.png",
    "animated": false
  },
  {
    "id": "living_13_hinamatsuri_a2_3_above_fireplace_a_tier_1",
    "item_id": "living_13_hinamatsuri_a2_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_13_hinamatsuri_a2_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/13_hinamatsuri_a2/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_13_hinamatsuri_a2_3_above_fireplace_a_tier_2",
    "item_id": "living_13_hinamatsuri_a2_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_13_hinamatsuri_a2_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/13_hinamatsuri_a2/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_13_hinamatsuri_a2_3_above_fireplace_a_tier_3",
    "item_id": "living_13_hinamatsuri_a2_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_13_hinamatsuri_a2_3_above_fireplace_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/13_hinamatsuri_a2/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_13_hinamatsuri_a2_3_above_fireplace_a_tier_4",
    "item_id": "living_13_hinamatsuri_a2_3_above_fireplace_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/13_hinamatsuri_a2/01_color_A/04_tier_4/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_13_hinamatsuri_a2_4_painting_a_tier_1",
    "item_id": "living_13_hinamatsuri_a2_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_13_hinamatsuri_a2_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/13_hinamatsuri_a2/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_13_hinamatsuri_a2_4_painting_a_tier_2",
    "item_id": "living_13_hinamatsuri_a2_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_13_hinamatsuri_a2_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/13_hinamatsuri_a2/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_13_hinamatsuri_a2_4_painting_a_tier_3",
    "item_id": "living_13_hinamatsuri_a2_4_painting_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_13_hinamatsuri_a2_4_painting_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/13_hinamatsuri_a2/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_13_hinamatsuri_a2_4_painting_a_tier_4",
    "item_id": "living_13_hinamatsuri_a2_4_painting_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/13_hinamatsuri_a2/01_color_A/04_tier_4/04_painting.png",
    "animated": false
  },
  {
    "id": "living_13_hinamatsuri_a2_5_fireplace_a_tier_1",
    "item_id": "living_13_hinamatsuri_a2_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_13_hinamatsuri_a2_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/13_hinamatsuri_a2/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_13_hinamatsuri_a2_5_fireplace_a_tier_2",
    "item_id": "living_13_hinamatsuri_a2_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_13_hinamatsuri_a2_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/13_hinamatsuri_a2/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_13_hinamatsuri_a2_5_fireplace_a_tier_3",
    "item_id": "living_13_hinamatsuri_a2_5_fireplace_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_13_hinamatsuri_a2_5_fireplace_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/13_hinamatsuri_a2/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_13_hinamatsuri_a2_5_fireplace_a_tier_4",
    "item_id": "living_13_hinamatsuri_a2_5_fireplace_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/13_hinamatsuri_a2/01_color_A/04_tier_4/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_13_hinamatsuri_a2_6_tree_a_tier_1",
    "item_id": "living_13_hinamatsuri_a2_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_13_hinamatsuri_a2_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/13_hinamatsuri_a2/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_13_hinamatsuri_a2_6_tree_a_tier_2",
    "item_id": "living_13_hinamatsuri_a2_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_13_hinamatsuri_a2_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/13_hinamatsuri_a2/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_13_hinamatsuri_a2_6_tree_a_tier_3",
    "item_id": "living_13_hinamatsuri_a2_6_tree_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_13_hinamatsuri_a2_6_tree_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/13_hinamatsuri_a2/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_13_hinamatsuri_a2_6_tree_a_tier_4",
    "item_id": "living_13_hinamatsuri_a2_6_tree_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/13_hinamatsuri_a2/01_color_A/04_tier_4/06_tree.png",
    "animated": false
  },
  {
    "id": "living_13_hinamatsuri_a2_7_couch_a_tier_1",
    "item_id": "living_13_hinamatsuri_a2_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_13_hinamatsuri_a2_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/13_hinamatsuri_a2/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_13_hinamatsuri_a2_7_couch_a_tier_2",
    "item_id": "living_13_hinamatsuri_a2_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_13_hinamatsuri_a2_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/13_hinamatsuri_a2/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_13_hinamatsuri_a2_7_couch_a_tier_3",
    "item_id": "living_13_hinamatsuri_a2_7_couch_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_13_hinamatsuri_a2_7_couch_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/13_hinamatsuri_a2/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_13_hinamatsuri_a2_7_couch_a_tier_4",
    "item_id": "living_13_hinamatsuri_a2_7_couch_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/13_hinamatsuri_a2/01_color_A/04_tier_4/07_couch.png",
    "animated": false
  },
  {
    "id": "living_13_hinamatsuri_a2_8_sidetable_a_tier_1",
    "item_id": "living_13_hinamatsuri_a2_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_13_hinamatsuri_a2_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/13_hinamatsuri_a2/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_13_hinamatsuri_a2_8_sidetable_a_tier_2",
    "item_id": "living_13_hinamatsuri_a2_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_13_hinamatsuri_a2_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/13_hinamatsuri_a2/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_13_hinamatsuri_a2_8_sidetable_a_tier_3",
    "item_id": "living_13_hinamatsuri_a2_8_sidetable_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_13_hinamatsuri_a2_8_sidetable_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/13_hinamatsuri_a2/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_13_hinamatsuri_a2_8_sidetable_a_tier_4",
    "item_id": "living_13_hinamatsuri_a2_8_sidetable_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/13_hinamatsuri_a2/01_color_A/04_tier_4/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_14_whiteday_1_wallpaper_a_tier_1",
    "item_id": "living_14_whiteday_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_14_whiteday_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/14_whiteday/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_14_whiteday_1_wallpaper_a_tier_2",
    "item_id": "living_14_whiteday_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_14_whiteday_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/14_whiteday/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_14_whiteday_1_wallpaper_a_tier_3",
    "item_id": "living_14_whiteday_1_wallpaper_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_14_whiteday_1_wallpaper_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/14_whiteday/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_14_whiteday_1_wallpaper_a_tier_4",
    "item_id": "living_14_whiteday_1_wallpaper_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/14_whiteday/01_color_A/04_tier_4/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_14_whiteday_2_floor_a_tier_1",
    "item_id": "living_14_whiteday_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_14_whiteday_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/14_whiteday/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_14_whiteday_2_floor_a_tier_2",
    "item_id": "living_14_whiteday_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_14_whiteday_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/14_whiteday/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_14_whiteday_2_floor_a_tier_3",
    "item_id": "living_14_whiteday_2_floor_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_14_whiteday_2_floor_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/14_whiteday/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_14_whiteday_2_floor_a_tier_4",
    "item_id": "living_14_whiteday_2_floor_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/14_whiteday/01_color_A/04_tier_4/02_floor.png",
    "animated": false
  },
  {
    "id": "living_14_whiteday_3_above_fireplace_a_tier_1",
    "item_id": "living_14_whiteday_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_14_whiteday_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/14_whiteday/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_14_whiteday_3_above_fireplace_a_tier_2",
    "item_id": "living_14_whiteday_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_14_whiteday_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/14_whiteday/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_14_whiteday_3_above_fireplace_a_tier_3",
    "item_id": "living_14_whiteday_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_14_whiteday_3_above_fireplace_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/14_whiteday/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_14_whiteday_3_above_fireplace_a_tier_4",
    "item_id": "living_14_whiteday_3_above_fireplace_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/14_whiteday/01_color_A/04_tier_4/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_14_whiteday_4_painting_a_tier_1",
    "item_id": "living_14_whiteday_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_14_whiteday_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/14_whiteday/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_14_whiteday_4_painting_a_tier_2",
    "item_id": "living_14_whiteday_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_14_whiteday_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/14_whiteday/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_14_whiteday_4_painting_a_tier_3",
    "item_id": "living_14_whiteday_4_painting_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_14_whiteday_4_painting_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/14_whiteday/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_14_whiteday_4_painting_a_tier_4",
    "item_id": "living_14_whiteday_4_painting_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/14_whiteday/01_color_A/04_tier_4/04_painting.png",
    "animated": false
  },
  {
    "id": "living_14_whiteday_5_fireplace_a_tier_1",
    "item_id": "living_14_whiteday_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_14_whiteday_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/14_whiteday/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_14_whiteday_5_fireplace_a_tier_2",
    "item_id": "living_14_whiteday_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_14_whiteday_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/14_whiteday/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_14_whiteday_5_fireplace_a_tier_3",
    "item_id": "living_14_whiteday_5_fireplace_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_14_whiteday_5_fireplace_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/14_whiteday/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_14_whiteday_5_fireplace_a_tier_4",
    "item_id": "living_14_whiteday_5_fireplace_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/14_whiteday/01_color_A/04_tier_4/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_14_whiteday_6_tree_a_tier_1",
    "item_id": "living_14_whiteday_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_14_whiteday_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/14_whiteday/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_14_whiteday_6_tree_a_tier_2",
    "item_id": "living_14_whiteday_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_14_whiteday_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/14_whiteday/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_14_whiteday_6_tree_a_tier_3",
    "item_id": "living_14_whiteday_6_tree_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_14_whiteday_6_tree_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/14_whiteday/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_14_whiteday_6_tree_a_tier_4",
    "item_id": "living_14_whiteday_6_tree_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/14_whiteday/01_color_A/04_tier_4/06_tree.png",
    "animated": false
  },
  {
    "id": "living_14_whiteday_7_couch_a_tier_1",
    "item_id": "living_14_whiteday_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_14_whiteday_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/14_whiteday/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_14_whiteday_7_couch_a_tier_2",
    "item_id": "living_14_whiteday_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_14_whiteday_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/14_whiteday/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_14_whiteday_7_couch_a_tier_3",
    "item_id": "living_14_whiteday_7_couch_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_14_whiteday_7_couch_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/14_whiteday/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_14_whiteday_7_couch_a_tier_4",
    "item_id": "living_14_whiteday_7_couch_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/14_whiteday/01_color_A/04_tier_4/07_couch.png",
    "animated": false
  },
  {
    "id": "living_14_whiteday_8_sidetable_a_tier_1",
    "item_id": "living_14_whiteday_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_14_whiteday_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/14_whiteday/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_14_whiteday_8_sidetable_a_tier_2",
    "item_id": "living_14_whiteday_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_14_whiteday_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/14_whiteday/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_14_whiteday_8_sidetable_a_tier_3",
    "item_id": "living_14_whiteday_8_sidetable_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_14_whiteday_8_sidetable_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/14_whiteday/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_14_whiteday_8_sidetable_a_tier_4",
    "item_id": "living_14_whiteday_8_sidetable_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/14_whiteday/01_color_A/04_tier_4/08_sidetable.png",
    "animated": false
  },
  {
    "id": "toilet_01_default_theme_3_empty_na_tier_1",
    "item_id": "toilet_01_default_theme_3_empty_na",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "toilet_01_default_theme_3_empty_na_tier_2",
    "can_sell": false,
    "animated": false
  },
  {
    "id": "toilet_01_default_theme_5_empty_na_tier_1",
    "item_id": "toilet_01_default_theme_5_empty_na",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "toilet_01_default_theme_5_empty_na_tier_2",
    "can_sell": false,
    "animated": false
  },
  {
    "id": "toilet_01_default_theme_3_empty_na_tier_2",
    "item_id": "toilet_01_default_theme_3_empty_na",
    "tier": 2,
    "can_fuse": false,
    "can_sell": false,
    "animated": false
  },
  {
    "id": "toilet_01_default_theme_5_empty_na_tier_2",
    "item_id": "toilet_01_default_theme_5_empty_na",
    "tier": 2,
    "can_fuse": false,
    "can_sell": false,
    "animated": false
  },
  {
    "id": "toilet_02_deep_ocean_1_wallpaper_a_tier_1",
    "item_id": "toilet_02_deep_ocean_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "toilet_02_deep_ocean_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "04_toilet_room/02_deep_ocean/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "toilet_02_deep_ocean_2_floor_a_tier_1",
    "item_id": "toilet_02_deep_ocean_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "toilet_02_deep_ocean_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "04_toilet_room/02_deep_ocean/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "toilet_02_deep_ocean_3_arch_a_tier_1",
    "item_id": "toilet_02_deep_ocean_3_arch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "toilet_02_deep_ocean_3_arch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "04_toilet_room/02_deep_ocean/01_color_A/01_tier_1/03_arch.png",
    "animated": false
  },
  {
    "id": "toilet_02_deep_ocean_4_toilet_a_tier_1",
    "item_id": "toilet_02_deep_ocean_4_toilet_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "toilet_02_deep_ocean_4_toilet_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "04_toilet_room/02_deep_ocean/01_color_A/01_tier_1/04_toilet.png",
    "animated": false
  },
  {
    "id": "toilet_02_deep_ocean_5_toilet_ornament_a_tier_1",
    "item_id": "toilet_02_deep_ocean_5_toilet_ornament_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "toilet_02_deep_ocean_5_toilet_ornament_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "04_toilet_room/02_deep_ocean/01_color_A/01_tier_1/05_toilet_ornament.png",
    "animated": false
  },
  {
    "id": "toilet_02_deep_ocean_1_wallpaper_a_tier_2",
    "item_id": "toilet_02_deep_ocean_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "toilet_02_deep_ocean_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "04_toilet_room/02_deep_ocean/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "toilet_02_deep_ocean_2_floor_a_tier_2",
    "item_id": "toilet_02_deep_ocean_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "toilet_02_deep_ocean_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "04_toilet_room/02_deep_ocean/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "toilet_02_deep_ocean_3_arch_a_tier_2",
    "item_id": "toilet_02_deep_ocean_3_arch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "toilet_02_deep_ocean_3_arch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "04_toilet_room/02_deep_ocean/01_color_A/02_tier_2/03_arch.png",
    "animated": false
  },
  {
    "id": "toilet_02_deep_ocean_4_toilet_a_tier_2",
    "item_id": "toilet_02_deep_ocean_4_toilet_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "toilet_02_deep_ocean_4_toilet_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "04_toilet_room/02_deep_ocean/01_color_A/02_tier_2/04_toilet.png",
    "animated": false
  },
  {
    "id": "toilet_02_deep_ocean_5_toilet_ornament_a_tier_2",
    "item_id": "toilet_02_deep_ocean_5_toilet_ornament_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "toilet_02_deep_ocean_5_toilet_ornament_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "04_toilet_room/02_deep_ocean/01_color_A/02_tier_2/05_toilet_ornament.png",
    "animated": false
  },
  {
    "id": "toilet_02_deep_ocean_1_wallpaper_a_tier_3",
    "item_id": "toilet_02_deep_ocean_1_wallpaper_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "04_toilet_room/02_deep_ocean/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "toilet_02_deep_ocean_2_floor_a_tier_3",
    "item_id": "toilet_02_deep_ocean_2_floor_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "04_toilet_room/02_deep_ocean/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "toilet_02_deep_ocean_3_arch_a_tier_3",
    "item_id": "toilet_02_deep_ocean_3_arch_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "04_toilet_room/02_deep_ocean/01_color_A/03_tier_3/03_arch.png",
    "animated": false
  },
  {
    "id": "toilet_02_deep_ocean_4_toilet_a_tier_3",
    "item_id": "toilet_02_deep_ocean_4_toilet_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "04_toilet_room/02_deep_ocean/01_color_A/03_tier_3/04_toilet.png",
    "animated": false
  },
  {
    "id": "toilet_02_deep_ocean_5_toilet_ornament_a_tier_3",
    "item_id": "toilet_02_deep_ocean_5_toilet_ornament_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "04_toilet_room/02_deep_ocean/01_color_A/03_tier_3/05_toilet_ornament.png",
    "animated": false
  },
  {
    "id": "toilet_03_fresh_forrest_1_wallpaper_a_tier_1",
    "item_id": "toilet_03_fresh_forrest_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "toilet_03_fresh_forrest_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "04_toilet_room/03_fresh_forrest/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "toilet_03_fresh_forrest_2_floor_a_tier_1",
    "item_id": "toilet_03_fresh_forrest_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "toilet_03_fresh_forrest_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "04_toilet_room/03_fresh_forrest/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "toilet_03_fresh_forrest_3_arch_a_tier_1",
    "item_id": "toilet_03_fresh_forrest_3_arch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "toilet_03_fresh_forrest_3_arch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "04_toilet_room/03_fresh_forrest/01_color_A/01_tier_1/03_arch.png",
    "animated": false
  },
  {
    "id": "toilet_03_fresh_forrest_4_toilet_a_tier_1",
    "item_id": "toilet_03_fresh_forrest_4_toilet_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "toilet_03_fresh_forrest_4_toilet_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "04_toilet_room/03_fresh_forrest/01_color_A/01_tier_1/04_toilet.png",
    "animated": false
  },
  {
    "id": "toilet_03_fresh_forrest_5_toilet_ornament_a_tier_1",
    "item_id": "toilet_03_fresh_forrest_5_toilet_ornament_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "toilet_03_fresh_forrest_5_toilet_ornament_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "04_toilet_room/03_fresh_forrest/01_color_A/01_tier_1/05_toilet_ornament.png",
    "animated": false
  },
  {
    "id": "toilet_03_fresh_forrest_1_wallpaper_a_tier_2",
    "item_id": "toilet_03_fresh_forrest_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "toilet_03_fresh_forrest_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "04_toilet_room/03_fresh_forrest/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "toilet_03_fresh_forrest_2_floor_a_tier_2",
    "item_id": "toilet_03_fresh_forrest_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "toilet_03_fresh_forrest_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "04_toilet_room/03_fresh_forrest/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "toilet_03_fresh_forrest_3_arch_a_tier_2",
    "item_id": "toilet_03_fresh_forrest_3_arch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "toilet_03_fresh_forrest_3_arch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "04_toilet_room/03_fresh_forrest/01_color_A/02_tier_2/03_arch.png",
    "animated": false
  },
  {
    "id": "toilet_03_fresh_forrest_4_toilet_a_tier_2",
    "item_id": "toilet_03_fresh_forrest_4_toilet_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "toilet_03_fresh_forrest_4_toilet_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "04_toilet_room/03_fresh_forrest/01_color_A/02_tier_2/04_toilet.png",
    "animated": false
  },
  {
    "id": "toilet_03_fresh_forrest_5_toilet_ornament_a_tier_2",
    "item_id": "toilet_03_fresh_forrest_5_toilet_ornament_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "toilet_03_fresh_forrest_5_toilet_ornament_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "04_toilet_room/03_fresh_forrest/01_color_A/02_tier_2/05_toilet_ornament.png",
    "animated": false
  },
  {
    "id": "toilet_03_fresh_forrest_1_wallpaper_a_tier_3",
    "item_id": "toilet_03_fresh_forrest_1_wallpaper_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "04_toilet_room/03_fresh_forrest/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "toilet_03_fresh_forrest_2_floor_a_tier_3",
    "item_id": "toilet_03_fresh_forrest_2_floor_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "04_toilet_room/03_fresh_forrest/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "toilet_03_fresh_forrest_3_arch_a_tier_3",
    "item_id": "toilet_03_fresh_forrest_3_arch_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "04_toilet_room/03_fresh_forrest/01_color_A/03_tier_3/03_arch.png",
    "animated": false
  },
  {
    "id": "toilet_03_fresh_forrest_4_toilet_a_tier_3",
    "item_id": "toilet_03_fresh_forrest_4_toilet_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "04_toilet_room/03_fresh_forrest/01_color_A/03_tier_3/04_toilet.png",
    "animated": false
  },
  {
    "id": "toilet_03_fresh_forrest_5_toilet_ornament_a_tier_3",
    "item_id": "toilet_03_fresh_forrest_5_toilet_ornament_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "04_toilet_room/03_fresh_forrest/01_color_A/03_tier_3/05_toilet_ornament.png",
    "animated": false
  },
  {
    "id": "toilet_04_valentine_day_1_wallpaper_a_tier_1",
    "item_id": "toilet_04_valentine_day_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "toilet_04_valentine_day_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "04_toilet_room/04_valentine_day/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "toilet_04_valentine_day_2_floor_a_tier_1",
    "item_id": "toilet_04_valentine_day_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "toilet_04_valentine_day_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "04_toilet_room/04_valentine_day/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "toilet_04_valentine_day_3_arch_a_tier_1",
    "item_id": "toilet_04_valentine_day_3_arch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "toilet_04_valentine_day_3_arch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "04_toilet_room/04_valentine_day/01_color_A/01_tier_1/03_arch.png",
    "animated": false
  },
  {
    "id": "toilet_04_valentine_day_4_toilet_a_tier_1",
    "item_id": "toilet_04_valentine_day_4_toilet_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "toilet_04_valentine_day_4_toilet_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "04_toilet_room/04_valentine_day/01_color_A/01_tier_1/04_toilet.png",
    "animated": false
  },
  {
    "id": "toilet_04_valentine_day_5_toilet_ornament_a_tier_1",
    "item_id": "toilet_04_valentine_day_5_toilet_ornament_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "toilet_04_valentine_day_5_toilet_ornament_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "04_toilet_room/04_valentine_day/01_color_A/01_tier_1/05_toilet_ornament.png",
    "animated": false
  },
  {
    "id": "toilet_04_valentine_day_1_wallpaper_a_tier_2",
    "item_id": "toilet_04_valentine_day_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "toilet_04_valentine_day_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "04_toilet_room/04_valentine_day/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "toilet_04_valentine_day_2_floor_a_tier_2",
    "item_id": "toilet_04_valentine_day_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "toilet_04_valentine_day_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "04_toilet_room/04_valentine_day/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "toilet_04_valentine_day_3_arch_a_tier_2",
    "item_id": "toilet_04_valentine_day_3_arch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "toilet_04_valentine_day_3_arch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "04_toilet_room/04_valentine_day/01_color_A/02_tier_2/03_arch.png",
    "animated": false
  },
  {
    "id": "toilet_04_valentine_day_4_toilet_a_tier_2",
    "item_id": "toilet_04_valentine_day_4_toilet_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "toilet_04_valentine_day_4_toilet_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "04_toilet_room/04_valentine_day/01_color_A/02_tier_2/04_toilet.png",
    "animated": false
  },
  {
    "id": "toilet_04_valentine_day_5_toilet_ornament_a_tier_2",
    "item_id": "toilet_04_valentine_day_5_toilet_ornament_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "toilet_04_valentine_day_5_toilet_ornament_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "04_toilet_room/04_valentine_day/01_color_A/02_tier_2/05_toilet_ornament.png",
    "animated": false
  },
  {
    "id": "toilet_04_valentine_day_1_wallpaper_a_tier_3",
    "item_id": "toilet_04_valentine_day_1_wallpaper_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "toilet_04_valentine_day_1_wallpaper_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "04_toilet_room/04_valentine_day/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "toilet_04_valentine_day_2_floor_a_tier_3",
    "item_id": "toilet_04_valentine_day_2_floor_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "toilet_04_valentine_day_2_floor_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "04_toilet_room/04_valentine_day/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "toilet_04_valentine_day_3_arch_a_tier_3",
    "item_id": "toilet_04_valentine_day_3_arch_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "toilet_04_valentine_day_3_arch_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "04_toilet_room/04_valentine_day/01_color_A/03_tier_3/03_arch.png",
    "animated": false
  },
  {
    "id": "toilet_04_valentine_day_4_toilet_a_tier_3",
    "item_id": "toilet_04_valentine_day_4_toilet_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "toilet_04_valentine_day_4_toilet_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "04_toilet_room/04_valentine_day/01_color_A/03_tier_3/04_toilet.png",
    "animated": false
  },
  {
    "id": "toilet_04_valentine_day_5_toilet_ornament_a_tier_3",
    "item_id": "toilet_04_valentine_day_5_toilet_ornament_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "toilet_04_valentine_day_5_toilet_ornament_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "04_toilet_room/04_valentine_day/01_color_A/03_tier_3/05_toilet_ornament.png",
    "animated": false
  },
  {
    "id": "toilet_04_valentine_day_1_wallpaper_a_tier_4",
    "item_id": "toilet_04_valentine_day_1_wallpaper_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "04_toilet_room/04_valentine_day/01_color_A/04_tier_4/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "toilet_04_valentine_day_2_floor_a_tier_4",
    "item_id": "toilet_04_valentine_day_2_floor_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "04_toilet_room/04_valentine_day/01_color_A/04_tier_4/02_floor.png",
    "animated": false
  },
  {
    "id": "toilet_04_valentine_day_3_arch_a_tier_4",
    "item_id": "toilet_04_valentine_day_3_arch_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "04_toilet_room/04_valentine_day/01_color_A/04_tier_4/03_arch.png",
    "animated": false
  },
  {
    "id": "toilet_04_valentine_day_4_toilet_a_tier_4",
    "item_id": "toilet_04_valentine_day_4_toilet_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "04_toilet_room/04_valentine_day/01_color_A/04_tier_4/04_toilet.png",
    "animated": false
  },
  {
    "id": "toilet_04_valentine_day_5_toilet_ornament_a_tier_4",
    "item_id": "toilet_04_valentine_day_5_toilet_ornament_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "04_toilet_room/04_valentine_day/01_color_A/04_tier_4/05_toilet_ornament.png",
    "animated": false
  },
  {
    "id": "living_15_rainy_frogs_1_wallpaper_a_tier_1",
    "item_id": "living_15_rainy_frogs_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_15_rainy_frogs_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/15_rainy_frogs/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_15_rainy_frogs_1_wallpaper_a_tier_2",
    "item_id": "living_15_rainy_frogs_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_15_rainy_frogs_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/15_rainy_frogs/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_15_rainy_frogs_1_wallpaper_a_tier_3",
    "item_id": "living_15_rainy_frogs_1_wallpaper_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_15_rainy_frogs_1_wallpaper_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/15_rainy_frogs/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_15_rainy_frogs_1_wallpaper_a_tier_4",
    "item_id": "living_15_rainy_frogs_1_wallpaper_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/15_rainy_frogs/01_color_A/04_tier_4/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_15_rainy_frogs_2_floor_a_tier_1",
    "item_id": "living_15_rainy_frogs_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_15_rainy_frogs_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/15_rainy_frogs/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_15_rainy_frogs_2_floor_a_tier_2",
    "item_id": "living_15_rainy_frogs_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_15_rainy_frogs_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/15_rainy_frogs/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_15_rainy_frogs_2_floor_a_tier_3",
    "item_id": "living_15_rainy_frogs_2_floor_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_15_rainy_frogs_2_floor_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/15_rainy_frogs/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_15_rainy_frogs_2_floor_a_tier_4",
    "item_id": "living_15_rainy_frogs_2_floor_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/15_rainy_frogs/01_color_A/04_tier_4/02_floor.png",
    "animated": false
  },
  {
    "id": "living_15_rainy_frogs_3_above_fireplace_a_tier_1",
    "item_id": "living_15_rainy_frogs_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_15_rainy_frogs_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/15_rainy_frogs/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_15_rainy_frogs_3_above_fireplace_a_tier_2",
    "item_id": "living_15_rainy_frogs_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_15_rainy_frogs_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/15_rainy_frogs/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_15_rainy_frogs_3_above_fireplace_a_tier_3",
    "item_id": "living_15_rainy_frogs_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_15_rainy_frogs_3_above_fireplace_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/15_rainy_frogs/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_15_rainy_frogs_3_above_fireplace_a_tier_4",
    "item_id": "living_15_rainy_frogs_3_above_fireplace_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/15_rainy_frogs/01_color_A/04_tier_4/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_15_rainy_frogs_4_painting_a_tier_1",
    "item_id": "living_15_rainy_frogs_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_15_rainy_frogs_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/15_rainy_frogs/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_15_rainy_frogs_4_painting_a_tier_2",
    "item_id": "living_15_rainy_frogs_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_15_rainy_frogs_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/15_rainy_frogs/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_15_rainy_frogs_4_painting_a_tier_3",
    "item_id": "living_15_rainy_frogs_4_painting_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_15_rainy_frogs_4_painting_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/15_rainy_frogs/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_15_rainy_frogs_4_painting_a_tier_4",
    "item_id": "living_15_rainy_frogs_4_painting_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/15_rainy_frogs/01_color_A/04_tier_4/04_painting.png",
    "animated": false
  },
  {
    "id": "living_15_rainy_frogs_5_fireplace_a_tier_1",
    "item_id": "living_15_rainy_frogs_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_15_rainy_frogs_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/15_rainy_frogs/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_15_rainy_frogs_5_fireplace_a_tier_2",
    "item_id": "living_15_rainy_frogs_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_15_rainy_frogs_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/15_rainy_frogs/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_15_rainy_frogs_5_fireplace_a_tier_3",
    "item_id": "living_15_rainy_frogs_5_fireplace_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_15_rainy_frogs_5_fireplace_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/15_rainy_frogs/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_15_rainy_frogs_5_fireplace_a_tier_4",
    "item_id": "living_15_rainy_frogs_5_fireplace_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/15_rainy_frogs/01_color_A/04_tier_4/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_15_rainy_frogs_6_tree_a_tier_1",
    "item_id": "living_15_rainy_frogs_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_15_rainy_frogs_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/15_rainy_frogs/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_15_rainy_frogs_6_tree_a_tier_2",
    "item_id": "living_15_rainy_frogs_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_15_rainy_frogs_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/15_rainy_frogs/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_15_rainy_frogs_6_tree_a_tier_3",
    "item_id": "living_15_rainy_frogs_6_tree_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_15_rainy_frogs_6_tree_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/15_rainy_frogs/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_15_rainy_frogs_6_tree_a_tier_4",
    "item_id": "living_15_rainy_frogs_6_tree_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/15_rainy_frogs/01_color_A/04_tier_4/06_tree.png",
    "animated": false
  },
  {
    "id": "living_15_rainy_frogs_7_couch_a_tier_1",
    "item_id": "living_15_rainy_frogs_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_15_rainy_frogs_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/15_rainy_frogs/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_15_rainy_frogs_7_couch_a_tier_2",
    "item_id": "living_15_rainy_frogs_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_15_rainy_frogs_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/15_rainy_frogs/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_15_rainy_frogs_7_couch_a_tier_3",
    "item_id": "living_15_rainy_frogs_7_couch_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_15_rainy_frogs_7_couch_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/15_rainy_frogs/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_15_rainy_frogs_7_couch_a_tier_4",
    "item_id": "living_15_rainy_frogs_7_couch_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/15_rainy_frogs/01_color_A/04_tier_4/07_couch.png",
    "animated": false
  },
  {
    "id": "living_15_rainy_frogs_8_sidetable_a_tier_1",
    "item_id": "living_15_rainy_frogs_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_15_rainy_frogs_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/15_rainy_frogs/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_15_rainy_frogs_8_sidetable_a_tier_2",
    "item_id": "living_15_rainy_frogs_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_15_rainy_frogs_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/15_rainy_frogs/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_15_rainy_frogs_8_sidetable_a_tier_3",
    "item_id": "living_15_rainy_frogs_8_sidetable_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_15_rainy_frogs_8_sidetable_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/15_rainy_frogs/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_15_rainy_frogs_8_sidetable_a_tier_4",
    "item_id": "living_15_rainy_frogs_8_sidetable_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/15_rainy_frogs/01_color_A/04_tier_4/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_16_milky_cow_1_wallpaper_a_tier_1",
    "item_id": "living_16_milky_cow_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_16_milky_cow_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/16_milky_cow/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_16_milky_cow_1_wallpaper_a_tier_2",
    "item_id": "living_16_milky_cow_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_16_milky_cow_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/16_milky_cow/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_16_milky_cow_1_wallpaper_a_tier_3",
    "item_id": "living_16_milky_cow_1_wallpaper_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_16_milky_cow_1_wallpaper_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/16_milky_cow/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_16_milky_cow_1_wallpaper_a_tier_4",
    "item_id": "living_16_milky_cow_1_wallpaper_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/16_milky_cow/01_color_A/04_tier_4/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_16_milky_cow_2_floor_a_tier_1",
    "item_id": "living_16_milky_cow_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_16_milky_cow_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/16_milky_cow/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_16_milky_cow_2_floor_a_tier_2",
    "item_id": "living_16_milky_cow_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_16_milky_cow_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/16_milky_cow/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_16_milky_cow_2_floor_a_tier_3",
    "item_id": "living_16_milky_cow_2_floor_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_16_milky_cow_2_floor_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/16_milky_cow/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_16_milky_cow_2_floor_a_tier_4",
    "item_id": "living_16_milky_cow_2_floor_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/16_milky_cow/01_color_A/04_tier_4/02_floor.png",
    "animated": false
  },
  {
    "id": "living_16_milky_cow_3_above_fireplace_a_tier_1",
    "item_id": "living_16_milky_cow_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_16_milky_cow_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/16_milky_cow/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_16_milky_cow_3_above_fireplace_a_tier_2",
    "item_id": "living_16_milky_cow_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_16_milky_cow_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/16_milky_cow/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_16_milky_cow_3_above_fireplace_a_tier_3",
    "item_id": "living_16_milky_cow_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_16_milky_cow_3_above_fireplace_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/16_milky_cow/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_16_milky_cow_3_above_fireplace_a_tier_4",
    "item_id": "living_16_milky_cow_3_above_fireplace_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/16_milky_cow/01_color_A/04_tier_4/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_16_milky_cow_4_painting_a_tier_1",
    "item_id": "living_16_milky_cow_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_16_milky_cow_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/16_milky_cow/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_16_milky_cow_4_painting_a_tier_2",
    "item_id": "living_16_milky_cow_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_16_milky_cow_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/16_milky_cow/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_16_milky_cow_4_painting_a_tier_3",
    "item_id": "living_16_milky_cow_4_painting_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_16_milky_cow_4_painting_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/16_milky_cow/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_16_milky_cow_4_painting_a_tier_4",
    "item_id": "living_16_milky_cow_4_painting_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/16_milky_cow/01_color_A/04_tier_4/04_painting.png",
    "animated": false
  },
  {
    "id": "living_16_milky_cow_5_fireplace_a_tier_1",
    "item_id": "living_16_milky_cow_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_16_milky_cow_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/16_milky_cow/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_16_milky_cow_5_fireplace_a_tier_2",
    "item_id": "living_16_milky_cow_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_16_milky_cow_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/16_milky_cow/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_16_milky_cow_5_fireplace_a_tier_3",
    "item_id": "living_16_milky_cow_5_fireplace_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_16_milky_cow_5_fireplace_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/16_milky_cow/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_16_milky_cow_5_fireplace_a_tier_4",
    "item_id": "living_16_milky_cow_5_fireplace_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/16_milky_cow/01_color_A/04_tier_4/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_16_milky_cow_6_tree_a_tier_1",
    "item_id": "living_16_milky_cow_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_16_milky_cow_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/16_milky_cow/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_16_milky_cow_6_tree_a_tier_2",
    "item_id": "living_16_milky_cow_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_16_milky_cow_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/16_milky_cow/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_16_milky_cow_6_tree_a_tier_3",
    "item_id": "living_16_milky_cow_6_tree_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_16_milky_cow_6_tree_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/16_milky_cow/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_16_milky_cow_6_tree_a_tier_4",
    "item_id": "living_16_milky_cow_6_tree_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/16_milky_cow/01_color_A/04_tier_4/06_tree.png",
    "animated": false
  },
  {
    "id": "living_16_milky_cow_7_couch_a_tier_1",
    "item_id": "living_16_milky_cow_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_16_milky_cow_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/16_milky_cow/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_16_milky_cow_7_couch_a_tier_2",
    "item_id": "living_16_milky_cow_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_16_milky_cow_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/16_milky_cow/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_16_milky_cow_7_couch_a_tier_3",
    "item_id": "living_16_milky_cow_7_couch_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_16_milky_cow_7_couch_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/16_milky_cow/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_16_milky_cow_7_couch_a_tier_4",
    "item_id": "living_16_milky_cow_7_couch_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/16_milky_cow/01_color_A/04_tier_4/07_couch.png",
    "animated": false
  },
  {
    "id": "living_16_milky_cow_8_sidetable_a_tier_1",
    "item_id": "living_16_milky_cow_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_16_milky_cow_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/16_milky_cow/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_16_milky_cow_8_sidetable_a_tier_2",
    "item_id": "living_16_milky_cow_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_16_milky_cow_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/16_milky_cow/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_16_milky_cow_8_sidetable_a_tier_3",
    "item_id": "living_16_milky_cow_8_sidetable_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_16_milky_cow_8_sidetable_a_tier_4",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/16_milky_cow/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_16_milky_cow_8_sidetable_a_tier_4",
    "item_id": "living_16_milky_cow_8_sidetable_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/16_milky_cow/01_color_A/04_tier_4/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_17_halloween_1_wallpaper_a_tier_1",
    "item_id": "living_17_halloween_1_wallpaper_a",
    "tier": 1,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/17_halloween/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_17_halloween_1_wallpaper_a_tier_2",
    "item_id": "living_17_halloween_1_wallpaper_a",
    "tier": 2,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/17_halloween/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_17_halloween_1_wallpaper_a_tier_3",
    "item_id": "living_17_halloween_1_wallpaper_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/17_halloween/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_17_halloween_1_wallpaper_a_tier_4",
    "item_id": "living_17_halloween_1_wallpaper_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/17_halloween/01_color_A/04_tier_4/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_17_halloween_2_floor_a_tier_1",
    "item_id": "living_17_halloween_2_floor_a",
    "tier": 1,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/17_halloween/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_17_halloween_2_floor_a_tier_2",
    "item_id": "living_17_halloween_2_floor_a",
    "tier": 2,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/17_halloween/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_17_halloween_2_floor_a_tier_3",
    "item_id": "living_17_halloween_2_floor_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/17_halloween/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_17_halloween_2_floor_a_tier_4",
    "item_id": "living_17_halloween_2_floor_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/17_halloween/01_color_A/04_tier_4/02_floor.png",
    "animated": false
  },
  {
    "id": "living_17_halloween_3_above_fireplace_a_tier_1",
    "item_id": "living_17_halloween_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/17_halloween/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_17_halloween_3_above_fireplace_a_tier_2",
    "item_id": "living_17_halloween_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/17_halloween/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_17_halloween_3_above_fireplace_a_tier_3",
    "item_id": "living_17_halloween_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/17_halloween/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_17_halloween_3_above_fireplace_a_tier_4",
    "item_id": "living_17_halloween_3_above_fireplace_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/17_halloween/01_color_A/04_tier_4/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_17_halloween_4_painting_a_tier_1",
    "item_id": "living_17_halloween_4_painting_a",
    "tier": 1,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/17_halloween/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_17_halloween_4_painting_a_tier_2",
    "item_id": "living_17_halloween_4_painting_a",
    "tier": 2,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/17_halloween/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_17_halloween_4_painting_a_tier_3",
    "item_id": "living_17_halloween_4_painting_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/17_halloween/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_17_halloween_4_painting_a_tier_4",
    "item_id": "living_17_halloween_4_painting_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/17_halloween/01_color_A/04_tier_4/04_painting.png",
    "animated": false
  },
  {
    "id": "living_17_halloween_5_fireplace_a_tier_1",
    "item_id": "living_17_halloween_5_fireplace_a",
    "tier": 1,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/17_halloween/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_17_halloween_5_fireplace_a_tier_2",
    "item_id": "living_17_halloween_5_fireplace_a",
    "tier": 2,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/17_halloween/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_17_halloween_5_fireplace_a_tier_3",
    "item_id": "living_17_halloween_5_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/17_halloween/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_17_halloween_5_fireplace_a_tier_4",
    "item_id": "living_17_halloween_5_fireplace_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/17_halloween/01_color_A/04_tier_4/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_17_halloween_6_tree_a_tier_1",
    "item_id": "living_17_halloween_6_tree_a",
    "tier": 1,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/17_halloween/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_17_halloween_6_tree_a_tier_2",
    "item_id": "living_17_halloween_6_tree_a",
    "tier": 2,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/17_halloween/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_17_halloween_6_tree_a_tier_3",
    "item_id": "living_17_halloween_6_tree_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/17_halloween/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_17_halloween_6_tree_a_tier_4",
    "item_id": "living_17_halloween_6_tree_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/17_halloween/01_color_A/04_tier_4/06_tree.png",
    "animated": false
  },
  {
    "id": "living_17_halloween_7_couch_a_tier_1",
    "item_id": "living_17_halloween_7_couch_a",
    "tier": 1,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/17_halloween/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_17_halloween_7_couch_a_tier_2",
    "item_id": "living_17_halloween_7_couch_a",
    "tier": 2,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/17_halloween/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_17_halloween_7_couch_a_tier_3",
    "item_id": "living_17_halloween_7_couch_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/17_halloween/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_17_halloween_7_couch_a_tier_4",
    "item_id": "living_17_halloween_7_couch_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/17_halloween/01_color_A/04_tier_4/07_couch.png",
    "animated": false
  },
  {
    "id": "living_17_halloween_8_sidetable_a_tier_1",
    "item_id": "living_17_halloween_8_sidetable_a",
    "tier": 1,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/17_halloween/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_17_halloween_8_sidetable_a_tier_2",
    "item_id": "living_17_halloween_8_sidetable_a",
    "tier": 2,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/17_halloween/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_17_halloween_8_sidetable_a_tier_3",
    "item_id": "living_17_halloween_8_sidetable_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/17_halloween/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_17_halloween_8_sidetable_a_tier_4",
    "item_id": "living_17_halloween_8_sidetable_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/17_halloween/01_color_A/04_tier_4/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_18_candy_house_1_wallpaper_a_tier_1",
    "item_id": "living_18_candy_house_1_wallpaper_a",
    "tier": 1,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/18_candy_house/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_18_candy_house_1_wallpaper_a_tier_2",
    "item_id": "living_18_candy_house_1_wallpaper_a",
    "tier": 2,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/18_candy_house/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_18_candy_house_1_wallpaper_a_tier_3",
    "item_id": "living_18_candy_house_1_wallpaper_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/18_candy_house/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_18_candy_house_1_wallpaper_a_tier_4",
    "item_id": "living_18_candy_house_1_wallpaper_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/18_candy_house/01_color_A/04_tier_4/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_18_candy_house_2_floor_a_tier_1",
    "item_id": "living_18_candy_house_2_floor_a",
    "tier": 1,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/18_candy_house/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_18_candy_house_2_floor_a_tier_2",
    "item_id": "living_18_candy_house_2_floor_a",
    "tier": 2,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/18_candy_house/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_18_candy_house_2_floor_a_tier_3",
    "item_id": "living_18_candy_house_2_floor_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/18_candy_house/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_18_candy_house_2_floor_a_tier_4",
    "item_id": "living_18_candy_house_2_floor_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/18_candy_house/01_color_A/04_tier_4/02_floor.png",
    "animated": false
  },
  {
    "id": "living_18_candy_house_3_above_fireplace_a_tier_1",
    "item_id": "living_18_candy_house_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/18_candy_house/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_18_candy_house_3_above_fireplace_a_tier_2",
    "item_id": "living_18_candy_house_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/18_candy_house/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_18_candy_house_3_above_fireplace_a_tier_3",
    "item_id": "living_18_candy_house_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/18_candy_house/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_18_candy_house_3_above_fireplace_a_tier_4",
    "item_id": "living_18_candy_house_3_above_fireplace_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/18_candy_house/01_color_A/04_tier_4/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_18_candy_house_4_painting_a_tier_1",
    "item_id": "living_18_candy_house_4_painting_a",
    "tier": 1,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/18_candy_house/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_18_candy_house_4_painting_a_tier_2",
    "item_id": "living_18_candy_house_4_painting_a",
    "tier": 2,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/18_candy_house/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_18_candy_house_4_painting_a_tier_3",
    "item_id": "living_18_candy_house_4_painting_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/18_candy_house/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_18_candy_house_4_painting_a_tier_4",
    "item_id": "living_18_candy_house_4_painting_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/18_candy_house/01_color_A/04_tier_4/04_painting.png",
    "animated": false
  },
  {
    "id": "living_18_candy_house_5_fireplace_a_tier_1",
    "item_id": "living_18_candy_house_5_fireplace_a",
    "tier": 1,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/18_candy_house/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_18_candy_house_5_fireplace_a_tier_2",
    "item_id": "living_18_candy_house_5_fireplace_a",
    "tier": 2,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/18_candy_house/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_18_candy_house_5_fireplace_a_tier_3",
    "item_id": "living_18_candy_house_5_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/18_candy_house/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_18_candy_house_5_fireplace_a_tier_4",
    "item_id": "living_18_candy_house_5_fireplace_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/18_candy_house/01_color_A/04_tier_4/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_18_candy_house_6_tree_a_tier_1",
    "item_id": "living_18_candy_house_6_tree_a",
    "tier": 1,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/18_candy_house/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_18_candy_house_6_tree_a_tier_2",
    "item_id": "living_18_candy_house_6_tree_a",
    "tier": 2,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/18_candy_house/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_18_candy_house_6_tree_a_tier_3",
    "item_id": "living_18_candy_house_6_tree_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/18_candy_house/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_18_candy_house_6_tree_a_tier_4",
    "item_id": "living_18_candy_house_6_tree_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/18_candy_house/01_color_A/04_tier_4/06_tree.png",
    "animated": false
  },
  {
    "id": "living_18_candy_house_7_couch_a_tier_1",
    "item_id": "living_18_candy_house_7_couch_a",
    "tier": 1,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/18_candy_house/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_18_candy_house_7_couch_a_tier_2",
    "item_id": "living_18_candy_house_7_couch_a",
    "tier": 2,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/18_candy_house/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_18_candy_house_7_couch_a_tier_3",
    "item_id": "living_18_candy_house_7_couch_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/18_candy_house/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_18_candy_house_7_couch_a_tier_4",
    "item_id": "living_18_candy_house_7_couch_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/18_candy_house/01_color_A/04_tier_4/07_couch.png",
    "animated": false
  },
  {
    "id": "living_18_candy_house_8_sidetable_a_tier_1",
    "item_id": "living_18_candy_house_8_sidetable_a",
    "tier": 1,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/18_candy_house/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_18_candy_house_8_sidetable_a_tier_2",
    "item_id": "living_18_candy_house_8_sidetable_a",
    "tier": 2,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/18_candy_house/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_18_candy_house_8_sidetable_a_tier_3",
    "item_id": "living_18_candy_house_8_sidetable_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/18_candy_house/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_18_candy_house_8_sidetable_a_tier_4",
    "item_id": "living_18_candy_house_8_sidetable_a",
    "tier": 4,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 2700,
    "image": "01_living_room/18_candy_house/01_color_A/04_tier_4/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_19_circus_1_wallpaper_a_tier_1",
    "item_id": "living_19_circus_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_19_circus_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/19_circus/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_19_circus_1_wallpaper_a_tier_2",
    "item_id": "living_19_circus_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_19_circus_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/19_circus/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_19_circus_1_wallpaper_a_tier_3",
    "item_id": "living_19_circus_1_wallpaper_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/19_circus/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_19_circus_2_floor_a_tier_1",
    "item_id": "living_19_circus_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_19_circus_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/19_circus/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_19_circus_2_floor_a_tier_2",
    "item_id": "living_19_circus_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_19_circus_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/19_circus/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_19_circus_2_floor_a_tier_3",
    "item_id": "living_19_circus_2_floor_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/19_circus/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_19_circus_3_above_fireplace_a_tier_1",
    "item_id": "living_19_circus_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_19_circus_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/19_circus/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_19_circus_3_above_fireplace_a_tier_2",
    "item_id": "living_19_circus_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_19_circus_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/19_circus/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_19_circus_3_above_fireplace_a_tier_3",
    "item_id": "living_19_circus_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/19_circus/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_19_circus_4_painting_a_tier_1",
    "item_id": "living_19_circus_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_19_circus_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/19_circus/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_19_circus_4_painting_a_tier_2",
    "item_id": "living_19_circus_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_19_circus_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/19_circus/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_19_circus_4_painting_a_tier_3",
    "item_id": "living_19_circus_4_painting_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/19_circus/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_19_circus_5_fireplace_a_tier_1",
    "item_id": "living_19_circus_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_19_circus_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/19_circus/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_19_circus_5_fireplace_a_tier_2",
    "item_id": "living_19_circus_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_19_circus_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/19_circus/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_19_circus_5_fireplace_a_tier_3",
    "item_id": "living_19_circus_5_fireplace_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/19_circus/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_19_circus_6_tree_a_tier_1",
    "item_id": "living_19_circus_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_19_circus_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/19_circus/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_19_circus_6_tree_a_tier_2",
    "item_id": "living_19_circus_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_19_circus_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/19_circus/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_19_circus_6_tree_a_tier_3",
    "item_id": "living_19_circus_6_tree_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/19_circus/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_19_circus_7_couch_a_tier_1",
    "item_id": "living_19_circus_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_19_circus_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/19_circus/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_19_circus_7_couch_a_tier_2",
    "item_id": "living_19_circus_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_19_circus_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/19_circus/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_19_circus_7_couch_a_tier_3",
    "item_id": "living_19_circus_7_couch_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/19_circus/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_19_circus_8_sidetable_a_tier_1",
    "item_id": "living_19_circus_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_19_circus_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/19_circus/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_19_circus_8_sidetable_a_tier_2",
    "item_id": "living_19_circus_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_19_circus_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/19_circus/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_19_circus_8_sidetable_a_tier_3",
    "item_id": "living_19_circus_8_sidetable_a",
    "tier": 3,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 4500,
    "fuse_items_required": 3,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/19_circus/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_20_space_1_wallpaper_a_tier_1",
    "item_id": "living_20_space_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_20_space_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/20_space/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_20_space_1_wallpaper_a_tier_2",
    "item_id": "living_20_space_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_20_space_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/20_space/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_20_space_1_wallpaper_a_tier_3",
    "item_id": "living_20_space_1_wallpaper_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/20_space/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_20_space_2_floor_a_tier_1",
    "item_id": "living_20_space_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_20_space_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/20_space/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_20_space_2_floor_a_tier_2",
    "item_id": "living_20_space_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_20_space_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/20_space/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_20_space_2_floor_a_tier_3",
    "item_id": "living_20_space_2_floor_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/20_space/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_20_space_3_above_fireplace_a_tier_1",
    "item_id": "living_20_space_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_20_space_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/20_space/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_20_space_3_above_fireplace_a_tier_2",
    "item_id": "living_20_space_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_20_space_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/20_space/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_20_space_3_above_fireplace_a_tier_3",
    "item_id": "living_20_space_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/20_space/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_20_space_4_painting_a_tier_1",
    "item_id": "living_20_space_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_20_space_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/20_space/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_20_space_4_painting_a_tier_2",
    "item_id": "living_20_space_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_20_space_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/20_space/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_20_space_4_painting_a_tier_3",
    "item_id": "living_20_space_4_painting_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/20_space/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_20_space_5_fireplace_a_tier_1",
    "item_id": "living_20_space_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_20_space_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/20_space/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_20_space_5_fireplace_a_tier_2",
    "item_id": "living_20_space_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_20_space_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/20_space/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_20_space_5_fireplace_a_tier_3",
    "item_id": "living_20_space_5_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/20_space/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_20_space_6_tree_a_tier_1",
    "item_id": "living_20_space_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_20_space_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/20_space/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_20_space_6_tree_a_tier_2",
    "item_id": "living_20_space_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_20_space_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/20_space/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_20_space_6_tree_a_tier_3",
    "item_id": "living_20_space_6_tree_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/20_space/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_20_space_7_couch_a_tier_1",
    "item_id": "living_20_space_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_20_space_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/20_space/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_20_space_7_couch_a_tier_2",
    "item_id": "living_20_space_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_20_space_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/20_space/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_20_space_7_couch_a_tier_3",
    "item_id": "living_20_space_7_couch_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/20_space/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_20_space_8_sidetable_a_tier_1",
    "item_id": "living_20_space_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_20_space_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/20_space/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_20_space_8_sidetable_a_tier_2",
    "item_id": "living_20_space_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_20_space_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/20_space/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_20_space_8_sidetable_a_tier_3",
    "item_id": "living_20_space_8_sidetable_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/20_space/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_21_egyptian_1_wallpaper_a_tier_1",
    "item_id": "living_21_egyptian_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_21_egyptian_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/21_egyptian/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_21_egyptian_1_wallpaper_a_tier_2",
    "item_id": "living_21_egyptian_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_21_egyptian_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/21_egyptian/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_21_egyptian_1_wallpaper_a_tier_3",
    "item_id": "living_21_egyptian_1_wallpaper_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/21_egyptian/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_21_egyptian_2_floor_a_tier_1",
    "item_id": "living_21_egyptian_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_21_egyptian_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/21_egyptian/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_21_egyptian_2_floor_a_tier_2",
    "item_id": "living_21_egyptian_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_21_egyptian_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/21_egyptian/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_21_egyptian_2_floor_a_tier_3",
    "item_id": "living_21_egyptian_2_floor_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/21_egyptian/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_21_egyptian_3_above_fireplace_a_tier_1",
    "item_id": "living_21_egyptian_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_21_egyptian_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/21_egyptian/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_21_egyptian_3_above_fireplace_a_tier_2",
    "item_id": "living_21_egyptian_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_21_egyptian_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/21_egyptian/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_21_egyptian_3_above_fireplace_a_tier_3",
    "item_id": "living_21_egyptian_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/21_egyptian/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_21_egyptian_4_painting_a_tier_1",
    "item_id": "living_21_egyptian_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_21_egyptian_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/21_egyptian/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_21_egyptian_4_painting_a_tier_2",
    "item_id": "living_21_egyptian_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_21_egyptian_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/21_egyptian/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_21_egyptian_4_painting_a_tier_3",
    "item_id": "living_21_egyptian_4_painting_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/21_egyptian/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_21_egyptian_5_fireplace_a_tier_1",
    "item_id": "living_21_egyptian_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_21_egyptian_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/21_egyptian/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_21_egyptian_5_fireplace_a_tier_2",
    "item_id": "living_21_egyptian_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_21_egyptian_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/21_egyptian/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_21_egyptian_5_fireplace_a_tier_3",
    "item_id": "living_21_egyptian_5_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/21_egyptian/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_21_egyptian_6_tree_a_tier_1",
    "item_id": "living_21_egyptian_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_21_egyptian_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/21_egyptian/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_21_egyptian_6_tree_a_tier_2",
    "item_id": "living_21_egyptian_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_21_egyptian_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/21_egyptian/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_21_egyptian_6_tree_a_tier_3",
    "item_id": "living_21_egyptian_6_tree_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/21_egyptian/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_21_egyptian_7_couch_a_tier_1",
    "item_id": "living_21_egyptian_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_21_egyptian_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/21_egyptian/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_21_egyptian_7_couch_a_tier_2",
    "item_id": "living_21_egyptian_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_21_egyptian_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/21_egyptian/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_21_egyptian_7_couch_a_tier_3",
    "item_id": "living_21_egyptian_7_couch_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/21_egyptian/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_21_egyptian_8_sidetable_a_tier_1",
    "item_id": "living_21_egyptian_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_21_egyptian_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/21_egyptian/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_21_egyptian_8_sidetable_a_tier_2",
    "item_id": "living_21_egyptian_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_21_egyptian_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/21_egyptian/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_21_egyptian_8_sidetable_a_tier_3",
    "item_id": "living_21_egyptian_8_sidetable_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/21_egyptian/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_22_fruitsandcream_1_wallpaper_a_tier_1",
    "item_id": "living_22_fruitsandcream_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_22_fruitsandcream_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/22_fruitsandcream/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_22_fruitsandcream_1_wallpaper_a_tier_2",
    "item_id": "living_22_fruitsandcream_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_22_fruitsandcream_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/22_fruitsandcream/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_22_fruitsandcream_1_wallpaper_a_tier_3",
    "item_id": "living_22_fruitsandcream_1_wallpaper_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/22_fruitsandcream/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_22_fruitsandcream_2_floor_a_tier_1",
    "item_id": "living_22_fruitsandcream_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_22_fruitsandcream_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/22_fruitsandcream/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_22_fruitsandcream_2_floor_a_tier_2",
    "item_id": "living_22_fruitsandcream_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_22_fruitsandcream_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/22_fruitsandcream/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_22_fruitsandcream_2_floor_a_tier_3",
    "item_id": "living_22_fruitsandcream_2_floor_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/22_fruitsandcream/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_22_fruitsandcream_3_above_fireplace_a_tier_1",
    "item_id": "living_22_fruitsandcream_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_22_fruitsandcream_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/22_fruitsandcream/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_22_fruitsandcream_3_above_fireplace_a_tier_2",
    "item_id": "living_22_fruitsandcream_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_22_fruitsandcream_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/22_fruitsandcream/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_22_fruitsandcream_3_above_fireplace_a_tier_3",
    "item_id": "living_22_fruitsandcream_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/22_fruitsandcream/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_22_fruitsandcream_4_painting_a_tier_1",
    "item_id": "living_22_fruitsandcream_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_22_fruitsandcream_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/22_fruitsandcream/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_22_fruitsandcream_4_painting_a_tier_2",
    "item_id": "living_22_fruitsandcream_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_22_fruitsandcream_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/22_fruitsandcream/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_22_fruitsandcream_4_painting_a_tier_3",
    "item_id": "living_22_fruitsandcream_4_painting_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/22_fruitsandcream/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_22_fruitsandcream_5_fireplace_a_tier_1",
    "item_id": "living_22_fruitsandcream_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_22_fruitsandcream_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/22_fruitsandcream/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_22_fruitsandcream_5_fireplace_a_tier_2",
    "item_id": "living_22_fruitsandcream_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_22_fruitsandcream_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/22_fruitsandcream/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_22_fruitsandcream_5_fireplace_a_tier_3",
    "item_id": "living_22_fruitsandcream_5_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/22_fruitsandcream/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_22_fruitsandcream_6_tree_a_tier_1",
    "item_id": "living_22_fruitsandcream_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_22_fruitsandcream_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/22_fruitsandcream/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_22_fruitsandcream_6_tree_a_tier_2",
    "item_id": "living_22_fruitsandcream_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_22_fruitsandcream_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/22_fruitsandcream/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_22_fruitsandcream_6_tree_a_tier_3",
    "item_id": "living_22_fruitsandcream_6_tree_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/22_fruitsandcream/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_22_fruitsandcream_7_couch_a_tier_1",
    "item_id": "living_22_fruitsandcream_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_22_fruitsandcream_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/22_fruitsandcream/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_22_fruitsandcream_7_couch_a_tier_2",
    "item_id": "living_22_fruitsandcream_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_22_fruitsandcream_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/22_fruitsandcream/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_22_fruitsandcream_7_couch_a_tier_3",
    "item_id": "living_22_fruitsandcream_7_couch_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/22_fruitsandcream/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_22_fruitsandcream_8_sidetable_a_tier_1",
    "item_id": "living_22_fruitsandcream_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_22_fruitsandcream_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/22_fruitsandcream/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_22_fruitsandcream_8_sidetable_a_tier_2",
    "item_id": "living_22_fruitsandcream_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_22_fruitsandcream_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/22_fruitsandcream/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_22_fruitsandcream_8_sidetable_a_tier_3",
    "item_id": "living_22_fruitsandcream_8_sidetable_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/22_fruitsandcream/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_23_halloween2024_1_wallpaper_a_tier_1",
    "item_id": "living_23_halloween2024_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_23_halloween2024_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/23_halloween2024/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_23_halloween2024_1_wallpaper_a_tier_2",
    "item_id": "living_23_halloween2024_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_23_halloween2024_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/23_halloween2024/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_23_halloween2024_1_wallpaper_a_tier_3",
    "item_id": "living_23_halloween2024_1_wallpaper_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/23_halloween2024/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_23_halloween2024_2_floor_a_tier_1",
    "item_id": "living_23_halloween2024_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_23_halloween2024_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/23_halloween2024/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_23_halloween2024_2_floor_a_tier_2",
    "item_id": "living_23_halloween2024_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_23_halloween2024_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/23_halloween2024/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_23_halloween2024_2_floor_a_tier_3",
    "item_id": "living_23_halloween2024_2_floor_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/23_halloween2024/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_23_halloween2024_3_above_fireplace_a_tier_1",
    "item_id": "living_23_halloween2024_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_23_halloween2024_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/23_halloween2024/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_23_halloween2024_3_above_fireplace_a_tier_2",
    "item_id": "living_23_halloween2024_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_23_halloween2024_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/23_halloween2024/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_23_halloween2024_3_above_fireplace_a_tier_3",
    "item_id": "living_23_halloween2024_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/23_halloween2024/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_23_halloween2024_4_painting_a_tier_1",
    "item_id": "living_23_halloween2024_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_23_halloween2024_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/23_halloween2024/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_23_halloween2024_4_painting_a_tier_2",
    "item_id": "living_23_halloween2024_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_23_halloween2024_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/23_halloween2024/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_23_halloween2024_4_painting_a_tier_3",
    "item_id": "living_23_halloween2024_4_painting_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/23_halloween2024/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_23_halloween2024_5_fireplace_a_tier_1",
    "item_id": "living_23_halloween2024_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_23_halloween2024_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/23_halloween2024/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_23_halloween2024_5_fireplace_a_tier_2",
    "item_id": "living_23_halloween2024_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_23_halloween2024_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/23_halloween2024/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_23_halloween2024_5_fireplace_a_tier_3",
    "item_id": "living_23_halloween2024_5_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/23_halloween2024/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_23_halloween2024_6_tree_a_tier_1",
    "item_id": "living_23_halloween2024_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_23_halloween2024_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/23_halloween2024/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_23_halloween2024_6_tree_a_tier_2",
    "item_id": "living_23_halloween2024_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_23_halloween2024_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/23_halloween2024/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_23_halloween2024_6_tree_a_tier_3",
    "item_id": "living_23_halloween2024_6_tree_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/23_halloween2024/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_23_halloween2024_7_couch_a_tier_1",
    "item_id": "living_23_halloween2024_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_23_halloween2024_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/23_halloween2024/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_23_halloween2024_7_couch_a_tier_2",
    "item_id": "living_23_halloween2024_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_23_halloween2024_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/23_halloween2024/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_23_halloween2024_7_couch_a_tier_3",
    "item_id": "living_23_halloween2024_7_couch_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/23_halloween2024/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_23_halloween2024_8_sidetable_a_tier_1",
    "item_id": "living_23_halloween2024_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_23_halloween2024_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/23_halloween2024/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_23_halloween2024_8_sidetable_a_tier_2",
    "item_id": "living_23_halloween2024_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_23_halloween2024_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/23_halloween2024/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_23_halloween2024_8_sidetable_a_tier_3",
    "item_id": "living_23_halloween2024_8_sidetable_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/23_halloween2024/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_24_moonviewing_1_wallpaper_a_tier_1",
    "item_id": "living_24_moonviewing_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_24_moonviewing_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/24_moonviewing/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_24_moonviewing_1_wallpaper_a_tier_2",
    "item_id": "living_24_moonviewing_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_24_moonviewing_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/24_moonviewing/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_24_moonviewing_1_wallpaper_a_tier_3",
    "item_id": "living_24_moonviewing_1_wallpaper_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/24_moonviewing/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_24_moonviewing_2_floor_a_tier_1",
    "item_id": "living_24_moonviewing_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_24_moonviewing_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/24_moonviewing/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_24_moonviewing_2_floor_a_tier_2",
    "item_id": "living_24_moonviewing_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_24_moonviewing_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/24_moonviewing/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_24_moonviewing_2_floor_a_tier_3",
    "item_id": "living_24_moonviewing_2_floor_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/24_moonviewing/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_24_moonviewing_3_above_fireplace_a_tier_1",
    "item_id": "living_24_moonviewing_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_24_moonviewing_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/24_moonviewing/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_24_moonviewing_3_above_fireplace_a_tier_2",
    "item_id": "living_24_moonviewing_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_24_moonviewing_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/24_moonviewing/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_24_moonviewing_3_above_fireplace_a_tier_3",
    "item_id": "living_24_moonviewing_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/24_moonviewing/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_24_moonviewing_4_painting_a_tier_1",
    "item_id": "living_24_moonviewing_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_24_moonviewing_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/24_moonviewing/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_24_moonviewing_4_painting_a_tier_2",
    "item_id": "living_24_moonviewing_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_24_moonviewing_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/24_moonviewing/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_24_moonviewing_4_painting_a_tier_3",
    "item_id": "living_24_moonviewing_4_painting_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/24_moonviewing/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_24_moonviewing_5_fireplace_a_tier_1",
    "item_id": "living_24_moonviewing_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_24_moonviewing_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/24_moonviewing/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_24_moonviewing_5_fireplace_a_tier_2",
    "item_id": "living_24_moonviewing_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_24_moonviewing_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/24_moonviewing/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_24_moonviewing_5_fireplace_a_tier_3",
    "item_id": "living_24_moonviewing_5_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/24_moonviewing/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_24_moonviewing_6_tree_a_tier_1",
    "item_id": "living_24_moonviewing_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_24_moonviewing_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/24_moonviewing/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_24_moonviewing_6_tree_a_tier_2",
    "item_id": "living_24_moonviewing_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_24_moonviewing_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/24_moonviewing/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_24_moonviewing_6_tree_a_tier_3",
    "item_id": "living_24_moonviewing_6_tree_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/24_moonviewing/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_24_moonviewing_7_couch_a_tier_1",
    "item_id": "living_24_moonviewing_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_24_moonviewing_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/24_moonviewing/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_24_moonviewing_7_couch_a_tier_2",
    "item_id": "living_24_moonviewing_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_24_moonviewing_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/24_moonviewing/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_24_moonviewing_7_couch_a_tier_3",
    "item_id": "living_24_moonviewing_7_couch_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/24_moonviewing/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_24_moonviewing_8_sidetable_a_tier_1",
    "item_id": "living_24_moonviewing_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_24_moonviewing_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/24_moonviewing/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_24_moonviewing_8_sidetable_a_tier_2",
    "item_id": "living_24_moonviewing_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_24_moonviewing_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/24_moonviewing/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_24_moonviewing_8_sidetable_a_tier_3",
    "item_id": "living_24_moonviewing_8_sidetable_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/24_moonviewing/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_25_cute_xmas_1_wallpaper_a_tier_1",
    "item_id": "living_25_cute_xmas_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_25_cute_xmas_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/25_cute_xmas/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_25_cute_xmas_1_wallpaper_a_tier_2",
    "item_id": "living_25_cute_xmas_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_25_cute_xmas_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/25_cute_xmas/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_25_cute_xmas_1_wallpaper_a_tier_3",
    "item_id": "living_25_cute_xmas_1_wallpaper_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/25_cute_xmas/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_25_cute_xmas_2_floor_a_tier_1",
    "item_id": "living_25_cute_xmas_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_25_cute_xmas_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/25_cute_xmas/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_25_cute_xmas_2_floor_a_tier_2",
    "item_id": "living_25_cute_xmas_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_25_cute_xmas_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/25_cute_xmas/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_25_cute_xmas_2_floor_a_tier_3",
    "item_id": "living_25_cute_xmas_2_floor_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/25_cute_xmas/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_25_cute_xmas_3_above_fireplace_a_tier_1",
    "item_id": "living_25_cute_xmas_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_25_cute_xmas_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/25_cute_xmas/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_25_cute_xmas_3_above_fireplace_a_tier_2",
    "item_id": "living_25_cute_xmas_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_25_cute_xmas_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/25_cute_xmas/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_25_cute_xmas_3_above_fireplace_a_tier_3",
    "item_id": "living_25_cute_xmas_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/25_cute_xmas/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_25_cute_xmas_4_painting_a_tier_1",
    "item_id": "living_25_cute_xmas_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_25_cute_xmas_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/25_cute_xmas/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_25_cute_xmas_4_painting_a_tier_2",
    "item_id": "living_25_cute_xmas_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_25_cute_xmas_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/25_cute_xmas/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_25_cute_xmas_4_painting_a_tier_3",
    "item_id": "living_25_cute_xmas_4_painting_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/25_cute_xmas/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_25_cute_xmas_5_fireplace_a_tier_1",
    "item_id": "living_25_cute_xmas_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_25_cute_xmas_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/25_cute_xmas/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_25_cute_xmas_5_fireplace_a_tier_2",
    "item_id": "living_25_cute_xmas_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_25_cute_xmas_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/25_cute_xmas/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_25_cute_xmas_5_fireplace_a_tier_3",
    "item_id": "living_25_cute_xmas_5_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/25_cute_xmas/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_25_cute_xmas_6_tree_a_tier_1",
    "item_id": "living_25_cute_xmas_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_25_cute_xmas_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/25_cute_xmas/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_25_cute_xmas_6_tree_a_tier_2",
    "item_id": "living_25_cute_xmas_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_25_cute_xmas_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/25_cute_xmas/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_25_cute_xmas_6_tree_a_tier_3",
    "item_id": "living_25_cute_xmas_6_tree_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/25_cute_xmas/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_25_cute_xmas_7_couch_a_tier_1",
    "item_id": "living_25_cute_xmas_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_25_cute_xmas_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/25_cute_xmas/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_25_cute_xmas_7_couch_a_tier_2",
    "item_id": "living_25_cute_xmas_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_25_cute_xmas_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/25_cute_xmas/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_25_cute_xmas_7_couch_a_tier_3",
    "item_id": "living_25_cute_xmas_7_couch_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/25_cute_xmas/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_25_cute_xmas_8_sidetable_a_tier_1",
    "item_id": "living_25_cute_xmas_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_25_cute_xmas_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/25_cute_xmas/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_25_cute_xmas_8_sidetable_a_tier_2",
    "item_id": "living_25_cute_xmas_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_25_cute_xmas_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/25_cute_xmas/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_25_cute_xmas_8_sidetable_a_tier_3",
    "item_id": "living_25_cute_xmas_8_sidetable_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/25_cute_xmas/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_26_new_year_2025_1_wallpaper_a_tier_1",
    "item_id": "living_26_new_year_2025_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_26_new_year_2025_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/26_new_year_2025/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_26_new_year_2025_1_wallpaper_a_tier_2",
    "item_id": "living_26_new_year_2025_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_26_new_year_2025_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/26_new_year_2025/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_26_new_year_2025_1_wallpaper_a_tier_3",
    "item_id": "living_26_new_year_2025_1_wallpaper_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/26_new_year_2025/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_26_new_year_2025_2_floor_a_tier_1",
    "item_id": "living_26_new_year_2025_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_26_new_year_2025_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/26_new_year_2025/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_26_new_year_2025_2_floor_a_tier_2",
    "item_id": "living_26_new_year_2025_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_26_new_year_2025_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/26_new_year_2025/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_26_new_year_2025_2_floor_a_tier_3",
    "item_id": "living_26_new_year_2025_2_floor_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/26_new_year_2025/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_26_new_year_2025_3_above_fireplace_a_tier_1",
    "item_id": "living_26_new_year_2025_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_26_new_year_2025_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/26_new_year_2025/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_26_new_year_2025_3_above_fireplace_a_tier_2",
    "item_id": "living_26_new_year_2025_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_26_new_year_2025_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/26_new_year_2025/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_26_new_year_2025_3_above_fireplace_a_tier_3",
    "item_id": "living_26_new_year_2025_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/26_new_year_2025/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_26_new_year_2025_4_painting_a_tier_1",
    "item_id": "living_26_new_year_2025_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_26_new_year_2025_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/26_new_year_2025/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_26_new_year_2025_4_painting_a_tier_2",
    "item_id": "living_26_new_year_2025_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_26_new_year_2025_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/26_new_year_2025/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_26_new_year_2025_4_painting_a_tier_3",
    "item_id": "living_26_new_year_2025_4_painting_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/26_new_year_2025/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_26_new_year_2025_5_fireplace_a_tier_1",
    "item_id": "living_26_new_year_2025_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_26_new_year_2025_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/26_new_year_2025/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_26_new_year_2025_5_fireplace_a_tier_2",
    "item_id": "living_26_new_year_2025_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_26_new_year_2025_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/26_new_year_2025/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_26_new_year_2025_5_fireplace_a_tier_3",
    "item_id": "living_26_new_year_2025_5_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/26_new_year_2025/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_26_new_year_2025_6_tree_a_tier_1",
    "item_id": "living_26_new_year_2025_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_26_new_year_2025_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/26_new_year_2025/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_26_new_year_2025_6_tree_a_tier_2",
    "item_id": "living_26_new_year_2025_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_26_new_year_2025_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/26_new_year_2025/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_26_new_year_2025_6_tree_a_tier_3",
    "item_id": "living_26_new_year_2025_6_tree_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/26_new_year_2025/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_26_new_year_2025_7_couch_a_tier_1",
    "item_id": "living_26_new_year_2025_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_26_new_year_2025_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/26_new_year_2025/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_26_new_year_2025_7_couch_a_tier_2",
    "item_id": "living_26_new_year_2025_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_26_new_year_2025_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/26_new_year_2025/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_26_new_year_2025_7_couch_a_tier_3",
    "item_id": "living_26_new_year_2025_7_couch_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/26_new_year_2025/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_26_new_year_2025_8_sidetable_a_tier_1",
    "item_id": "living_26_new_year_2025_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_26_new_year_2025_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/26_new_year_2025/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_26_new_year_2025_8_sidetable_a_tier_2",
    "item_id": "living_26_new_year_2025_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_26_new_year_2025_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/26_new_year_2025/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_26_new_year_2025_8_sidetable_a_tier_3",
    "item_id": "living_26_new_year_2025_8_sidetable_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/26_new_year_2025/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_27_setsubun_1_wallpaper_a_tier_1",
    "item_id": "living_27_setsubun_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_27_setsubun_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/27_setsubun/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_27_setsubun_1_wallpaper_a_tier_2",
    "item_id": "living_27_setsubun_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_27_setsubun_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/27_setsubun/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_27_setsubun_1_wallpaper_a_tier_3",
    "item_id": "living_27_setsubun_1_wallpaper_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/27_setsubun/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_27_setsubun_2_floor_a_tier_1",
    "item_id": "living_27_setsubun_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_27_setsubun_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/27_setsubun/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_27_setsubun_2_floor_a_tier_2",
    "item_id": "living_27_setsubun_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_27_setsubun_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/27_setsubun/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_27_setsubun_2_floor_a_tier_3",
    "item_id": "living_27_setsubun_2_floor_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/27_setsubun/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_27_setsubun_3_above_fireplace_a_tier_1",
    "item_id": "living_27_setsubun_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_27_setsubun_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/27_setsubun/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_27_setsubun_3_above_fireplace_a_tier_2",
    "item_id": "living_27_setsubun_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_27_setsubun_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/27_setsubun/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_27_setsubun_3_above_fireplace_a_tier_3",
    "item_id": "living_27_setsubun_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/27_setsubun/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_27_setsubun_4_painting_a_tier_1",
    "item_id": "living_27_setsubun_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_27_setsubun_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/27_setsubun/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_27_setsubun_4_painting_a_tier_2",
    "item_id": "living_27_setsubun_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_27_setsubun_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/27_setsubun/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_27_setsubun_4_painting_a_tier_3",
    "item_id": "living_27_setsubun_4_painting_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/27_setsubun/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_27_setsubun_5_fireplace_a_tier_1",
    "item_id": "living_27_setsubun_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_27_setsubun_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/27_setsubun/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_27_setsubun_5_fireplace_a_tier_2",
    "item_id": "living_27_setsubun_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_27_setsubun_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/27_setsubun/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_27_setsubun_5_fireplace_a_tier_3",
    "item_id": "living_27_setsubun_5_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/27_setsubun/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_27_setsubun_6_tree_a_tier_1",
    "item_id": "living_27_setsubun_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_27_setsubun_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/27_setsubun/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_27_setsubun_6_tree_a_tier_2",
    "item_id": "living_27_setsubun_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_27_setsubun_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/27_setsubun/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_27_setsubun_6_tree_a_tier_3",
    "item_id": "living_27_setsubun_6_tree_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/27_setsubun/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_27_setsubun_7_couch_a_tier_1",
    "item_id": "living_27_setsubun_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_27_setsubun_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/27_setsubun/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_27_setsubun_7_couch_a_tier_2",
    "item_id": "living_27_setsubun_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_27_setsubun_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/27_setsubun/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_27_setsubun_7_couch_a_tier_3",
    "item_id": "living_27_setsubun_7_couch_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/27_setsubun/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_27_setsubun_8_sidetable_a_tier_1",
    "item_id": "living_27_setsubun_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_27_setsubun_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/27_setsubun/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_27_setsubun_8_sidetable_a_tier_2",
    "item_id": "living_27_setsubun_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_27_setsubun_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/27_setsubun/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_27_setsubun_8_sidetable_a_tier_3",
    "item_id": "living_27_setsubun_8_sidetable_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/27_setsubun/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_28_cafe_1_wallpaper_a_tier_1",
    "item_id": "living_28_cafe_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_28_cafe_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/28_cafe/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_28_cafe_1_wallpaper_a_tier_2",
    "item_id": "living_28_cafe_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_28_cafe_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/28_cafe/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_28_cafe_1_wallpaper_a_tier_3",
    "item_id": "living_28_cafe_1_wallpaper_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/28_cafe/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_28_cafe_2_floor_a_tier_1",
    "item_id": "living_28_cafe_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_28_cafe_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/28_cafe/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_28_cafe_2_floor_a_tier_2",
    "item_id": "living_28_cafe_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_28_cafe_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/28_cafe/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_28_cafe_2_floor_a_tier_3",
    "item_id": "living_28_cafe_2_floor_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/28_cafe/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_28_cafe_3_above_fireplace_a_tier_1",
    "item_id": "living_28_cafe_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_28_cafe_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/28_cafe/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_28_cafe_3_above_fireplace_a_tier_2",
    "item_id": "living_28_cafe_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_28_cafe_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/28_cafe/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_28_cafe_3_above_fireplace_a_tier_3",
    "item_id": "living_28_cafe_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/28_cafe/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_28_cafe_4_painting_a_tier_1",
    "item_id": "living_28_cafe_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_28_cafe_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/28_cafe/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_28_cafe_4_painting_a_tier_2",
    "item_id": "living_28_cafe_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_28_cafe_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/28_cafe/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_28_cafe_4_painting_a_tier_3",
    "item_id": "living_28_cafe_4_painting_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/28_cafe/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_28_cafe_5_fireplace_a_tier_1",
    "item_id": "living_28_cafe_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_28_cafe_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/28_cafe/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_28_cafe_5_fireplace_a_tier_2",
    "item_id": "living_28_cafe_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_28_cafe_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/28_cafe/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_28_cafe_5_fireplace_a_tier_3",
    "item_id": "living_28_cafe_5_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/28_cafe/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_28_cafe_6_tree_a_tier_1",
    "item_id": "living_28_cafe_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_28_cafe_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/28_cafe/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_28_cafe_6_tree_a_tier_2",
    "item_id": "living_28_cafe_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_28_cafe_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/28_cafe/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_28_cafe_6_tree_a_tier_3",
    "item_id": "living_28_cafe_6_tree_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/28_cafe/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_28_cafe_7_couch_a_tier_1",
    "item_id": "living_28_cafe_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_28_cafe_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/28_cafe/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_28_cafe_7_couch_a_tier_2",
    "item_id": "living_28_cafe_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_28_cafe_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/28_cafe/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_28_cafe_7_couch_a_tier_3",
    "item_id": "living_28_cafe_7_couch_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/28_cafe/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_28_cafe_8_sidetable_a_tier_1",
    "item_id": "living_28_cafe_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_28_cafe_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/28_cafe/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_28_cafe_8_sidetable_a_tier_2",
    "item_id": "living_28_cafe_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_28_cafe_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/28_cafe/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_28_cafe_8_sidetable_a_tier_3",
    "item_id": "living_28_cafe_8_sidetable_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/28_cafe/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_29_hanami_1_wallpaper_a_tier_1",
    "item_id": "living_29_hanami_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_29_hanami_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/29_hanami/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_29_hanami_1_wallpaper_a_tier_2",
    "item_id": "living_29_hanami_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_29_hanami_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/29_hanami/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_29_hanami_1_wallpaper_a_tier_3",
    "item_id": "living_29_hanami_1_wallpaper_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/29_hanami/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_29_hanami_2_floor_a_tier_1",
    "item_id": "living_29_hanami_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_29_hanami_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/29_hanami/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_29_hanami_2_floor_a_tier_2",
    "item_id": "living_29_hanami_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_29_hanami_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/29_hanami/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_29_hanami_2_floor_a_tier_3",
    "item_id": "living_29_hanami_2_floor_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/29_hanami/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_29_hanami_3_above_fireplace_a_tier_1",
    "item_id": "living_29_hanami_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_29_hanami_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/29_hanami/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_29_hanami_3_above_fireplace_a_tier_2",
    "item_id": "living_29_hanami_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_29_hanami_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/29_hanami/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_29_hanami_3_above_fireplace_a_tier_3",
    "item_id": "living_29_hanami_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/29_hanami/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_29_hanami_4_painting_a_tier_1",
    "item_id": "living_29_hanami_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_29_hanami_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/29_hanami/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_29_hanami_4_painting_a_tier_2",
    "item_id": "living_29_hanami_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_29_hanami_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/29_hanami/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_29_hanami_4_painting_a_tier_3",
    "item_id": "living_29_hanami_4_painting_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/29_hanami/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_29_hanami_5_fireplace_a_tier_1",
    "item_id": "living_29_hanami_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_29_hanami_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/29_hanami/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_29_hanami_5_fireplace_a_tier_2",
    "item_id": "living_29_hanami_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_29_hanami_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/29_hanami/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_29_hanami_5_fireplace_a_tier_3",
    "item_id": "living_29_hanami_5_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/29_hanami/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_29_hanami_6_tree_a_tier_1",
    "item_id": "living_29_hanami_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_29_hanami_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/29_hanami/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_29_hanami_6_tree_a_tier_2",
    "item_id": "living_29_hanami_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_29_hanami_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/29_hanami/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_29_hanami_6_tree_a_tier_3",
    "item_id": "living_29_hanami_6_tree_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/29_hanami/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_29_hanami_7_couch_a_tier_1",
    "item_id": "living_29_hanami_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_29_hanami_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/29_hanami/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_29_hanami_7_couch_a_tier_2",
    "item_id": "living_29_hanami_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_29_hanami_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/29_hanami/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_29_hanami_7_couch_a_tier_3",
    "item_id": "living_29_hanami_7_couch_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/29_hanami/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_29_hanami_8_sidetable_a_tier_1",
    "item_id": "living_29_hanami_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_29_hanami_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/29_hanami/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_29_hanami_8_sidetable_a_tier_2",
    "item_id": "living_29_hanami_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_29_hanami_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/29_hanami/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_29_hanami_8_sidetable_a_tier_3",
    "item_id": "living_29_hanami_8_sidetable_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/29_hanami/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_30_childrens_day2025_1_wallpaper_a_tier_1",
    "item_id": "living_30_childrens_day2025_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_30_childrens_day2025_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/30_childrens_day2025/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_30_childrens_day2025_1_wallpaper_a_tier_2",
    "item_id": "living_30_childrens_day2025_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_30_childrens_day2025_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/30_childrens_day2025/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_30_childrens_day2025_1_wallpaper_a_tier_3",
    "item_id": "living_30_childrens_day2025_1_wallpaper_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/30_childrens_day2025/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_30_childrens_day2025_2_floor_a_tier_1",
    "item_id": "living_30_childrens_day2025_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_30_childrens_day2025_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/30_childrens_day2025/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_30_childrens_day2025_2_floor_a_tier_2",
    "item_id": "living_30_childrens_day2025_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_30_childrens_day2025_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/30_childrens_day2025/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_30_childrens_day2025_2_floor_a_tier_3",
    "item_id": "living_30_childrens_day2025_2_floor_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/30_childrens_day2025/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_30_childrens_day2025_3_above_fireplace_a_tier_1",
    "item_id": "living_30_childrens_day2025_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_30_childrens_day2025_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/30_childrens_day2025/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_30_childrens_day2025_3_above_fireplace_a_tier_2",
    "item_id": "living_30_childrens_day2025_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_30_childrens_day2025_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/30_childrens_day2025/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_30_childrens_day2025_3_above_fireplace_a_tier_3",
    "item_id": "living_30_childrens_day2025_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/30_childrens_day2025/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_30_childrens_day2025_4_painting_a_tier_1",
    "item_id": "living_30_childrens_day2025_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_30_childrens_day2025_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/30_childrens_day2025/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_30_childrens_day2025_4_painting_a_tier_2",
    "item_id": "living_30_childrens_day2025_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_30_childrens_day2025_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/30_childrens_day2025/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_30_childrens_day2025_4_painting_a_tier_3",
    "item_id": "living_30_childrens_day2025_4_painting_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/30_childrens_day2025/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_30_childrens_day2025_5_fireplace_a_tier_1",
    "item_id": "living_30_childrens_day2025_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_30_childrens_day2025_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/30_childrens_day2025/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_30_childrens_day2025_5_fireplace_a_tier_2",
    "item_id": "living_30_childrens_day2025_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_30_childrens_day2025_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/30_childrens_day2025/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_30_childrens_day2025_5_fireplace_a_tier_3",
    "item_id": "living_30_childrens_day2025_5_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/30_childrens_day2025/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_30_childrens_day2025_6_tree_a_tier_1",
    "item_id": "living_30_childrens_day2025_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_30_childrens_day2025_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/30_childrens_day2025/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_30_childrens_day2025_6_tree_a_tier_2",
    "item_id": "living_30_childrens_day2025_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_30_childrens_day2025_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/30_childrens_day2025/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_30_childrens_day2025_6_tree_a_tier_3",
    "item_id": "living_30_childrens_day2025_6_tree_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/30_childrens_day2025/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_30_childrens_day2025_7_couch_a_tier_1",
    "item_id": "living_30_childrens_day2025_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_30_childrens_day2025_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/30_childrens_day2025/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_30_childrens_day2025_7_couch_a_tier_2",
    "item_id": "living_30_childrens_day2025_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_30_childrens_day2025_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/30_childrens_day2025/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_30_childrens_day2025_7_couch_a_tier_3",
    "item_id": "living_30_childrens_day2025_7_couch_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/30_childrens_day2025/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_30_childrens_day2025_8_sidetable_a_tier_1",
    "item_id": "living_30_childrens_day2025_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_30_childrens_day2025_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/30_childrens_day2025/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_30_childrens_day2025_8_sidetable_a_tier_2",
    "item_id": "living_30_childrens_day2025_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_30_childrens_day2025_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/30_childrens_day2025/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_30_childrens_day2025_8_sidetable_a_tier_3",
    "item_id": "living_30_childrens_day2025_8_sidetable_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/30_childrens_day2025/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_31_mothers_day2025_1_wallpaper_a_tier_1",
    "item_id": "living_31_mothers_day2025_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_31_mothers_day2025_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/31_mothers_day2025/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_31_mothers_day2025_1_wallpaper_a_tier_2",
    "item_id": "living_31_mothers_day2025_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_31_mothers_day2025_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/31_mothers_day2025/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_31_mothers_day2025_1_wallpaper_a_tier_3",
    "item_id": "living_31_mothers_day2025_1_wallpaper_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/31_mothers_day2025/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_31_mothers_day2025_2_floor_a_tier_1",
    "item_id": "living_31_mothers_day2025_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_31_mothers_day2025_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/31_mothers_day2025/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_31_mothers_day2025_2_floor_a_tier_2",
    "item_id": "living_31_mothers_day2025_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_31_mothers_day2025_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/31_mothers_day2025/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_31_mothers_day2025_2_floor_a_tier_3",
    "item_id": "living_31_mothers_day2025_2_floor_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/31_mothers_day2025/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_31_mothers_day2025_3_above_fireplace_a_tier_1",
    "item_id": "living_31_mothers_day2025_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_31_mothers_day2025_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/31_mothers_day2025/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_31_mothers_day2025_3_above_fireplace_a_tier_2",
    "item_id": "living_31_mothers_day2025_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_31_mothers_day2025_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/31_mothers_day2025/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_31_mothers_day2025_3_above_fireplace_a_tier_3",
    "item_id": "living_31_mothers_day2025_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/31_mothers_day2025/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_31_mothers_day2025_4_painting_a_tier_1",
    "item_id": "living_31_mothers_day2025_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_31_mothers_day2025_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/31_mothers_day2025/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_31_mothers_day2025_4_painting_a_tier_2",
    "item_id": "living_31_mothers_day2025_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_31_mothers_day2025_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/31_mothers_day2025/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_31_mothers_day2025_4_painting_a_tier_3",
    "item_id": "living_31_mothers_day2025_4_painting_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/31_mothers_day2025/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_31_mothers_day2025_5_fireplace_a_tier_1",
    "item_id": "living_31_mothers_day2025_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_31_mothers_day2025_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/31_mothers_day2025/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_31_mothers_day2025_5_fireplace_a_tier_2",
    "item_id": "living_31_mothers_day2025_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_31_mothers_day2025_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/31_mothers_day2025/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_31_mothers_day2025_5_fireplace_a_tier_3",
    "item_id": "living_31_mothers_day2025_5_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/31_mothers_day2025/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_31_mothers_day2025_6_tree_a_tier_1",
    "item_id": "living_31_mothers_day2025_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_31_mothers_day2025_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/31_mothers_day2025/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_31_mothers_day2025_6_tree_a_tier_2",
    "item_id": "living_31_mothers_day2025_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_31_mothers_day2025_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/31_mothers_day2025/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_31_mothers_day2025_6_tree_a_tier_3",
    "item_id": "living_31_mothers_day2025_6_tree_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/31_mothers_day2025/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_31_mothers_day2025_7_couch_a_tier_1",
    "item_id": "living_31_mothers_day2025_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_31_mothers_day2025_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/31_mothers_day2025/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_31_mothers_day2025_7_couch_a_tier_2",
    "item_id": "living_31_mothers_day2025_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_31_mothers_day2025_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/31_mothers_day2025/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_31_mothers_day2025_7_couch_a_tier_3",
    "item_id": "living_31_mothers_day2025_7_couch_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/31_mothers_day2025/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_31_mothers_day2025_8_sidetable_a_tier_1",
    "item_id": "living_31_mothers_day2025_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_31_mothers_day2025_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/31_mothers_day2025/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_31_mothers_day2025_8_sidetable_a_tier_2",
    "item_id": "living_31_mothers_day2025_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_31_mothers_day2025_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/31_mothers_day2025/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_31_mothers_day2025_8_sidetable_a_tier_3",
    "item_id": "living_31_mothers_day2025_8_sidetable_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/31_mothers_day2025/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_32_melon_season_1_wallpaper_a_tier_1",
    "item_id": "living_32_melon_season_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_32_melon_season_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/32_melon_season/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_32_melon_season_1_wallpaper_a_tier_2",
    "item_id": "living_32_melon_season_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_32_melon_season_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/32_melon_season/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_32_melon_season_1_wallpaper_a_tier_3",
    "item_id": "living_32_melon_season_1_wallpaper_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/32_melon_season/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_32_melon_season_2_floor_a_tier_1",
    "item_id": "living_32_melon_season_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_32_melon_season_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/32_melon_season/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_32_melon_season_2_floor_a_tier_2",
    "item_id": "living_32_melon_season_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_32_melon_season_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/32_melon_season/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_32_melon_season_2_floor_a_tier_3",
    "item_id": "living_32_melon_season_2_floor_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/32_melon_season/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_32_melon_season_3_above_fireplace_a_tier_1",
    "item_id": "living_32_melon_season_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_32_melon_season_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/32_melon_season/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_32_melon_season_3_above_fireplace_a_tier_2",
    "item_id": "living_32_melon_season_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_32_melon_season_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/32_melon_season/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_32_melon_season_3_above_fireplace_a_tier_3",
    "item_id": "living_32_melon_season_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/32_melon_season/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_32_melon_season_4_painting_a_tier_1",
    "item_id": "living_32_melon_season_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_32_melon_season_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/32_melon_season/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_32_melon_season_4_painting_a_tier_2",
    "item_id": "living_32_melon_season_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_32_melon_season_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/32_melon_season/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_32_melon_season_4_painting_a_tier_3",
    "item_id": "living_32_melon_season_4_painting_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/32_melon_season/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_32_melon_season_5_fireplace_a_tier_1",
    "item_id": "living_32_melon_season_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_32_melon_season_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/32_melon_season/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_32_melon_season_5_fireplace_a_tier_2",
    "item_id": "living_32_melon_season_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_32_melon_season_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/32_melon_season/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_32_melon_season_5_fireplace_a_tier_3",
    "item_id": "living_32_melon_season_5_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/32_melon_season/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_32_melon_season_6_tree_a_tier_1",
    "item_id": "living_32_melon_season_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_32_melon_season_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/32_melon_season/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_32_melon_season_6_tree_a_tier_2",
    "item_id": "living_32_melon_season_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_32_melon_season_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/32_melon_season/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_32_melon_season_6_tree_a_tier_3",
    "item_id": "living_32_melon_season_6_tree_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/32_melon_season/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_32_melon_season_7_couch_a_tier_1",
    "item_id": "living_32_melon_season_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_32_melon_season_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/32_melon_season/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_32_melon_season_7_couch_a_tier_2",
    "item_id": "living_32_melon_season_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_32_melon_season_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/32_melon_season/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_32_melon_season_7_couch_a_tier_3",
    "item_id": "living_32_melon_season_7_couch_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/32_melon_season/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_32_melon_season_8_sidetable_a_tier_1",
    "item_id": "living_32_melon_season_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_32_melon_season_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/32_melon_season/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_32_melon_season_8_sidetable_a_tier_2",
    "item_id": "living_32_melon_season_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_32_melon_season_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/32_melon_season/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_32_melon_season_8_sidetable_a_tier_3",
    "item_id": "living_32_melon_season_8_sidetable_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/32_melon_season/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_33_tanabata_1_wallpaper_a_tier_1",
    "item_id": "living_33_tanabata_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_33_tanabata_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/33_tanabata/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_33_tanabata_1_wallpaper_a_tier_2",
    "item_id": "living_33_tanabata_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_33_tanabata_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/33_tanabata/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_33_tanabata_1_wallpaper_a_tier_3",
    "item_id": "living_33_tanabata_1_wallpaper_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/33_tanabata/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_33_tanabata_2_floor_a_tier_1",
    "item_id": "living_33_tanabata_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_33_tanabata_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/33_tanabata/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_33_tanabata_2_floor_a_tier_2",
    "item_id": "living_33_tanabata_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_33_tanabata_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/33_tanabata/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_33_tanabata_2_floor_a_tier_3",
    "item_id": "living_33_tanabata_2_floor_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/33_tanabata/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_33_tanabata_3_above_fireplace_a_tier_1",
    "item_id": "living_33_tanabata_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_33_tanabata_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/33_tanabata/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_33_tanabata_3_above_fireplace_a_tier_2",
    "item_id": "living_33_tanabata_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_33_tanabata_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/33_tanabata/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_33_tanabata_3_above_fireplace_a_tier_3",
    "item_id": "living_33_tanabata_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/33_tanabata/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_33_tanabata_4_painting_a_tier_1",
    "item_id": "living_33_tanabata_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_33_tanabata_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/33_tanabata/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_33_tanabata_4_painting_a_tier_2",
    "item_id": "living_33_tanabata_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_33_tanabata_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/33_tanabata/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_33_tanabata_4_painting_a_tier_3",
    "item_id": "living_33_tanabata_4_painting_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/33_tanabata/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_33_tanabata_5_fireplace_a_tier_1",
    "item_id": "living_33_tanabata_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_33_tanabata_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/33_tanabata/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_33_tanabata_5_fireplace_a_tier_2",
    "item_id": "living_33_tanabata_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_33_tanabata_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/33_tanabata/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_33_tanabata_5_fireplace_a_tier_3",
    "item_id": "living_33_tanabata_5_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/33_tanabata/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_33_tanabata_6_tree_a_tier_1",
    "item_id": "living_33_tanabata_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_33_tanabata_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/33_tanabata/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_33_tanabata_6_tree_a_tier_2",
    "item_id": "living_33_tanabata_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_33_tanabata_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/33_tanabata/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_33_tanabata_6_tree_a_tier_3",
    "item_id": "living_33_tanabata_6_tree_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/33_tanabata/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_33_tanabata_7_couch_a_tier_1",
    "item_id": "living_33_tanabata_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_33_tanabata_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/33_tanabata/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_33_tanabata_7_couch_a_tier_2",
    "item_id": "living_33_tanabata_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_33_tanabata_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/33_tanabata/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_33_tanabata_7_couch_a_tier_3",
    "item_id": "living_33_tanabata_7_couch_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/33_tanabata/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_33_tanabata_8_sidetable_a_tier_1",
    "item_id": "living_33_tanabata_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_33_tanabata_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/33_tanabata/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_33_tanabata_8_sidetable_a_tier_2",
    "item_id": "living_33_tanabata_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_33_tanabata_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/33_tanabata/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_33_tanabata_8_sidetable_a_tier_3",
    "item_id": "living_33_tanabata_8_sidetable_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/33_tanabata/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_34_kakigori_1_wallpaper_a_tier_1",
    "item_id": "living_34_kakigori_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_34_kakigori_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/34_kakigori/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_34_kakigori_1_wallpaper_a_tier_2",
    "item_id": "living_34_kakigori_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_34_kakigori_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/34_kakigori/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_34_kakigori_1_wallpaper_a_tier_3",
    "item_id": "living_34_kakigori_1_wallpaper_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/34_kakigori/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_34_kakigori_2_floor_a_tier_1",
    "item_id": "living_34_kakigori_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_34_kakigori_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/34_kakigori/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_34_kakigori_2_floor_a_tier_2",
    "item_id": "living_34_kakigori_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_34_kakigori_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/34_kakigori/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_34_kakigori_2_floor_a_tier_3",
    "item_id": "living_34_kakigori_2_floor_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/34_kakigori/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_34_kakigori_3_above_fireplace_a_tier_1",
    "item_id": "living_34_kakigori_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_34_kakigori_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/34_kakigori/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_34_kakigori_3_above_fireplace_a_tier_2",
    "item_id": "living_34_kakigori_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_34_kakigori_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/34_kakigori/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_34_kakigori_3_above_fireplace_a_tier_3",
    "item_id": "living_34_kakigori_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/34_kakigori/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_34_kakigori_4_painting_a_tier_1",
    "item_id": "living_34_kakigori_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_34_kakigori_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/34_kakigori/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_34_kakigori_4_painting_a_tier_2",
    "item_id": "living_34_kakigori_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_34_kakigori_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/34_kakigori/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_34_kakigori_4_painting_a_tier_3",
    "item_id": "living_34_kakigori_4_painting_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/34_kakigori/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_34_kakigori_5_fireplace_a_tier_1",
    "item_id": "living_34_kakigori_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_34_kakigori_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/34_kakigori/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_34_kakigori_5_fireplace_a_tier_2",
    "item_id": "living_34_kakigori_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_34_kakigori_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/34_kakigori/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_34_kakigori_5_fireplace_a_tier_3",
    "item_id": "living_34_kakigori_5_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/34_kakigori/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_34_kakigori_6_tree_a_tier_1",
    "item_id": "living_34_kakigori_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_34_kakigori_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/34_kakigori/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_34_kakigori_6_tree_a_tier_2",
    "item_id": "living_34_kakigori_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_34_kakigori_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/34_kakigori/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_34_kakigori_6_tree_a_tier_3",
    "item_id": "living_34_kakigori_6_tree_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/34_kakigori/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_34_kakigori_7_couch_a_tier_1",
    "item_id": "living_34_kakigori_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_34_kakigori_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/34_kakigori/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_34_kakigori_7_couch_a_tier_2",
    "item_id": "living_34_kakigori_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_34_kakigori_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/34_kakigori/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_34_kakigori_7_couch_a_tier_3",
    "item_id": "living_34_kakigori_7_couch_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/34_kakigori/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_34_kakigori_8_sidetable_a_tier_1",
    "item_id": "living_34_kakigori_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_34_kakigori_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/34_kakigori/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_34_kakigori_8_sidetable_a_tier_2",
    "item_id": "living_34_kakigori_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_34_kakigori_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/34_kakigori/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_34_kakigori_8_sidetable_a_tier_3",
    "item_id": "living_34_kakigori_8_sidetable_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/34_kakigori/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_35_moonviewing2025_1_wallpaper_a_tier_1",
    "item_id": "living_35_moonviewing2025_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_35_moonviewing2025_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/35_moonviewing2025/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_35_moonviewing2025_1_wallpaper_a_tier_2",
    "item_id": "living_35_moonviewing2025_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_35_moonviewing2025_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/35_moonviewing2025/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_35_moonviewing2025_1_wallpaper_a_tier_3",
    "item_id": "living_35_moonviewing2025_1_wallpaper_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/35_moonviewing2025/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_35_moonviewing2025_2_floor_a_tier_1",
    "item_id": "living_35_moonviewing2025_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_35_moonviewing2025_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/35_moonviewing2025/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_35_moonviewing2025_2_floor_a_tier_2",
    "item_id": "living_35_moonviewing2025_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_35_moonviewing2025_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/35_moonviewing2025/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_35_moonviewing2025_2_floor_a_tier_3",
    "item_id": "living_35_moonviewing2025_2_floor_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/35_moonviewing2025/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_35_moonviewing2025_3_above_fireplace_a_tier_1",
    "item_id": "living_35_moonviewing2025_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_35_moonviewing2025_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/35_moonviewing2025/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_35_moonviewing2025_3_above_fireplace_a_tier_2",
    "item_id": "living_35_moonviewing2025_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_35_moonviewing2025_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/35_moonviewing2025/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_35_moonviewing2025_3_above_fireplace_a_tier_3",
    "item_id": "living_35_moonviewing2025_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/35_moonviewing2025/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_35_moonviewing2025_4_painting_a_tier_1",
    "item_id": "living_35_moonviewing2025_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_35_moonviewing2025_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/35_moonviewing2025/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_35_moonviewing2025_4_painting_a_tier_2",
    "item_id": "living_35_moonviewing2025_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_35_moonviewing2025_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/35_moonviewing2025/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_35_moonviewing2025_4_painting_a_tier_3",
    "item_id": "living_35_moonviewing2025_4_painting_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/35_moonviewing2025/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_35_moonviewing2025_5_fireplace_a_tier_1",
    "item_id": "living_35_moonviewing2025_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_35_moonviewing2025_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/35_moonviewing2025/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_35_moonviewing2025_5_fireplace_a_tier_2",
    "item_id": "living_35_moonviewing2025_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_35_moonviewing2025_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/35_moonviewing2025/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_35_moonviewing2025_5_fireplace_a_tier_3",
    "item_id": "living_35_moonviewing2025_5_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/35_moonviewing2025/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_35_moonviewing2025_6_tree_a_tier_1",
    "item_id": "living_35_moonviewing2025_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_35_moonviewing2025_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/35_moonviewing2025/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_35_moonviewing2025_6_tree_a_tier_2",
    "item_id": "living_35_moonviewing2025_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_35_moonviewing2025_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/35_moonviewing2025/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_35_moonviewing2025_6_tree_a_tier_3",
    "item_id": "living_35_moonviewing2025_6_tree_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/35_moonviewing2025/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_35_moonviewing2025_7_couch_a_tier_1",
    "item_id": "living_35_moonviewing2025_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_35_moonviewing2025_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/35_moonviewing2025/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_35_moonviewing2025_7_couch_a_tier_2",
    "item_id": "living_35_moonviewing2025_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_35_moonviewing2025_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/35_moonviewing2025/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_35_moonviewing2025_7_couch_a_tier_3",
    "item_id": "living_35_moonviewing2025_7_couch_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/35_moonviewing2025/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_35_moonviewing2025_8_sidetable_a_tier_1",
    "item_id": "living_35_moonviewing2025_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_35_moonviewing2025_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/35_moonviewing2025/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_35_moonviewing2025_8_sidetable_a_tier_2",
    "item_id": "living_35_moonviewing2025_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_35_moonviewing2025_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/35_moonviewing2025/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_35_moonviewing2025_8_sidetable_a_tier_3",
    "item_id": "living_35_moonviewing2025_8_sidetable_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/35_moonviewing2025/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_36_magicalbooks_1_wallpaper_a_tier_1",
    "item_id": "living_36_magicalbooks_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_36_magicalbooks_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/36_magicalbooks/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_36_magicalbooks_1_wallpaper_a_tier_2",
    "item_id": "living_36_magicalbooks_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_36_magicalbooks_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/36_magicalbooks/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_36_magicalbooks_1_wallpaper_a_tier_3",
    "item_id": "living_36_magicalbooks_1_wallpaper_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/36_magicalbooks/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_36_magicalbooks_2_floor_a_tier_1",
    "item_id": "living_36_magicalbooks_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_36_magicalbooks_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/36_magicalbooks/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_36_magicalbooks_2_floor_a_tier_2",
    "item_id": "living_36_magicalbooks_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_36_magicalbooks_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/36_magicalbooks/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_36_magicalbooks_2_floor_a_tier_3",
    "item_id": "living_36_magicalbooks_2_floor_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/36_magicalbooks/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_36_magicalbooks_3_above_fireplace_a_tier_1",
    "item_id": "living_36_magicalbooks_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_36_magicalbooks_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/36_magicalbooks/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_36_magicalbooks_3_above_fireplace_a_tier_2",
    "item_id": "living_36_magicalbooks_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_36_magicalbooks_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/36_magicalbooks/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_36_magicalbooks_3_above_fireplace_a_tier_3",
    "item_id": "living_36_magicalbooks_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/36_magicalbooks/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_36_magicalbooks_4_painting_a_tier_1",
    "item_id": "living_36_magicalbooks_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_36_magicalbooks_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/36_magicalbooks/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_36_magicalbooks_4_painting_a_tier_2",
    "item_id": "living_36_magicalbooks_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_36_magicalbooks_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/36_magicalbooks/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_36_magicalbooks_4_painting_a_tier_3",
    "item_id": "living_36_magicalbooks_4_painting_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/36_magicalbooks/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_36_magicalbooks_5_fireplace_a_tier_1",
    "item_id": "living_36_magicalbooks_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_36_magicalbooks_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/36_magicalbooks/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_36_magicalbooks_5_fireplace_a_tier_2",
    "item_id": "living_36_magicalbooks_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_36_magicalbooks_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/36_magicalbooks/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_36_magicalbooks_5_fireplace_a_tier_3",
    "item_id": "living_36_magicalbooks_5_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/36_magicalbooks/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_36_magicalbooks_6_tree_a_tier_1",
    "item_id": "living_36_magicalbooks_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_36_magicalbooks_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/36_magicalbooks/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_36_magicalbooks_6_tree_a_tier_2",
    "item_id": "living_36_magicalbooks_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_36_magicalbooks_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/36_magicalbooks/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_36_magicalbooks_6_tree_a_tier_3",
    "item_id": "living_36_magicalbooks_6_tree_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/36_magicalbooks/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_36_magicalbooks_7_couch_a_tier_1",
    "item_id": "living_36_magicalbooks_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_36_magicalbooks_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/36_magicalbooks/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_36_magicalbooks_7_couch_a_tier_2",
    "item_id": "living_36_magicalbooks_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_36_magicalbooks_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/36_magicalbooks/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_36_magicalbooks_7_couch_a_tier_3",
    "item_id": "living_36_magicalbooks_7_couch_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/36_magicalbooks/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_36_magicalbooks_8_sidetable_a_tier_1",
    "item_id": "living_36_magicalbooks_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_36_magicalbooks_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/36_magicalbooks/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_36_magicalbooks_8_sidetable_a_tier_2",
    "item_id": "living_36_magicalbooks_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_36_magicalbooks_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/36_magicalbooks/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_36_magicalbooks_8_sidetable_a_tier_3",
    "item_id": "living_36_magicalbooks_8_sidetable_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/36_magicalbooks/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_37_taste_autumn_1_wallpaper_a_tier_1",
    "item_id": "living_37_taste_autumn_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_37_taste_autumn_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/37_taste_autumn/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_37_taste_autumn_1_wallpaper_a_tier_2",
    "item_id": "living_37_taste_autumn_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_37_taste_autumn_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/37_taste_autumn/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_37_taste_autumn_1_wallpaper_a_tier_3",
    "item_id": "living_37_taste_autumn_1_wallpaper_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/37_taste_autumn/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_37_taste_autumn_2_floor_a_tier_1",
    "item_id": "living_37_taste_autumn_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_37_taste_autumn_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/37_taste_autumn/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_37_taste_autumn_2_floor_a_tier_2",
    "item_id": "living_37_taste_autumn_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_37_taste_autumn_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/37_taste_autumn/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_37_taste_autumn_2_floor_a_tier_3",
    "item_id": "living_37_taste_autumn_2_floor_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/37_taste_autumn/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_37_taste_autumn_3_above_fireplace_a_tier_1",
    "item_id": "living_37_taste_autumn_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_37_taste_autumn_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/37_taste_autumn/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_37_taste_autumn_3_above_fireplace_a_tier_2",
    "item_id": "living_37_taste_autumn_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_37_taste_autumn_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/37_taste_autumn/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_37_taste_autumn_3_above_fireplace_a_tier_3",
    "item_id": "living_37_taste_autumn_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/37_taste_autumn/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_37_taste_autumn_4_painting_a_tier_1",
    "item_id": "living_37_taste_autumn_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_37_taste_autumn_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/37_taste_autumn/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_37_taste_autumn_4_painting_a_tier_2",
    "item_id": "living_37_taste_autumn_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_37_taste_autumn_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/37_taste_autumn/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_37_taste_autumn_4_painting_a_tier_3",
    "item_id": "living_37_taste_autumn_4_painting_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/37_taste_autumn/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_37_taste_autumn_5_fireplace_a_tier_1",
    "item_id": "living_37_taste_autumn_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_37_taste_autumn_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/37_taste_autumn/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_37_taste_autumn_5_fireplace_a_tier_2",
    "item_id": "living_37_taste_autumn_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_37_taste_autumn_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/37_taste_autumn/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_37_taste_autumn_5_fireplace_a_tier_3",
    "item_id": "living_37_taste_autumn_5_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/37_taste_autumn/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_37_taste_autumn_6_tree_a_tier_1",
    "item_id": "living_37_taste_autumn_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_37_taste_autumn_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/37_taste_autumn/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_37_taste_autumn_6_tree_a_tier_2",
    "item_id": "living_37_taste_autumn_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_37_taste_autumn_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/37_taste_autumn/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_37_taste_autumn_6_tree_a_tier_3",
    "item_id": "living_37_taste_autumn_6_tree_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/37_taste_autumn/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_37_taste_autumn_7_couch_a_tier_1",
    "item_id": "living_37_taste_autumn_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_37_taste_autumn_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/37_taste_autumn/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_37_taste_autumn_7_couch_a_tier_2",
    "item_id": "living_37_taste_autumn_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_37_taste_autumn_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/37_taste_autumn/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_37_taste_autumn_7_couch_a_tier_3",
    "item_id": "living_37_taste_autumn_7_couch_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/37_taste_autumn/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_37_taste_autumn_8_sidetable_a_tier_1",
    "item_id": "living_37_taste_autumn_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_37_taste_autumn_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/37_taste_autumn/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_37_taste_autumn_8_sidetable_a_tier_2",
    "item_id": "living_37_taste_autumn_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_37_taste_autumn_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/37_taste_autumn/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_37_taste_autumn_8_sidetable_a_tier_3",
    "item_id": "living_37_taste_autumn_8_sidetable_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/37_taste_autumn/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_38_winter_candle_1_wallpaper_a_tier_1",
    "item_id": "living_38_winter_candle_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_38_winter_candle_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/38_winter_candle/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_38_winter_candle_1_wallpaper_a_tier_2",
    "item_id": "living_38_winter_candle_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_38_winter_candle_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/38_winter_candle/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_38_winter_candle_1_wallpaper_a_tier_3",
    "item_id": "living_38_winter_candle_1_wallpaper_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/38_winter_candle/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_38_winter_candle_2_floor_a_tier_1",
    "item_id": "living_38_winter_candle_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_38_winter_candle_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/38_winter_candle/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_38_winter_candle_2_floor_a_tier_2",
    "item_id": "living_38_winter_candle_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_38_winter_candle_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/38_winter_candle/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_38_winter_candle_2_floor_a_tier_3",
    "item_id": "living_38_winter_candle_2_floor_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/38_winter_candle/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_38_winter_candle_3_above_fireplace_a_tier_1",
    "item_id": "living_38_winter_candle_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_38_winter_candle_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/38_winter_candle/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_38_winter_candle_3_above_fireplace_a_tier_2",
    "item_id": "living_38_winter_candle_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_38_winter_candle_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/38_winter_candle/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_38_winter_candle_3_above_fireplace_a_tier_3",
    "item_id": "living_38_winter_candle_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/38_winter_candle/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_38_winter_candle_4_painting_a_tier_1",
    "item_id": "living_38_winter_candle_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_38_winter_candle_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/38_winter_candle/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_38_winter_candle_4_painting_a_tier_2",
    "item_id": "living_38_winter_candle_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_38_winter_candle_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/38_winter_candle/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_38_winter_candle_4_painting_a_tier_3",
    "item_id": "living_38_winter_candle_4_painting_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/38_winter_candle/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_38_winter_candle_5_fireplace_a_tier_1",
    "item_id": "living_38_winter_candle_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_38_winter_candle_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/38_winter_candle/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_38_winter_candle_5_fireplace_a_tier_2",
    "item_id": "living_38_winter_candle_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_38_winter_candle_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/38_winter_candle/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_38_winter_candle_5_fireplace_a_tier_3",
    "item_id": "living_38_winter_candle_5_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/38_winter_candle/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_38_winter_candle_6_tree_a_tier_1",
    "item_id": "living_38_winter_candle_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_38_winter_candle_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/38_winter_candle/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_38_winter_candle_6_tree_a_tier_2",
    "item_id": "living_38_winter_candle_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_38_winter_candle_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/38_winter_candle/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_38_winter_candle_6_tree_a_tier_3",
    "item_id": "living_38_winter_candle_6_tree_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/38_winter_candle/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_38_winter_candle_7_couch_a_tier_1",
    "item_id": "living_38_winter_candle_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_38_winter_candle_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/38_winter_candle/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_38_winter_candle_7_couch_a_tier_2",
    "item_id": "living_38_winter_candle_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_38_winter_candle_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/38_winter_candle/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_38_winter_candle_7_couch_a_tier_3",
    "item_id": "living_38_winter_candle_7_couch_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/38_winter_candle/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_38_winter_candle_8_sidetable_a_tier_1",
    "item_id": "living_38_winter_candle_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_38_winter_candle_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/38_winter_candle/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_38_winter_candle_8_sidetable_a_tier_2",
    "item_id": "living_38_winter_candle_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_38_winter_candle_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/38_winter_candle/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_38_winter_candle_8_sidetable_a_tier_3",
    "item_id": "living_38_winter_candle_8_sidetable_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/38_winter_candle/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_39_ice_queens_castle_1_wallpaper_a_tier_1",
    "item_id": "living_39_ice_queens_castle_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_39_ice_queens_castle_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/39_ice_queens_castle/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_39_ice_queens_castle_1_wallpaper_a_tier_2",
    "item_id": "living_39_ice_queens_castle_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_39_ice_queens_castle_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/39_ice_queens_castle/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_39_ice_queens_castle_1_wallpaper_a_tier_3",
    "item_id": "living_39_ice_queens_castle_1_wallpaper_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/39_ice_queens_castle/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_39_ice_queens_castle_2_floor_a_tier_1",
    "item_id": "living_39_ice_queens_castle_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_39_ice_queens_castle_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/39_ice_queens_castle/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_39_ice_queens_castle_2_floor_a_tier_2",
    "item_id": "living_39_ice_queens_castle_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_39_ice_queens_castle_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/39_ice_queens_castle/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_39_ice_queens_castle_2_floor_a_tier_3",
    "item_id": "living_39_ice_queens_castle_2_floor_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/39_ice_queens_castle/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_39_ice_queens_castle_3_above_fireplace_a_tier_1",
    "item_id": "living_39_ice_queens_castle_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_39_ice_queens_castle_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/39_ice_queens_castle/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_39_ice_queens_castle_3_above_fireplace_a_tier_2",
    "item_id": "living_39_ice_queens_castle_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_39_ice_queens_castle_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/39_ice_queens_castle/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_39_ice_queens_castle_3_above_fireplace_a_tier_3",
    "item_id": "living_39_ice_queens_castle_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/39_ice_queens_castle/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_39_ice_queens_castle_4_painting_a_tier_1",
    "item_id": "living_39_ice_queens_castle_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_39_ice_queens_castle_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/39_ice_queens_castle/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_39_ice_queens_castle_4_painting_a_tier_2",
    "item_id": "living_39_ice_queens_castle_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_39_ice_queens_castle_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/39_ice_queens_castle/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_39_ice_queens_castle_4_painting_a_tier_3",
    "item_id": "living_39_ice_queens_castle_4_painting_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/39_ice_queens_castle/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_39_ice_queens_castle_5_fireplace_a_tier_1",
    "item_id": "living_39_ice_queens_castle_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_39_ice_queens_castle_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/39_ice_queens_castle/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_39_ice_queens_castle_5_fireplace_a_tier_2",
    "item_id": "living_39_ice_queens_castle_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_39_ice_queens_castle_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/39_ice_queens_castle/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_39_ice_queens_castle_5_fireplace_a_tier_3",
    "item_id": "living_39_ice_queens_castle_5_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/39_ice_queens_castle/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_39_ice_queens_castle_6_tree_a_tier_1",
    "item_id": "living_39_ice_queens_castle_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_39_ice_queens_castle_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/39_ice_queens_castle/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_39_ice_queens_castle_6_tree_a_tier_2",
    "item_id": "living_39_ice_queens_castle_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_39_ice_queens_castle_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/39_ice_queens_castle/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_39_ice_queens_castle_6_tree_a_tier_3",
    "item_id": "living_39_ice_queens_castle_6_tree_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/39_ice_queens_castle/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_39_ice_queens_castle_7_couch_a_tier_1",
    "item_id": "living_39_ice_queens_castle_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_39_ice_queens_castle_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/39_ice_queens_castle/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_39_ice_queens_castle_7_couch_a_tier_2",
    "item_id": "living_39_ice_queens_castle_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_39_ice_queens_castle_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/39_ice_queens_castle/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_39_ice_queens_castle_7_couch_a_tier_3",
    "item_id": "living_39_ice_queens_castle_7_couch_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/39_ice_queens_castle/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_39_ice_queens_castle_8_sidetable_a_tier_1",
    "item_id": "living_39_ice_queens_castle_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_39_ice_queens_castle_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/39_ice_queens_castle/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_39_ice_queens_castle_8_sidetable_a_tier_2",
    "item_id": "living_39_ice_queens_castle_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_39_ice_queens_castle_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/39_ice_queens_castle/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_39_ice_queens_castle_8_sidetable_a_tier_3",
    "item_id": "living_39_ice_queens_castle_8_sidetable_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/39_ice_queens_castle/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_40_artisan_chocolatier_1_wallpaper_a_tier_1",
    "item_id": "living_40_artisan_chocolatier_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_40_artisan_chocolatier_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/40_artisan_chocolatier/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_40_artisan_chocolatier_1_wallpaper_a_tier_2",
    "item_id": "living_40_artisan_chocolatier_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_40_artisan_chocolatier_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/40_artisan_chocolatier/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_40_artisan_chocolatier_1_wallpaper_a_tier_3",
    "item_id": "living_40_artisan_chocolatier_1_wallpaper_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/40_artisan_chocolatier/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_40_artisan_chocolatier_2_floor_a_tier_1",
    "item_id": "living_40_artisan_chocolatier_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_40_artisan_chocolatier_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/40_artisan_chocolatier/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_40_artisan_chocolatier_2_floor_a_tier_2",
    "item_id": "living_40_artisan_chocolatier_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_40_artisan_chocolatier_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/40_artisan_chocolatier/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_40_artisan_chocolatier_2_floor_a_tier_3",
    "item_id": "living_40_artisan_chocolatier_2_floor_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/40_artisan_chocolatier/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_40_artisan_chocolatier_3_above_fireplace_a_tier_1",
    "item_id": "living_40_artisan_chocolatier_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_40_artisan_chocolatier_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/40_artisan_chocolatier/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_40_artisan_chocolatier_3_above_fireplace_a_tier_2",
    "item_id": "living_40_artisan_chocolatier_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_40_artisan_chocolatier_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/40_artisan_chocolatier/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_40_artisan_chocolatier_3_above_fireplace_a_tier_3",
    "item_id": "living_40_artisan_chocolatier_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/40_artisan_chocolatier/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_40_artisan_chocolatier_4_painting_a_tier_1",
    "item_id": "living_40_artisan_chocolatier_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_40_artisan_chocolatier_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/40_artisan_chocolatier/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_40_artisan_chocolatier_4_painting_a_tier_2",
    "item_id": "living_40_artisan_chocolatier_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_40_artisan_chocolatier_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/40_artisan_chocolatier/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_40_artisan_chocolatier_4_painting_a_tier_3",
    "item_id": "living_40_artisan_chocolatier_4_painting_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/40_artisan_chocolatier/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_40_artisan_chocolatier_5_fireplace_a_tier_1",
    "item_id": "living_40_artisan_chocolatier_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_40_artisan_chocolatier_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/40_artisan_chocolatier/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_40_artisan_chocolatier_5_fireplace_a_tier_2",
    "item_id": "living_40_artisan_chocolatier_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_40_artisan_chocolatier_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/40_artisan_chocolatier/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_40_artisan_chocolatier_5_fireplace_a_tier_3",
    "item_id": "living_40_artisan_chocolatier_5_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/40_artisan_chocolatier/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_40_artisan_chocolatier_6_tree_a_tier_1",
    "item_id": "living_40_artisan_chocolatier_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_40_artisan_chocolatier_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/40_artisan_chocolatier/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_40_artisan_chocolatier_6_tree_a_tier_2",
    "item_id": "living_40_artisan_chocolatier_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_40_artisan_chocolatier_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/40_artisan_chocolatier/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_40_artisan_chocolatier_6_tree_a_tier_3",
    "item_id": "living_40_artisan_chocolatier_6_tree_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/40_artisan_chocolatier/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_40_artisan_chocolatier_7_couch_a_tier_1",
    "item_id": "living_40_artisan_chocolatier_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_40_artisan_chocolatier_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/40_artisan_chocolatier/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_40_artisan_chocolatier_7_couch_a_tier_2",
    "item_id": "living_40_artisan_chocolatier_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_40_artisan_chocolatier_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/40_artisan_chocolatier/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_40_artisan_chocolatier_7_couch_a_tier_3",
    "item_id": "living_40_artisan_chocolatier_7_couch_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/40_artisan_chocolatier/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_40_artisan_chocolatier_8_sidetable_a_tier_1",
    "item_id": "living_40_artisan_chocolatier_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_40_artisan_chocolatier_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/40_artisan_chocolatier/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_40_artisan_chocolatier_8_sidetable_a_tier_2",
    "item_id": "living_40_artisan_chocolatier_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_40_artisan_chocolatier_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/40_artisan_chocolatier/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_40_artisan_chocolatier_8_sidetable_a_tier_3",
    "item_id": "living_40_artisan_chocolatier_8_sidetable_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/40_artisan_chocolatier/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_41_valentine_day_1_wallpaper_a_tier_1",
    "item_id": "living_41_valentine_day_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_41_valentine_day_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/41_valentine_day/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_41_valentine_day_1_wallpaper_a_tier_2",
    "item_id": "living_41_valentine_day_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_41_valentine_day_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/41_valentine_day/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_41_valentine_day_1_wallpaper_a_tier_3",
    "item_id": "living_41_valentine_day_1_wallpaper_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/41_valentine_day/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_41_valentine_day_2_floor_a_tier_1",
    "item_id": "living_41_valentine_day_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_41_valentine_day_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/41_valentine_day/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_41_valentine_day_2_floor_a_tier_2",
    "item_id": "living_41_valentine_day_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_41_valentine_day_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/41_valentine_day/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_41_valentine_day_2_floor_a_tier_3",
    "item_id": "living_41_valentine_day_2_floor_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/41_valentine_day/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_41_valentine_day_3_above_fireplace_a_tier_1",
    "item_id": "living_41_valentine_day_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_41_valentine_day_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/41_valentine_day/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_41_valentine_day_3_above_fireplace_a_tier_2",
    "item_id": "living_41_valentine_day_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_41_valentine_day_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/41_valentine_day/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_41_valentine_day_3_above_fireplace_a_tier_3",
    "item_id": "living_41_valentine_day_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/41_valentine_day/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_41_valentine_day_4_painting_a_tier_1",
    "item_id": "living_41_valentine_day_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_41_valentine_day_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/41_valentine_day/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_41_valentine_day_4_painting_a_tier_2",
    "item_id": "living_41_valentine_day_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_41_valentine_day_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/41_valentine_day/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_41_valentine_day_4_painting_a_tier_3",
    "item_id": "living_41_valentine_day_4_painting_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/41_valentine_day/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_41_valentine_day_5_fireplace_a_tier_1",
    "item_id": "living_41_valentine_day_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_41_valentine_day_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/41_valentine_day/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_41_valentine_day_5_fireplace_a_tier_2",
    "item_id": "living_41_valentine_day_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_41_valentine_day_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/41_valentine_day/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_41_valentine_day_5_fireplace_a_tier_3",
    "item_id": "living_41_valentine_day_5_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/41_valentine_day/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_41_valentine_day_6_tree_a_tier_1",
    "item_id": "living_41_valentine_day_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_41_valentine_day_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/41_valentine_day/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_41_valentine_day_6_tree_a_tier_2",
    "item_id": "living_41_valentine_day_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_41_valentine_day_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/41_valentine_day/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_41_valentine_day_6_tree_a_tier_3",
    "item_id": "living_41_valentine_day_6_tree_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/41_valentine_day/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_41_valentine_day_7_couch_a_tier_1",
    "item_id": "living_41_valentine_day_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_41_valentine_day_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/41_valentine_day/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_41_valentine_day_7_couch_a_tier_2",
    "item_id": "living_41_valentine_day_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_41_valentine_day_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/41_valentine_day/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_41_valentine_day_7_couch_a_tier_3",
    "item_id": "living_41_valentine_day_7_couch_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/41_valentine_day/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_41_valentine_day_8_sidetable_a_tier_1",
    "item_id": "living_41_valentine_day_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_41_valentine_day_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/41_valentine_day/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_41_valentine_day_8_sidetable_a_tier_2",
    "item_id": "living_41_valentine_day_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_41_valentine_day_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/41_valentine_day/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_41_valentine_day_8_sidetable_a_tier_3",
    "item_id": "living_41_valentine_day_8_sidetable_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/41_valentine_day/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_42_spring_tea_party_1_wallpaper_a_tier_1",
    "item_id": "living_42_spring_tea_party_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_42_spring_tea_party_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/42_spring_tea_party/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_42_spring_tea_party_1_wallpaper_a_tier_2",
    "item_id": "living_42_spring_tea_party_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_42_spring_tea_party_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/42_spring_tea_party/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_42_spring_tea_party_1_wallpaper_a_tier_3",
    "item_id": "living_42_spring_tea_party_1_wallpaper_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/42_spring_tea_party/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_42_spring_tea_party_2_floor_a_tier_1",
    "item_id": "living_42_spring_tea_party_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_42_spring_tea_party_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/42_spring_tea_party/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_42_spring_tea_party_2_floor_a_tier_2",
    "item_id": "living_42_spring_tea_party_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_42_spring_tea_party_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/42_spring_tea_party/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_42_spring_tea_party_2_floor_a_tier_3",
    "item_id": "living_42_spring_tea_party_2_floor_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/42_spring_tea_party/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_42_spring_tea_party_3_above_fireplace_a_tier_1",
    "item_id": "living_42_spring_tea_party_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_42_spring_tea_party_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/42_spring_tea_party/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_42_spring_tea_party_3_above_fireplace_a_tier_2",
    "item_id": "living_42_spring_tea_party_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_42_spring_tea_party_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/42_spring_tea_party/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_42_spring_tea_party_3_above_fireplace_a_tier_3",
    "item_id": "living_42_spring_tea_party_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/42_spring_tea_party/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_42_spring_tea_party_4_painting_a_tier_1",
    "item_id": "living_42_spring_tea_party_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_42_spring_tea_party_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/42_spring_tea_party/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_42_spring_tea_party_4_painting_a_tier_2",
    "item_id": "living_42_spring_tea_party_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_42_spring_tea_party_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/42_spring_tea_party/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_42_spring_tea_party_4_painting_a_tier_3",
    "item_id": "living_42_spring_tea_party_4_painting_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/42_spring_tea_party/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_42_spring_tea_party_5_fireplace_a_tier_1",
    "item_id": "living_42_spring_tea_party_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_42_spring_tea_party_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/42_spring_tea_party/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_42_spring_tea_party_5_fireplace_a_tier_2",
    "item_id": "living_42_spring_tea_party_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_42_spring_tea_party_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/42_spring_tea_party/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_42_spring_tea_party_5_fireplace_a_tier_3",
    "item_id": "living_42_spring_tea_party_5_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/42_spring_tea_party/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_42_spring_tea_party_6_tree_a_tier_1",
    "item_id": "living_42_spring_tea_party_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_42_spring_tea_party_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/42_spring_tea_party/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_42_spring_tea_party_6_tree_a_tier_2",
    "item_id": "living_42_spring_tea_party_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_42_spring_tea_party_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/42_spring_tea_party/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_42_spring_tea_party_6_tree_a_tier_3",
    "item_id": "living_42_spring_tea_party_6_tree_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/42_spring_tea_party/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_42_spring_tea_party_7_couch_a_tier_1",
    "item_id": "living_42_spring_tea_party_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_42_spring_tea_party_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/42_spring_tea_party/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_42_spring_tea_party_7_couch_a_tier_2",
    "item_id": "living_42_spring_tea_party_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_42_spring_tea_party_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/42_spring_tea_party/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_42_spring_tea_party_7_couch_a_tier_3",
    "item_id": "living_42_spring_tea_party_7_couch_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/42_spring_tea_party/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_42_spring_tea_party_8_sidetable_a_tier_1",
    "item_id": "living_42_spring_tea_party_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_42_spring_tea_party_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/42_spring_tea_party/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_42_spring_tea_party_8_sidetable_a_tier_2",
    "item_id": "living_42_spring_tea_party_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_42_spring_tea_party_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/42_spring_tea_party/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_42_spring_tea_party_8_sidetable_a_tier_3",
    "item_id": "living_42_spring_tea_party_8_sidetable_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/42_spring_tea_party/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_43_easter_egg_hunt_1_wallpaper_a_tier_1",
    "item_id": "living_43_easter_egg_hunt_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_43_easter_egg_hunt_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/43_easter_egg_hunt/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_43_easter_egg_hunt_1_wallpaper_a_tier_2",
    "item_id": "living_43_easter_egg_hunt_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_43_easter_egg_hunt_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/43_easter_egg_hunt/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_43_easter_egg_hunt_1_wallpaper_a_tier_3",
    "item_id": "living_43_easter_egg_hunt_1_wallpaper_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/43_easter_egg_hunt/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_43_easter_egg_hunt_2_floor_a_tier_1",
    "item_id": "living_43_easter_egg_hunt_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_43_easter_egg_hunt_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/43_easter_egg_hunt/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_43_easter_egg_hunt_2_floor_a_tier_2",
    "item_id": "living_43_easter_egg_hunt_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_43_easter_egg_hunt_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/43_easter_egg_hunt/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_43_easter_egg_hunt_2_floor_a_tier_3",
    "item_id": "living_43_easter_egg_hunt_2_floor_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/43_easter_egg_hunt/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_43_easter_egg_hunt_3_above_fireplace_a_tier_1",
    "item_id": "living_43_easter_egg_hunt_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_43_easter_egg_hunt_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/43_easter_egg_hunt/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_43_easter_egg_hunt_3_above_fireplace_a_tier_2",
    "item_id": "living_43_easter_egg_hunt_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_43_easter_egg_hunt_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/43_easter_egg_hunt/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_43_easter_egg_hunt_3_above_fireplace_a_tier_3",
    "item_id": "living_43_easter_egg_hunt_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/43_easter_egg_hunt/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_43_easter_egg_hunt_4_painting_a_tier_1",
    "item_id": "living_43_easter_egg_hunt_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_43_easter_egg_hunt_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/43_easter_egg_hunt/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_43_easter_egg_hunt_4_painting_a_tier_2",
    "item_id": "living_43_easter_egg_hunt_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_43_easter_egg_hunt_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/43_easter_egg_hunt/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_43_easter_egg_hunt_4_painting_a_tier_3",
    "item_id": "living_43_easter_egg_hunt_4_painting_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/43_easter_egg_hunt/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_43_easter_egg_hunt_5_fireplace_a_tier_1",
    "item_id": "living_43_easter_egg_hunt_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_43_easter_egg_hunt_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/43_easter_egg_hunt/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_43_easter_egg_hunt_5_fireplace_a_tier_2",
    "item_id": "living_43_easter_egg_hunt_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_43_easter_egg_hunt_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/43_easter_egg_hunt/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_43_easter_egg_hunt_5_fireplace_a_tier_3",
    "item_id": "living_43_easter_egg_hunt_5_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/43_easter_egg_hunt/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_43_easter_egg_hunt_6_tree_a_tier_1",
    "item_id": "living_43_easter_egg_hunt_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_43_easter_egg_hunt_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/43_easter_egg_hunt/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_43_easter_egg_hunt_6_tree_a_tier_2",
    "item_id": "living_43_easter_egg_hunt_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_43_easter_egg_hunt_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/43_easter_egg_hunt/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_43_easter_egg_hunt_6_tree_a_tier_3",
    "item_id": "living_43_easter_egg_hunt_6_tree_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/43_easter_egg_hunt/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_43_easter_egg_hunt_7_couch_a_tier_1",
    "item_id": "living_43_easter_egg_hunt_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_43_easter_egg_hunt_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/43_easter_egg_hunt/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_43_easter_egg_hunt_7_couch_a_tier_2",
    "item_id": "living_43_easter_egg_hunt_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_43_easter_egg_hunt_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/43_easter_egg_hunt/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_43_easter_egg_hunt_7_couch_a_tier_3",
    "item_id": "living_43_easter_egg_hunt_7_couch_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/43_easter_egg_hunt/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_43_easter_egg_hunt_8_sidetable_a_tier_1",
    "item_id": "living_43_easter_egg_hunt_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_43_easter_egg_hunt_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/43_easter_egg_hunt/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_43_easter_egg_hunt_8_sidetable_a_tier_2",
    "item_id": "living_43_easter_egg_hunt_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_43_easter_egg_hunt_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/43_easter_egg_hunt/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_43_easter_egg_hunt_8_sidetable_a_tier_3",
    "item_id": "living_43_easter_egg_hunt_8_sidetable_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/43_easter_egg_hunt/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_44_golden_week_day_1_wallpaper_a_tier_1",
    "item_id": "living_44_golden_week_day_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_44_golden_week_day_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/44_golden_week/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_44_golden_week_day_1_wallpaper_a_tier_2",
    "item_id": "living_44_golden_week_day_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_44_golden_week_day_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/44_golden_week/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_44_golden_week_day_1_wallpaper_a_tier_3",
    "item_id": "living_44_golden_week_day_1_wallpaper_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/44_golden_week/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_44_golden_week_day_2_floor_a_tier_1",
    "item_id": "living_44_golden_week_day_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_44_golden_week_day_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/44_golden_week/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_44_golden_week_day_2_floor_a_tier_2",
    "item_id": "living_44_golden_week_day_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_44_golden_week_day_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/44_golden_week/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_44_golden_week_day_2_floor_a_tier_3",
    "item_id": "living_44_golden_week_day_2_floor_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/44_golden_week/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_44_golden_week_day_3_above_fireplace_a_tier_1",
    "item_id": "living_44_golden_week_day_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_44_golden_week_day_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/44_golden_week/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_44_golden_week_day_3_above_fireplace_a_tier_2",
    "item_id": "living_44_golden_week_day_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_44_golden_week_day_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/44_golden_week/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_44_golden_week_day_3_above_fireplace_a_tier_3",
    "item_id": "living_44_golden_week_day_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/44_golden_week/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_44_golden_week_day_4_painting_a_tier_1",
    "item_id": "living_44_golden_week_day_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_44_golden_week_day_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/44_golden_week/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_44_golden_week_day_4_painting_a_tier_2",
    "item_id": "living_44_golden_week_day_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_44_golden_week_day_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/44_golden_week/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_44_golden_week_day_4_painting_a_tier_3",
    "item_id": "living_44_golden_week_day_4_painting_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/44_golden_week/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_44_golden_week_day_5_fireplace_a_tier_1",
    "item_id": "living_44_golden_week_day_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_44_golden_week_day_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/44_golden_week/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_44_golden_week_day_5_fireplace_a_tier_2",
    "item_id": "living_44_golden_week_day_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_44_golden_week_day_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/44_golden_week/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_44_golden_week_day_5_fireplace_a_tier_3",
    "item_id": "living_44_golden_week_day_5_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/44_golden_week/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_44_golden_week_day_6_tree_a_tier_1",
    "item_id": "living_44_golden_week_day_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_44_golden_week_day_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/44_golden_week/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_44_golden_week_day_6_tree_a_tier_2",
    "item_id": "living_44_golden_week_day_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_44_golden_week_day_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/44_golden_week/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_44_golden_week_day_6_tree_a_tier_3",
    "item_id": "living_44_golden_week_day_6_tree_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/44_golden_week/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_44_golden_week_day_7_couch_a_tier_1",
    "item_id": "living_44_golden_week_day_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_44_golden_week_day_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/44_golden_week/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_44_golden_week_day_7_couch_a_tier_2",
    "item_id": "living_44_golden_week_day_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_44_golden_week_day_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/44_golden_week/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_44_golden_week_day_7_couch_a_tier_3",
    "item_id": "living_44_golden_week_day_7_couch_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/44_golden_week/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_44_golden_week_day_8_sidetable_a_tier_1",
    "item_id": "living_44_golden_week_day_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_44_golden_week_day_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/44_golden_week/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_44_golden_week_day_8_sidetable_a_tier_2",
    "item_id": "living_44_golden_week_day_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_44_golden_week_day_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/44_golden_week/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_44_golden_week_day_8_sidetable_a_tier_3",
    "item_id": "living_44_golden_week_day_8_sidetable_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/44_golden_week/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_45_rainyseason_bookcafe_day_1_wallpaper_a_tier_1",
    "item_id": "living_45_rainyseason_bookcafe_day_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_45_rainyseason_bookcafe_day_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/45_rainyseason_bookcafe/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_45_rainyseason_bookcafe_day_1_wallpaper_a_tier_2",
    "item_id": "living_45_rainyseason_bookcafe_day_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_45_rainyseason_bookcafe_day_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/45_rainyseason_bookcafe/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_45_rainyseason_bookcafe_day_1_wallpaper_a_tier_3",
    "item_id": "living_45_rainyseason_bookcafe_day_1_wallpaper_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/45_rainyseason_bookcafe/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_45_rainyseason_bookcafe_day_2_floor_a_tier_1",
    "item_id": "living_45_rainyseason_bookcafe_day_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_45_rainyseason_bookcafe_day_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/45_rainyseason_bookcafe/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_45_rainyseason_bookcafe_day_2_floor_a_tier_2",
    "item_id": "living_45_rainyseason_bookcafe_day_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_45_rainyseason_bookcafe_day_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/45_rainyseason_bookcafe/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_45_rainyseason_bookcafe_day_2_floor_a_tier_3",
    "item_id": "living_45_rainyseason_bookcafe_day_2_floor_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/45_rainyseason_bookcafe/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_45_rainyseason_bookcafe_day_3_above_fireplace_a_tier_1",
    "item_id": "living_45_rainyseason_bookcafe_day_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_45_rainyseason_bookcafe_day_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/45_rainyseason_bookcafe/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_45_rainyseason_bookcafe_day_3_above_fireplace_a_tier_2",
    "item_id": "living_45_rainyseason_bookcafe_day_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_45_rainyseason_bookcafe_day_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/45_rainyseason_bookcafe/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_45_rainyseason_bookcafe_day_3_above_fireplace_a_tier_3",
    "item_id": "living_45_rainyseason_bookcafe_day_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/45_rainyseason_bookcafe/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_45_rainyseason_bookcafe_day_4_painting_a_tier_1",
    "item_id": "living_45_rainyseason_bookcafe_day_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_45_rainyseason_bookcafe_day_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/45_rainyseason_bookcafe/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_45_rainyseason_bookcafe_day_4_painting_a_tier_2",
    "item_id": "living_45_rainyseason_bookcafe_day_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_45_rainyseason_bookcafe_day_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/45_rainyseason_bookcafe/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_45_rainyseason_bookcafe_day_4_painting_a_tier_3",
    "item_id": "living_45_rainyseason_bookcafe_day_4_painting_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/45_rainyseason_bookcafe/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_45_rainyseason_bookcafe_day_5_fireplace_a_tier_1",
    "item_id": "living_45_rainyseason_bookcafe_day_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_45_rainyseason_bookcafe_day_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/45_rainyseason_bookcafe/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_45_rainyseason_bookcafe_day_5_fireplace_a_tier_2",
    "item_id": "living_45_rainyseason_bookcafe_day_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_45_rainyseason_bookcafe_day_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/45_rainyseason_bookcafe/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_45_rainyseason_bookcafe_day_5_fireplace_a_tier_3",
    "item_id": "living_45_rainyseason_bookcafe_day_5_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/45_rainyseason_bookcafe/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_45_rainyseason_bookcafe_day_6_tree_a_tier_1",
    "item_id": "living_45_rainyseason_bookcafe_day_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_45_rainyseason_bookcafe_day_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/45_rainyseason_bookcafe/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_45_rainyseason_bookcafe_day_6_tree_a_tier_2",
    "item_id": "living_45_rainyseason_bookcafe_day_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_45_rainyseason_bookcafe_day_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/45_rainyseason_bookcafe/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_45_rainyseason_bookcafe_day_6_tree_a_tier_3",
    "item_id": "living_45_rainyseason_bookcafe_day_6_tree_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/45_rainyseason_bookcafe/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_45_rainyseason_bookcafe_day_7_couch_a_tier_1",
    "item_id": "living_45_rainyseason_bookcafe_day_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_45_rainyseason_bookcafe_day_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/45_rainyseason_bookcafe/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_45_rainyseason_bookcafe_day_7_couch_a_tier_2",
    "item_id": "living_45_rainyseason_bookcafe_day_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_45_rainyseason_bookcafe_day_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/45_rainyseason_bookcafe/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_45_rainyseason_bookcafe_day_7_couch_a_tier_3",
    "item_id": "living_45_rainyseason_bookcafe_day_7_couch_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/45_rainyseason_bookcafe/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_45_rainyseason_bookcafe_day_8_sidetable_a_tier_1",
    "item_id": "living_45_rainyseason_bookcafe_day_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_45_rainyseason_bookcafe_day_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/45_rainyseason_bookcafe/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_45_rainyseason_bookcafe_day_8_sidetable_a_tier_2",
    "item_id": "living_45_rainyseason_bookcafe_day_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_45_rainyseason_bookcafe_day_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/45_rainyseason_bookcafe/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_45_rainyseason_bookcafe_day_8_sidetable_a_tier_3",
    "item_id": "living_45_rainyseason_bookcafe_day_8_sidetable_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/45_rainyseason_bookcafe/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_46_tropical_island_vacation_day_1_wallpaper_a_tier_1",
    "item_id": "living_46_tropical_island_vacation_day_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_46_tropical_island_vacation_day_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/46_tropical_island_vacation/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_46_tropical_island_vacation_day_1_wallpaper_a_tier_2",
    "item_id": "living_46_tropical_island_vacation_day_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_46_tropical_island_vacation_day_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/46_tropical_island_vacation/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_46_tropical_island_vacation_day_1_wallpaper_a_tier_3",
    "item_id": "living_46_tropical_island_vacation_day_1_wallpaper_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/46_tropical_island_vacation/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_46_tropical_island_vacation_day_2_floor_a_tier_1",
    "item_id": "living_46_tropical_island_vacation_day_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_46_tropical_island_vacation_day_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/46_tropical_island_vacation/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_46_tropical_island_vacation_day_2_floor_a_tier_2",
    "item_id": "living_46_tropical_island_vacation_day_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_46_tropical_island_vacation_day_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/46_tropical_island_vacation/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_46_tropical_island_vacation_day_2_floor_a_tier_3",
    "item_id": "living_46_tropical_island_vacation_day_2_floor_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/46_tropical_island_vacation/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_46_tropical_island_vacation_day_3_above_fireplace_a_tier_1",
    "item_id": "living_46_tropical_island_vacation_day_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_46_tropical_island_vacation_day_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/46_tropical_island_vacation/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_46_tropical_island_vacation_day_3_above_fireplace_a_tier_2",
    "item_id": "living_46_tropical_island_vacation_day_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_46_tropical_island_vacation_day_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/46_tropical_island_vacation/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_46_tropical_island_vacation_day_3_above_fireplace_a_tier_3",
    "item_id": "living_46_tropical_island_vacation_day_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/46_tropical_island_vacation/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_46_tropical_island_vacation_day_4_painting_a_tier_1",
    "item_id": "living_46_tropical_island_vacation_day_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_46_tropical_island_vacation_day_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/46_tropical_island_vacation/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_46_tropical_island_vacation_day_4_painting_a_tier_2",
    "item_id": "living_46_tropical_island_vacation_day_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_46_tropical_island_vacation_day_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/46_tropical_island_vacation/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_46_tropical_island_vacation_day_4_painting_a_tier_3",
    "item_id": "living_46_tropical_island_vacation_day_4_painting_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/46_tropical_island_vacation/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_46_tropical_island_vacation_day_5_fireplace_a_tier_1",
    "item_id": "living_46_tropical_island_vacation_day_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_46_tropical_island_vacation_day_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/46_tropical_island_vacation/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_46_tropical_island_vacation_day_5_fireplace_a_tier_2",
    "item_id": "living_46_tropical_island_vacation_day_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_46_tropical_island_vacation_day_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/46_tropical_island_vacation/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_46_tropical_island_vacation_day_5_fireplace_a_tier_3",
    "item_id": "living_46_tropical_island_vacation_day_5_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/46_tropical_island_vacation/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_46_tropical_island_vacation_day_6_tree_a_tier_1",
    "item_id": "living_46_tropical_island_vacation_day_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_46_tropical_island_vacation_day_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/46_tropical_island_vacation/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_46_tropical_island_vacation_day_6_tree_a_tier_2",
    "item_id": "living_46_tropical_island_vacation_day_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_46_tropical_island_vacation_day_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/46_tropical_island_vacation/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_46_tropical_island_vacation_day_6_tree_a_tier_3",
    "item_id": "living_46_tropical_island_vacation_day_6_tree_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/46_tropical_island_vacation/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_46_tropical_island_vacation_day_7_couch_a_tier_1",
    "item_id": "living_46_tropical_island_vacation_day_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_46_tropical_island_vacation_day_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/46_tropical_island_vacation/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_46_tropical_island_vacation_day_7_couch_a_tier_2",
    "item_id": "living_46_tropical_island_vacation_day_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_46_tropical_island_vacation_day_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/46_tropical_island_vacation/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_46_tropical_island_vacation_day_7_couch_a_tier_3",
    "item_id": "living_46_tropical_island_vacation_day_7_couch_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/46_tropical_island_vacation/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_46_tropical_island_vacation_day_8_sidetable_a_tier_1",
    "item_id": "living_46_tropical_island_vacation_day_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_46_tropical_island_vacation_day_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/46_tropical_island_vacation/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_46_tropical_island_vacation_day_8_sidetable_a_tier_2",
    "item_id": "living_46_tropical_island_vacation_day_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_46_tropical_island_vacation_day_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/46_tropical_island_vacation/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_46_tropical_island_vacation_day_8_sidetable_a_tier_3",
    "item_id": "living_46_tropical_island_vacation_day_8_sidetable_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/46_tropical_island_vacation/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_47_seashell_day_1_wallpaper_a_tier_1",
    "item_id": "living_47_seashell_day_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_47_seashell_day_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/47_seashell/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_47_seashell_day_1_wallpaper_a_tier_2",
    "item_id": "living_47_seashell_day_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_47_seashell_day_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/47_seashell/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_47_seashell_day_1_wallpaper_a_tier_3",
    "item_id": "living_47_seashell_day_1_wallpaper_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/47_seashell/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_47_seashell_day_2_floor_a_tier_1",
    "item_id": "living_47_seashell_day_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_47_seashell_day_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/47_seashell/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_47_seashell_day_2_floor_a_tier_2",
    "item_id": "living_47_seashell_day_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_47_seashell_day_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/47_seashell/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_47_seashell_day_2_floor_a_tier_3",
    "item_id": "living_47_seashell_day_2_floor_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/47_seashell/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_47_seashell_day_3_above_fireplace_a_tier_1",
    "item_id": "living_47_seashell_day_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_47_seashell_day_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/47_seashell/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_47_seashell_day_3_above_fireplace_a_tier_2",
    "item_id": "living_47_seashell_day_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_47_seashell_day_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/47_seashell/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_47_seashell_day_3_above_fireplace_a_tier_3",
    "item_id": "living_47_seashell_day_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/47_seashell/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_47_seashell_day_4_painting_a_tier_1",
    "item_id": "living_47_seashell_day_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_47_seashell_day_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/47_seashell/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_47_seashell_day_4_painting_a_tier_2",
    "item_id": "living_47_seashell_day_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_47_seashell_day_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/47_seashell/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_47_seashell_day_4_painting_a_tier_3",
    "item_id": "living_47_seashell_day_4_painting_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/47_seashell/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_47_seashell_day_5_fireplace_a_tier_1",
    "item_id": "living_47_seashell_day_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_47_seashell_day_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/47_seashell/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_47_seashell_day_5_fireplace_a_tier_2",
    "item_id": "living_47_seashell_day_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_47_seashell_day_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/47_seashell/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_47_seashell_day_5_fireplace_a_tier_3",
    "item_id": "living_47_seashell_day_5_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/47_seashell/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_47_seashell_day_6_tree_a_tier_1",
    "item_id": "living_47_seashell_day_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_47_seashell_day_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/47_seashell/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_47_seashell_day_6_tree_a_tier_2",
    "item_id": "living_47_seashell_day_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_47_seashell_day_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/47_seashell/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_47_seashell_day_6_tree_a_tier_3",
    "item_id": "living_47_seashell_day_6_tree_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/47_seashell/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_47_seashell_day_7_couch_a_tier_1",
    "item_id": "living_47_seashell_day_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_47_seashell_day_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/47_seashell/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_47_seashell_day_7_couch_a_tier_2",
    "item_id": "living_47_seashell_day_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_47_seashell_day_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/47_seashell/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_47_seashell_day_7_couch_a_tier_3",
    "item_id": "living_47_seashell_day_7_couch_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/47_seashell/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_47_seashell_day_8_sidetable_a_tier_1",
    "item_id": "living_47_seashell_day_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_47_seashell_day_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/47_seashell/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_47_seashell_day_8_sidetable_a_tier_2",
    "item_id": "living_47_seashell_day_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_47_seashell_day_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/47_seashell/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_47_seashell_day_8_sidetable_a_tier_3",
    "item_id": "living_47_seashell_day_8_sidetable_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/47_seashell/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_48_early_autumn_picnic_day_1_wallpaper_a_tier_1",
    "item_id": "living_48_early_autumn_picnic_day_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_48_early_autumn_picnic_day_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/48_early_autumn_picnic/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_48_early_autumn_picnic_day_1_wallpaper_a_tier_2",
    "item_id": "living_48_early_autumn_picnic_day_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_48_early_autumn_picnic_day_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/48_early_autumn_picnic/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_48_early_autumn_picnic_day_1_wallpaper_a_tier_3",
    "item_id": "living_48_early_autumn_picnic_day_1_wallpaper_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/48_early_autumn_picnic/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_48_early_autumn_picnic_day_2_floor_a_tier_1",
    "item_id": "living_48_early_autumn_picnic_day_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_48_early_autumn_picnic_day_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/48_early_autumn_picnic/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_48_early_autumn_picnic_day_2_floor_a_tier_2",
    "item_id": "living_48_early_autumn_picnic_day_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_48_early_autumn_picnic_day_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/48_early_autumn_picnic/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_48_early_autumn_picnic_day_2_floor_a_tier_3",
    "item_id": "living_48_early_autumn_picnic_day_2_floor_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/48_early_autumn_picnic/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_48_early_autumn_picnic_day_3_above_fireplace_a_tier_1",
    "item_id": "living_48_early_autumn_picnic_day_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_48_early_autumn_picnic_day_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/48_early_autumn_picnic/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_48_early_autumn_picnic_day_3_above_fireplace_a_tier_2",
    "item_id": "living_48_early_autumn_picnic_day_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_48_early_autumn_picnic_day_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/48_early_autumn_picnic/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_48_early_autumn_picnic_day_3_above_fireplace_a_tier_3",
    "item_id": "living_48_early_autumn_picnic_day_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/48_early_autumn_picnic/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_48_early_autumn_picnic_day_4_painting_a_tier_1",
    "item_id": "living_48_early_autumn_picnic_day_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_48_early_autumn_picnic_day_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/48_early_autumn_picnic/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_48_early_autumn_picnic_day_4_painting_a_tier_2",
    "item_id": "living_48_early_autumn_picnic_day_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_48_early_autumn_picnic_day_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/48_early_autumn_picnic/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_48_early_autumn_picnic_day_4_painting_a_tier_3",
    "item_id": "living_48_early_autumn_picnic_day_4_painting_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/48_early_autumn_picnic/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_48_early_autumn_picnic_day_5_fireplace_a_tier_1",
    "item_id": "living_48_early_autumn_picnic_day_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_48_early_autumn_picnic_day_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/48_early_autumn_picnic/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_48_early_autumn_picnic_day_5_fireplace_a_tier_2",
    "item_id": "living_48_early_autumn_picnic_day_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_48_early_autumn_picnic_day_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/48_early_autumn_picnic/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_48_early_autumn_picnic_day_5_fireplace_a_tier_3",
    "item_id": "living_48_early_autumn_picnic_day_5_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/48_early_autumn_picnic/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_48_early_autumn_picnic_day_6_tree_a_tier_1",
    "item_id": "living_48_early_autumn_picnic_day_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_48_early_autumn_picnic_day_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/48_early_autumn_picnic/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_48_early_autumn_picnic_day_6_tree_a_tier_2",
    "item_id": "living_48_early_autumn_picnic_day_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_48_early_autumn_picnic_day_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/48_early_autumn_picnic/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_48_early_autumn_picnic_day_6_tree_a_tier_3",
    "item_id": "living_48_early_autumn_picnic_day_6_tree_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/48_early_autumn_picnic/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_48_early_autumn_picnic_day_7_couch_a_tier_1",
    "item_id": "living_48_early_autumn_picnic_day_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_48_early_autumn_picnic_day_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/48_early_autumn_picnic/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_48_early_autumn_picnic_day_7_couch_a_tier_2",
    "item_id": "living_48_early_autumn_picnic_day_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_48_early_autumn_picnic_day_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/48_early_autumn_picnic/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_48_early_autumn_picnic_day_7_couch_a_tier_3",
    "item_id": "living_48_early_autumn_picnic_day_7_couch_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/48_early_autumn_picnic/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_48_early_autumn_picnic_day_8_sidetable_a_tier_1",
    "item_id": "living_48_early_autumn_picnic_day_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_48_early_autumn_picnic_day_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/48_early_autumn_picnic/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_48_early_autumn_picnic_day_8_sidetable_a_tier_2",
    "item_id": "living_48_early_autumn_picnic_day_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_48_early_autumn_picnic_day_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/48_early_autumn_picnic/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_48_early_autumn_picnic_day_8_sidetable_a_tier_3",
    "item_id": "living_48_early_autumn_picnic_day_8_sidetable_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/48_early_autumn_picnic/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_49_pumpkin_farm_day_1_wallpaper_a_tier_1",
    "item_id": "living_49_pumpkin_farm_day_1_wallpaper_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_49_pumpkin_farm_day_1_wallpaper_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/49_pumpkin_farm/01_color_A/01_tier_1/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_49_pumpkin_farm_day_1_wallpaper_a_tier_2",
    "item_id": "living_49_pumpkin_farm_day_1_wallpaper_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_49_pumpkin_farm_day_1_wallpaper_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/49_pumpkin_farm/01_color_A/02_tier_2/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_49_pumpkin_farm_day_1_wallpaper_a_tier_3",
    "item_id": "living_49_pumpkin_farm_day_1_wallpaper_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/49_pumpkin_farm/01_color_A/03_tier_3/01_wallpaper.png",
    "animated": false
  },
  {
    "id": "living_49_pumpkin_farm_day_2_floor_a_tier_1",
    "item_id": "living_49_pumpkin_farm_day_2_floor_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_49_pumpkin_farm_day_2_floor_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/49_pumpkin_farm/01_color_A/01_tier_1/02_floor.png",
    "animated": false
  },
  {
    "id": "living_49_pumpkin_farm_day_2_floor_a_tier_2",
    "item_id": "living_49_pumpkin_farm_day_2_floor_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_49_pumpkin_farm_day_2_floor_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/49_pumpkin_farm/01_color_A/02_tier_2/02_floor.png",
    "animated": false
  },
  {
    "id": "living_49_pumpkin_farm_day_2_floor_a_tier_3",
    "item_id": "living_49_pumpkin_farm_day_2_floor_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/49_pumpkin_farm/01_color_A/03_tier_3/02_floor.png",
    "animated": false
  },
  {
    "id": "living_49_pumpkin_farm_day_3_above_fireplace_a_tier_1",
    "item_id": "living_49_pumpkin_farm_day_3_above_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_49_pumpkin_farm_day_3_above_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/49_pumpkin_farm/01_color_A/01_tier_1/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_49_pumpkin_farm_day_3_above_fireplace_a_tier_2",
    "item_id": "living_49_pumpkin_farm_day_3_above_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_49_pumpkin_farm_day_3_above_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/49_pumpkin_farm/01_color_A/02_tier_2/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_49_pumpkin_farm_day_3_above_fireplace_a_tier_3",
    "item_id": "living_49_pumpkin_farm_day_3_above_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/49_pumpkin_farm/01_color_A/03_tier_3/03_above_fireplace.png",
    "animated": false
  },
  {
    "id": "living_49_pumpkin_farm_day_4_painting_a_tier_1",
    "item_id": "living_49_pumpkin_farm_day_4_painting_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_49_pumpkin_farm_day_4_painting_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/49_pumpkin_farm/01_color_A/01_tier_1/04_painting.png",
    "animated": false
  },
  {
    "id": "living_49_pumpkin_farm_day_4_painting_a_tier_2",
    "item_id": "living_49_pumpkin_farm_day_4_painting_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_49_pumpkin_farm_day_4_painting_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/49_pumpkin_farm/01_color_A/02_tier_2/04_painting.png",
    "animated": false
  },
  {
    "id": "living_49_pumpkin_farm_day_4_painting_a_tier_3",
    "item_id": "living_49_pumpkin_farm_day_4_painting_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/49_pumpkin_farm/01_color_A/03_tier_3/04_painting.png",
    "animated": false
  },
  {
    "id": "living_49_pumpkin_farm_day_5_fireplace_a_tier_1",
    "item_id": "living_49_pumpkin_farm_day_5_fireplace_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_49_pumpkin_farm_day_5_fireplace_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/49_pumpkin_farm/01_color_A/01_tier_1/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_49_pumpkin_farm_day_5_fireplace_a_tier_2",
    "item_id": "living_49_pumpkin_farm_day_5_fireplace_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_49_pumpkin_farm_day_5_fireplace_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/49_pumpkin_farm/01_color_A/02_tier_2/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_49_pumpkin_farm_day_5_fireplace_a_tier_3",
    "item_id": "living_49_pumpkin_farm_day_5_fireplace_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/49_pumpkin_farm/01_color_A/03_tier_3/05_fireplace.png",
    "animated": false
  },
  {
    "id": "living_49_pumpkin_farm_day_6_tree_a_tier_1",
    "item_id": "living_49_pumpkin_farm_day_6_tree_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_49_pumpkin_farm_day_6_tree_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/49_pumpkin_farm/01_color_A/01_tier_1/06_tree.png",
    "animated": false
  },
  {
    "id": "living_49_pumpkin_farm_day_6_tree_a_tier_2",
    "item_id": "living_49_pumpkin_farm_day_6_tree_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_49_pumpkin_farm_day_6_tree_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/49_pumpkin_farm/01_color_A/02_tier_2/06_tree.png",
    "animated": false
  },
  {
    "id": "living_49_pumpkin_farm_day_6_tree_a_tier_3",
    "item_id": "living_49_pumpkin_farm_day_6_tree_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/49_pumpkin_farm/01_color_A/03_tier_3/06_tree.png",
    "animated": false
  },
  {
    "id": "living_49_pumpkin_farm_day_7_couch_a_tier_1",
    "item_id": "living_49_pumpkin_farm_day_7_couch_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_49_pumpkin_farm_day_7_couch_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/49_pumpkin_farm/01_color_A/01_tier_1/07_couch.png",
    "animated": false
  },
  {
    "id": "living_49_pumpkin_farm_day_7_couch_a_tier_2",
    "item_id": "living_49_pumpkin_farm_day_7_couch_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_49_pumpkin_farm_day_7_couch_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/49_pumpkin_farm/01_color_A/02_tier_2/07_couch.png",
    "animated": false
  },
  {
    "id": "living_49_pumpkin_farm_day_7_couch_a_tier_3",
    "item_id": "living_49_pumpkin_farm_day_7_couch_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/49_pumpkin_farm/01_color_A/03_tier_3/07_couch.png",
    "animated": false
  },
  {
    "id": "living_49_pumpkin_farm_day_8_sidetable_a_tier_1",
    "item_id": "living_49_pumpkin_farm_day_8_sidetable_a",
    "tier": 1,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_49_pumpkin_farm_day_8_sidetable_a_tier_2",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 100,
    "image": "01_living_room/49_pumpkin_farm/01_color_A/01_tier_1/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_49_pumpkin_farm_day_8_sidetable_a_tier_2",
    "item_id": "living_49_pumpkin_farm_day_8_sidetable_a",
    "tier": 2,
    "can_fuse": true,
    "fuse_currency": "b_points",
    "fuse_price": 1500,
    "fuse_items_required": 3,
    "fuse_next_tier": "living_49_pumpkin_farm_day_8_sidetable_a_tier_3",
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 300,
    "image": "01_living_room/49_pumpkin_farm/01_color_A/02_tier_2/08_sidetable.png",
    "animated": false
  },
  {
    "id": "living_49_pumpkin_farm_day_8_sidetable_a_tier_3",
    "item_id": "living_49_pumpkin_farm_day_8_sidetable_a",
    "tier": 3,
    "can_fuse": false,
    "can_sell": true,
    "sell_currency": "b_points",
    "sell_price": 900,
    "image": "01_living_room/49_pumpkin_farm/01_color_A/03_tier_3/08_sidetable.png",
    "animated": false
  }
]
